// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import type {
  GetV1CommunicationEmailTemplateData,
  GetV1CommunicationEmailTemplateResponse,
  PostV1CommunicationEmailTemplateData,
  PostV1CommunicationEmailTemplateResponse,
  GetV1CommunicationEmailTemplateByEmailTemplateIdData,
  GetV1CommunicationEmailTemplateByEmailTemplateIdResponse,
  PutV1CommunicationEmailTemplateByEmailTemplateIdData,
  PutV1CommunicationEmailTemplateByEmailTemplateIdResponse,
  PatchV1CommunicationEmailTemplateByEmailTemplateIdData,
  PatchV1CommunicationEmailTemplateByEmailTemplateIdResponse,
  DeleteV1CommunicationEmailTemplateByEmailTemplateIdData,
  DeleteV1CommunicationEmailTemplateByEmailTemplateIdResponse,
  PostV1CommunicationMfaCodeByCodeIdResendData,
  PostV1CommunicationMfaCodeByCodeIdResendResponse,
  PostV1CommunicationMfaCodeByCodeIdVerifyData,
  PostV1CommunicationMfaCodeByCodeIdVerifyResponse,
  PostV1CommunicationMfaCodeByUserIdCreateData,
  PostV1CommunicationMfaCodeByUserIdCreateResponse,
  GetV1CommunicationTextTemplateData,
  GetV1CommunicationTextTemplateResponse,
  PostV1CommunicationTextTemplateData,
  PostV1CommunicationTextTemplateResponse,
  GetV1CommunicationTextTemplateByTextTemplateIdData,
  GetV1CommunicationTextTemplateByTextTemplateIdResponse,
  PutV1CommunicationTextTemplateByTextTemplateIdData,
  PutV1CommunicationTextTemplateByTextTemplateIdResponse,
  PatchV1CommunicationTextTemplateByTextTemplateIdData,
  PatchV1CommunicationTextTemplateByTextTemplateIdResponse,
  DeleteV1CommunicationTextTemplateByTextTemplateIdData,
  DeleteV1CommunicationTextTemplateByTextTemplateIdResponse,
  GetV1SearchUserData,
  GetV1SearchUserResponse,
  GetV1SearchUserInternalData,
  GetV1SearchUserInternalResponse,
  PostV1UserManagementAccountOpsAccountMergeData,
  PostV1UserManagementAccountOpsAccountMergeResponse,
  PostV1UserManagementAccountOpsDataRetentionClearData,
  PostV1UserManagementAccountOpsDataRetentionClearResponse,
  PostV1UserManagementAccountOpsDataRetentionUpdateData,
  PostV1UserManagementAccountOpsDataRetentionUpdateResponse,
  PostV1UserManagementAccountOpsMarketingStatusUpdateData,
  PostV1UserManagementAccountOpsMarketingStatusUpdateResponse,
  PostV1UserManagementApiLoginData,
  PostV1UserManagementApiLoginResponse,
  GetV1UserManagementExternalServiceUsersData,
  GetV1UserManagementExternalServiceUsersResponse,
  PostV1UserManagementExternalServiceUsersData,
  PostV1UserManagementExternalServiceUsersResponse,
  GetV1UserManagementExternalServiceUsersByUserIdData,
  GetV1UserManagementExternalServiceUsersByUserIdResponse,
  PatchV1UserManagementExternalServiceUsersByUserIdData,
  PatchV1UserManagementExternalServiceUsersByUserIdResponse,
  DeleteV1UserManagementExternalServiceUsersByUserIdData,
  DeleteV1UserManagementExternalServiceUsersByUserIdResponse,
  DeleteV1UserManagementExternalServiceUsersByUserIdHardDeleteData,
  DeleteV1UserManagementExternalServiceUsersByUserIdHardDeleteResponse,
  PostV1UserManagementGuestWorkspaceByWorkspaceIdLoginData,
  PostV1UserManagementGuestWorkspaceByWorkspaceIdLoginResponse,
  PostV1UserManagementGuestWorkspaceByWorkspaceIdMfaLoginCompleteData,
  PostV1UserManagementGuestWorkspaceByWorkspaceIdMfaLoginCompleteResponse,
  PostV1UserManagementLoginData,
  PostV1UserManagementLoginResponse,
  PostV1UserManagementLogoutResponse,
  PostV1UserManagementMfaLoginCompleteData,
  PostV1UserManagementMfaLoginCompleteResponse,
  PostV1UserManagementMfaLoginSendCodeData,
  PostV1UserManagementMfaLoginSendCodeResponse,
  PostV1UserManagementMfaLoginStartData,
  PostV1UserManagementMfaLoginStartResponse,
  PostV1UserManagementMfaLoginByCodeIdResendData,
  PostV1UserManagementMfaLoginByCodeIdResendResponse,
  GetV1UserManagementPoliciesData,
  GetV1UserManagementPoliciesResponse,
  PostV1UserManagementPoliciesAgreementData,
  PostV1UserManagementPoliciesAgreementResponse,
  GetV1UserManagementPoliciesCurrentData,
  GetV1UserManagementPoliciesCurrentResponse,
  PostV1UserManagementPoliciesUploadData,
  PostV1UserManagementPoliciesUploadResponse,
  GetV1UserManagementPoliciesByPolicyNameAccessData,
  GetV1UserManagementPoliciesByPolicyNameAccessResponse,
  GetV1UserManagementPoliciesByVersionIdData,
  GetV1UserManagementPoliciesByVersionIdResponse,
  GetV1UserManagementServiceUsersData,
  GetV1UserManagementServiceUsersResponse,
  PostV1UserManagementServiceUsersData,
  PostV1UserManagementServiceUsersResponse,
  PostV1UserManagementServiceUsersRegistrationData,
  PostV1UserManagementServiceUsersRegistrationResponse,
  PostV1UserManagementTokenOrganizationByOrganizationIdRefreshData,
  PostV1UserManagementTokenOrganizationByOrganizationIdRefreshResponse,
  PostV1UserManagementTokenRefreshResponse,
  PostV1UserManagementUserWorkspacePublicProfilesData,
  PostV1UserManagementUserWorkspacePublicProfilesResponse,
  PostV1UserManagementUserWorkspaceUserPiiDataEntryBulkData,
  PostV1UserManagementUserWorkspaceUserPiiDataEntryBulkResponse,
  GetV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryData,
  GetV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryResponse,
  PostV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryData,
  PostV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryResponse,
  DeleteV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryData,
  DeleteV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryResponse,
  PostV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryUploadData,
  PostV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryUploadResponse,
  GetV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryIdData,
  GetV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryIdResponse,
  PatchV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryIdData,
  PatchV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryIdResponse,
  DeleteV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryIdData,
  DeleteV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryIdResponse,
  GetV1UserManagementUsersData,
  GetV1UserManagementUsersResponse,
  PostV1UserManagementUsersEmailVerificationConfirmData,
  PostV1UserManagementUsersEmailVerificationConfirmResponse,
  PostV1UserManagementUsersEmailVerificationRequestData,
  PostV1UserManagementUsersEmailVerificationRequestResponse,
  PostV1UserManagementUsersGuestUserRegistrationData,
  PostV1UserManagementUsersGuestUserRegistrationResponse,
  PostV1UserManagementUsersGuestUserRegistrationCompleteData,
  PostV1UserManagementUsersGuestUserRegistrationCompleteResponse,
  PostV1UserManagementUsersPasswordConfirmData,
  PostV1UserManagementUsersPasswordConfirmResponse,
  PostV1UserManagementUsersPasswordResetData,
  PostV1UserManagementUsersPasswordResetResponse,
  PostV1UserManagementUsersPublicProfilesData,
  PostV1UserManagementUsersPublicProfilesResponse,
  PostV1UserManagementUsersRegistrationData,
  PostV1UserManagementUsersRegistrationResponse,
  PostV1UserManagementUsersRegistrationUsernameAvailableData,
  PostV1UserManagementUsersRegistrationUsernameAvailableResponse,
  PostV1UserManagementUsersByCodeIdVerifyPhoneResendData,
  PostV1UserManagementUsersByCodeIdVerifyPhoneResendResponse,
  PostV1UserManagementUsersByCodeIdVerifyPhoneVerifyData,
  PostV1UserManagementUsersByCodeIdVerifyPhoneVerifyResponse,
  GetV1UserManagementUsersByUserIdData,
  GetV1UserManagementUsersByUserIdResponse,
  PatchV1UserManagementUsersByUserIdData,
  PatchV1UserManagementUsersByUserIdResponse,
  DeleteV1UserManagementUsersByUserIdData,
  DeleteV1UserManagementUsersByUserIdResponse,
  PostV1UserManagementUsersByUserIdEmailData,
  PostV1UserManagementUsersByUserIdEmailResponse,
  PostV1UserManagementUsersByUserIdGuestEmailData,
  PostV1UserManagementUsersByUserIdGuestEmailResponse,
  DeleteV1UserManagementUsersByUserIdHardDeleteData,
  DeleteV1UserManagementUsersByUserIdHardDeleteResponse,
  PostV1UserManagementUsersByUserIdPasswordData,
  PostV1UserManagementUsersByUserIdPasswordResponse,
  GetV1UserManagementUsersByUserIdUserPiiDataEntryData,
  GetV1UserManagementUsersByUserIdUserPiiDataEntryResponse,
  PostV1UserManagementUsersByUserIdUserPiiDataEntryData,
  PostV1UserManagementUsersByUserIdUserPiiDataEntryResponse,
  DeleteV1UserManagementUsersByUserIdUserPiiDataEntryData,
  DeleteV1UserManagementUsersByUserIdUserPiiDataEntryResponse,
  PostV1UserManagementUsersByUserIdUserPiiDataEntryUploadData,
  PostV1UserManagementUsersByUserIdUserPiiDataEntryUploadResponse,
  GetV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryIdData,
  GetV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryIdResponse,
  PatchV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryIdData,
  PatchV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryIdResponse,
  DeleteV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryIdData,
  DeleteV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryIdResponse,
  PostV1UserManagementUsersByUserIdVerifyPhoneStartData,
  PostV1UserManagementUsersByUserIdVerifyPhoneStartResponse,
  PostV1OrganizationManagementAccountOpsDataRetentionClearData,
  PostV1OrganizationManagementAccountOpsDataRetentionClearResponse,
  PostV1OrganizationManagementAccountOpsMemberWorkspaceBulkData,
  PostV1OrganizationManagementAccountOpsMemberWorkspaceBulkResponse,
  PostV1OrganizationManagementGuestFamilyRegistrationCreateData,
  PostV1OrganizationManagementGuestFamilyRegistrationCreateResponse,
  PostV1OrganizationManagementGuestFamilyRegistrationByOrganizationIdCompleteData,
  PostV1OrganizationManagementGuestFamilyRegistrationByOrganizationIdCompleteResponse,
  PostV1OrganizationManagementInviteAcceptData,
  PostV1OrganizationManagementInviteAcceptResponse,
  GetV1OrganizationManagementInviteByInviteIdData,
  GetV1OrganizationManagementInviteByInviteIdResponse,
  PostV1OrganizationManagementMemberWorkspaceBulkData,
  PostV1OrganizationManagementMemberWorkspaceBulkResponse,
  GetV1OrganizationManagementMemberByUserIdData,
  GetV1OrganizationManagementMemberByUserIdResponse,
  GetV1OrganizationManagementOrganizationData,
  GetV1OrganizationManagementOrganizationResponse,
  PostV1OrganizationManagementOrganizationData,
  PostV1OrganizationManagementOrganizationResponse,
  GetV1OrganizationManagementOrganizationMemberByOrganizationMemberIdData,
  GetV1OrganizationManagementOrganizationMemberByOrganizationMemberIdResponse,
  DeleteV1OrganizationManagementOrganizationMemberByOrganizationMemberIdData,
  DeleteV1OrganizationManagementOrganizationMemberByOrganizationMemberIdResponse,
  PostV1OrganizationManagementOrganizationWorkspaceOrganizationPiiDataEntryBulkData,
  PostV1OrganizationManagementOrganizationWorkspaceOrganizationPiiDataEntryBulkResponse,
  PostV1OrganizationManagementOrganizationWorkspaceProfilesData,
  PostV1OrganizationManagementOrganizationWorkspaceProfilesResponse,
  GetV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryData,
  GetV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryResponse,
  PostV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryData,
  PostV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryResponse,
  DeleteV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryData,
  DeleteV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryResponse,
  PostV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryUploadData,
  PostV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryUploadResponse,
  GetV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdData,
  GetV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdResponse,
  PatchV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdData,
  PatchV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdResponse,
  DeleteV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdData,
  DeleteV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdResponse,
  PostV1OrganizationManagementOrganizationProfilesData,
  PostV1OrganizationManagementOrganizationProfilesResponse,
  GetV1OrganizationManagementOrganizationByOrganizationIdData,
  GetV1OrganizationManagementOrganizationByOrganizationIdResponse,
  PatchV1OrganizationManagementOrganizationByOrganizationIdData,
  PatchV1OrganizationManagementOrganizationByOrganizationIdResponse,
  DeleteV1OrganizationManagementOrganizationByOrganizationIdData,
  DeleteV1OrganizationManagementOrganizationByOrganizationIdResponse,
  DeleteV1OrganizationManagementOrganizationByOrganizationIdHardDeleteData,
  DeleteV1OrganizationManagementOrganizationByOrganizationIdHardDeleteResponse,
  GetV1OrganizationManagementOrganizationByOrganizationIdInviteData,
  GetV1OrganizationManagementOrganizationByOrganizationIdInviteResponse,
  PostV1OrganizationManagementOrganizationByOrganizationIdInviteData,
  PostV1OrganizationManagementOrganizationByOrganizationIdInviteResponse,
  GetV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdData,
  GetV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdResponse,
  DeleteV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdData,
  DeleteV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdResponse,
  DeleteV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdHardDeleteData,
  DeleteV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdHardDeleteResponse,
  PostV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdResendData,
  PostV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdResendResponse,
  GetV1OrganizationManagementOrganizationByOrganizationIdMemberData,
  GetV1OrganizationManagementOrganizationByOrganizationIdMemberResponse,
  PostV1OrganizationManagementOrganizationByOrganizationIdMemberChildData,
  PostV1OrganizationManagementOrganizationByOrganizationIdMemberChildResponse,
  GetV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdData,
  GetV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdResponse,
  PatchV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdData,
  PatchV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdResponse,
  DeleteV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdData,
  DeleteV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdResponse,
  GetV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdRoleData,
  GetV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdRoleResponse,
  GetV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryData,
  GetV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryResponse,
  PostV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryData,
  PostV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryResponse,
  DeleteV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryData,
  DeleteV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryResponse,
  PostV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryUploadData,
  PostV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryUploadResponse,
  GetV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdData,
  GetV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdResponse,
  PatchV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdData,
  PatchV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdResponse,
  DeleteV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdData,
  DeleteV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdResponse,
  PutV1OrganizationManagementOrganizationByOrganizationIdOwnerData,
  PutV1OrganizationManagementOrganizationByOrganizationIdOwnerResponse,
  PutV1OrganizationManagementOrganizationByOrganizationIdTagsData,
  PutV1OrganizationManagementOrganizationByOrganizationIdTagsResponse,
  GetV1OrganizationManagementUserByUserIdInviteData,
  GetV1OrganizationManagementUserByUserIdInviteResponse,
  GetV1SearchInternalOrganizationData,
  GetV1SearchInternalOrganizationResponse,
  GetV1SearchOrganizationData,
  GetV1SearchOrganizationResponse,
  GetV1ApiUserApiUserByUserIdByUserIdData,
  GetV1ApiUserApiUserByUserIdByUserIdResponse,
  DeleteV1ApiUserApiUserByUserIdByUserIdData,
  DeleteV1ApiUserApiUserByUserIdByUserIdResponse,
  DeleteV1ApiUserApiUserByUserIdByUserIdHardDeleteData,
  DeleteV1ApiUserApiUserByUserIdByUserIdHardDeleteResponse,
  GetV1ApiUserOrganizationByOrganizationIdData,
  GetV1ApiUserOrganizationByOrganizationIdResponse,
  PostV1ApiUserOrganizationByOrganizationIdData,
  PostV1ApiUserOrganizationByOrganizationIdResponse,
  GetV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdData,
  GetV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdResponse,
  DeleteV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdData,
  DeleteV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdResponse,
  DeleteV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdHardDeleteData,
  DeleteV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdHardDeleteResponse,
  GetV1CardJamCardData,
  GetV1CardJamCardResponse,
  GetV1CardJamCardPackData,
  GetV1CardJamCardPackResponse,
  PostV1CardJamCardPackData,
  PostV1CardJamCardPackResponse,
  GetV1CardJamCardPackByCardPackIdData,
  GetV1CardJamCardPackByCardPackIdResponse,
  DeleteV1CardJamCardPackByCardPackIdData,
  DeleteV1CardJamCardPackByCardPackIdResponse,
  DeleteV1CardJamCardPackByCardPackIdHardDeleteData,
  DeleteV1CardJamCardPackByCardPackIdHardDeleteResponse,
  GetV1CardJamCardSetData,
  GetV1CardJamCardSetResponse,
  PostV1CardJamCardSetData,
  PostV1CardJamCardSetResponse,
  GetV1CardJamCardSetPackData,
  GetV1CardJamCardSetPackResponse,
  PostV1CardJamCardSetPackData,
  PostV1CardJamCardSetPackResponse,
  GetV1CardJamCardSetPackCardSetByCardSetIdCardSetPackTypeByCardSetPackTypeData,
  GetV1CardJamCardSetPackCardSetByCardSetIdCardSetPackTypeByCardSetPackTypeResponse,
  GetV1CardJamCardSetPackByCardSetPackIdData,
  GetV1CardJamCardSetPackByCardSetPackIdResponse,
  DeleteV1CardJamCardSetPackByCardSetPackIdData,
  DeleteV1CardJamCardSetPackByCardSetPackIdResponse,
  DeleteV1CardJamCardSetPackByCardSetPackIdHardDeleteData,
  DeleteV1CardJamCardSetPackByCardSetPackIdHardDeleteResponse,
  GetV1CardJamCardSetByCardSetIdData,
  GetV1CardJamCardSetByCardSetIdResponse,
  DeleteV1CardJamCardSetByCardSetIdData,
  DeleteV1CardJamCardSetByCardSetIdResponse,
  DeleteV1CardJamCardSetByCardSetIdHardDeleteData,
  DeleteV1CardJamCardSetByCardSetIdHardDeleteResponse,
  PostV1CardJamCardSetByCardSetIdValidateData,
  PostV1CardJamCardSetByCardSetIdValidateResponse,
  GetV1CardJamCardVariantAttributeData,
  GetV1CardJamCardVariantAttributeResponse,
  PostV1CardJamCardVariantAttributeData,
  PostV1CardJamCardVariantAttributeResponse,
  PostV1CardJamCardVariantAttributeRawData,
  PostV1CardJamCardVariantAttributeRawResponse,
  GetV1CardJamCardVariantAttributeByCardVariantAttributeData,
  GetV1CardJamCardVariantAttributeByCardVariantAttributeResponse,
  PostV1CardJamCardVariantAttributeByCardVariantAttributeData,
  PostV1CardJamCardVariantAttributeByCardVariantAttributeResponse,
  DeleteV1CardJamCardVariantAttributeByCardVariantAttributeHardDeleteData,
  DeleteV1CardJamCardVariantAttributeByCardVariantAttributeHardDeleteResponse,
  PostV1CardJamLocalAdminCardDownloadsData,
  PostV1CardJamLocalAdminCardDownloadsResponse,
  PostV1CardJamLocalAdminCardUploadData,
  PostV1CardJamLocalAdminCardUploadResponse,
  GetV1CardJamMarketingCampaignData,
  GetV1CardJamMarketingCampaignResponse,
  PostV1CardJamMarketingCampaignData,
  PostV1CardJamMarketingCampaignResponse,
  GetV1CardJamMarketingCampaignByMarketingCampaignIdData,
  GetV1CardJamMarketingCampaignByMarketingCampaignIdResponse,
  PostV1CardJamMarketingCampaignByMarketingCampaignIdActivateData,
  PostV1CardJamMarketingCampaignByMarketingCampaignIdActivateResponse,
  PostV1CardJamMarketingCampaignByMarketingCampaignIdCardPackData,
  PostV1CardJamMarketingCampaignByMarketingCampaignIdCardPackResponse,
  DeleteV1CardJamMarketingCampaignByMarketingCampaignIdCardPackByMarketingCampaignCardPackIdData,
  DeleteV1CardJamMarketingCampaignByMarketingCampaignIdCardPackByMarketingCampaignCardPackIdResponse,
  PostV1CardJamMarketingCampaignByMarketingCampaignIdDeactivateData,
  PostV1CardJamMarketingCampaignByMarketingCampaignIdDeactivateResponse,
  DeleteV1CardJamMarketingCampaignByMarketingCampaignIdHardDeleteData,
  DeleteV1CardJamMarketingCampaignByMarketingCampaignIdHardDeleteResponse,
  GetV1CardJamWorkspaceByWorkspaceIdCardData,
  GetV1CardJamWorkspaceByWorkspaceIdCardResponse,
  PostV1CardJamWorkspaceByWorkspaceIdCardData,
  PostV1CardJamWorkspaceByWorkspaceIdCardResponse,
  GetV1CardJamWorkspaceByWorkspaceIdCardAttributeData,
  GetV1CardJamWorkspaceByWorkspaceIdCardAttributeResponse,
  PostV1CardJamWorkspaceByWorkspaceIdCardAttributeData,
  PostV1CardJamWorkspaceByWorkspaceIdCardAttributeResponse,
  PostV1CardJamWorkspaceByWorkspaceIdCardAttributeDecreaseData,
  PostV1CardJamWorkspaceByWorkspaceIdCardAttributeDecreaseResponse,
  PostV1CardJamWorkspaceByWorkspaceIdCardAttributeIncreaseData,
  PostV1CardJamWorkspaceByWorkspaceIdCardAttributeIncreaseResponse,
  GetV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeIdData,
  GetV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeIdResponse,
  DeleteV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeIdHardDeleteData,
  DeleteV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeIdHardDeleteResponse,
  GetV1CardJamWorkspaceByWorkspaceIdCardDesignData,
  GetV1CardJamWorkspaceByWorkspaceIdCardDesignResponse,
  PostV1CardJamWorkspaceByWorkspaceIdCardDesignData,
  PostV1CardJamWorkspaceByWorkspaceIdCardDesignResponse,
  PostV1CardJamWorkspaceByWorkspaceIdCardDesignDecreaseData,
  PostV1CardJamWorkspaceByWorkspaceIdCardDesignDecreaseResponse,
  PostV1CardJamWorkspaceByWorkspaceIdCardDesignIncreaseData,
  PostV1CardJamWorkspaceByWorkspaceIdCardDesignIncreaseResponse,
  GetV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignIdData,
  GetV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignIdResponse,
  DeleteV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignIdHardDeleteData,
  DeleteV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignIdHardDeleteResponse,
  PostV1CardJamWorkspaceByWorkspaceIdCardFullData,
  PostV1CardJamWorkspaceByWorkspaceIdCardFullResponse,
  PostV1CardJamWorkspaceByWorkspaceIdCardInternalData,
  PostV1CardJamWorkspaceByWorkspaceIdCardInternalResponse,
  GetV1CardJamWorkspaceByWorkspaceIdCardSetData,
  GetV1CardJamWorkspaceByWorkspaceIdCardSetResponse,
  GetV1CardJamWorkspaceByWorkspaceIdCardSetByCardSetIdData,
  GetV1CardJamWorkspaceByWorkspaceIdCardSetByCardSetIdResponse,
  GetV1CardJamWorkspaceByWorkspaceIdCardByCardIdData,
  GetV1CardJamWorkspaceByWorkspaceIdCardByCardIdResponse,
  DeleteV1CardJamWorkspaceByWorkspaceIdCardByCardIdData,
  DeleteV1CardJamWorkspaceByWorkspaceIdCardByCardIdResponse,
  PostV1CardJamWorkspaceByWorkspaceIdCardByCardIdFinalizeData,
  PostV1CardJamWorkspaceByWorkspaceIdCardByCardIdFinalizeResponse,
  PostV1CardJamWorkspaceByWorkspaceIdCardByCardIdUpdateData,
  PostV1CardJamWorkspaceByWorkspaceIdCardByCardIdUpdateResponse,
  PostV1CardJamWorkspaceByWorkspaceIdCardByCardIdVariantData,
  PostV1CardJamWorkspaceByWorkspaceIdCardByCardIdVariantResponse,
  PostV1CardJamWorkspaceByWorkspaceIdMarketingCampaignClaimData,
  PostV1CardJamWorkspaceByWorkspaceIdMarketingCampaignClaimResponse,
  GetV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackData,
  GetV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackResponse,
  PostV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackData,
  PostV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackResponse,
  PostV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackDecreaseData,
  PostV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackDecreaseResponse,
  PostV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackIncreaseData,
  PostV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackIncreaseResponse,
  GetV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdData,
  GetV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdResponse,
  DeleteV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdHardDeleteData,
  DeleteV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdHardDeleteResponse,
  PostV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdOpenData,
  PostV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdOpenResponse,
  PostV1OrderManagementAbandonedCartReminderData,
  PostV1OrderManagementAbandonedCartReminderResponse,
  PostV1OrderManagementAccountOpsMarketingStatusUpdateData,
  PostV1OrderManagementAccountOpsMarketingStatusUpdateResponse,
  GetV1OrderManagementDiscountCouponData,
  GetV1OrderManagementDiscountCouponResponse,
  PostV1OrderManagementDiscountCouponData,
  PostV1OrderManagementDiscountCouponResponse,
  GetV1OrderManagementDiscountCouponByDiscountCouponIdData,
  GetV1OrderManagementDiscountCouponByDiscountCouponIdResponse,
  DeleteV1OrderManagementDiscountCouponByDiscountCouponIdHardDeleteData,
  DeleteV1OrderManagementDiscountCouponByDiscountCouponIdHardDeleteResponse,
  GetV1OrderManagementFreeCardCouponData,
  GetV1OrderManagementFreeCardCouponResponse,
  PostV1OrderManagementFreeCardCouponData,
  PostV1OrderManagementFreeCardCouponResponse,
  GetV1OrderManagementFreeCardCouponByFreeCardCouponIdData,
  GetV1OrderManagementFreeCardCouponByFreeCardCouponIdResponse,
  DeleteV1OrderManagementFreeCardCouponByFreeCardCouponIdHardDeleteData,
  DeleteV1OrderManagementFreeCardCouponByFreeCardCouponIdHardDeleteResponse,
  GetV1OrderManagementOrderData,
  GetV1OrderManagementOrderResponse,
  PostV1OrderManagementOrderPrintingStartedBulkData,
  PostV1OrderManagementOrderPrintingStartedBulkResponse,
  PostV1OrderManagementOrderShippedBulkData,
  PostV1OrderManagementOrderShippedBulkResponse,
  GetV1OrderManagementOrderByOrderIdData,
  GetV1OrderManagementOrderByOrderIdResponse,
  PostV1OrderManagementOrderByOrderIdPrintingStartedData,
  PostV1OrderManagementOrderByOrderIdPrintingStartedResponse,
  PostV1OrderManagementOrderByOrderIdShippedData,
  PostV1OrderManagementOrderByOrderIdShippedResponse,
  GetV1OrderManagementProductPriceData,
  GetV1OrderManagementProductPriceResponse,
  PostV1OrderManagementProductPriceData,
  PostV1OrderManagementProductPriceResponse,
  GetV1OrderManagementProductPriceProductTypeByProductTypeData,
  GetV1OrderManagementProductPriceProductTypeByProductTypeResponse,
  GetV1OrderManagementProductPriceByProductPriceIdData,
  GetV1OrderManagementProductPriceByProductPriceIdResponse,
  PatchV1OrderManagementProductPriceByProductPriceIdData,
  PatchV1OrderManagementProductPriceByProductPriceIdResponse,
  DeleteV1OrderManagementProductPriceByProductPriceIdData,
  DeleteV1OrderManagementProductPriceByProductPriceIdResponse,
  DeleteV1OrderManagementProductPriceByProductPriceIdHardDeleteData,
  DeleteV1OrderManagementProductPriceByProductPriceIdHardDeleteResponse,
  PostV1OrderManagementServiceAccountOpsAccountMergeData,
  PostV1OrderManagementServiceAccountOpsAccountMergeResponse,
  PostV1OrderManagementServiceAccountOpsDataRetentionClearData,
  PostV1OrderManagementServiceAccountOpsDataRetentionClearResponse,
  GetV1OrderManagementServiceOrderData,
  GetV1OrderManagementServiceOrderResponse,
  PostV1OrderManagementServiceWorkspaceOrderStatisticsData,
  PostV1OrderManagementServiceWorkspaceOrderStatisticsResponse,
  PostV1OrderManagementServiceWorkspaceByWorkspaceIdCheckoutByOrderIdTimeoutData,
  PostV1OrderManagementServiceWorkspaceByWorkspaceIdCheckoutByOrderIdTimeoutResponse,
  PostV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmationData,
  PostV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmationResponse,
  PostV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmationData,
  PostV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmationResponse,
  PostV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcessData,
  PostV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcessResponse,
  PostV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShippedData,
  PostV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShippedResponse,
  PostV1OrderManagementStripeRetryData,
  PostV1OrderManagementStripeRetryResponse,
  PostV1OrderManagementStripeWebhookResponse,
  GetV1OrderManagementWorkspaceByWorkspaceIdCartData,
  GetV1OrderManagementWorkspaceByWorkspaceIdCartResponse,
  GetV1OrderManagementWorkspaceByWorkspaceIdCartCartItemData,
  GetV1OrderManagementWorkspaceByWorkspaceIdCartCartItemResponse,
  PostV1OrderManagementWorkspaceByWorkspaceIdCartCartItemCardData,
  PostV1OrderManagementWorkspaceByWorkspaceIdCartCartItemCardResponse,
  PostV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamCardData,
  PostV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamCardResponse,
  PostV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamPackData,
  PostV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamPackResponse,
  GetV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdData,
  GetV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdResponse,
  PatchV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdData,
  PatchV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdResponse,
  DeleteV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdHardDeleteData,
  DeleteV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdHardDeleteResponse,
  PostV1OrderManagementWorkspaceByWorkspaceIdCheckoutStartData,
  PostV1OrderManagementWorkspaceByWorkspaceIdCheckoutStartResponse,
  GetV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdData,
  GetV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdResponse,
  PostV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCancelData,
  PostV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCancelResponse,
  PostV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCheckoutCompleteData,
  PostV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCheckoutCompleteResponse,
  GetV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountData,
  GetV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountResponse,
  PostV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountDecreaseData,
  PostV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountDecreaseResponse,
  DeleteV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountHardDeleteData,
  DeleteV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountHardDeleteResponse,
  PostV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountIncreaseData,
  PostV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountIncreaseResponse,
  PostV1OrderManagementWorkspaceByWorkspaceIdFreeCardCouponClaimData,
  PostV1OrderManagementWorkspaceByWorkspaceIdFreeCardCouponClaimResponse,
  GetV1OrderManagementWorkspaceByWorkspaceIdOrderData,
  GetV1OrderManagementWorkspaceByWorkspaceIdOrderResponse,
  GetV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdData,
  GetV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdResponse,
  PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmationData,
  PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmationResponse,
  PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmationData,
  PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmationResponse,
  PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcessData,
  PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcessResponse,
  PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShippedData,
  PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShippedResponse,
  DeleteV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdHardDeleteData,
  DeleteV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdHardDeleteResponse,
  PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdRewardClaimData,
  PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdRewardClaimResponse,
  PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdUpdateCardsData,
  PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdUpdateCardsResponse,
  GetV1CardPrintingLocalPrintCardRequestData,
  GetV1CardPrintingLocalPrintCardRequestResponse,
  PostV1CardPrintingLocalPrintCardRequestCompleteData,
  PostV1CardPrintingLocalPrintCardRequestCompleteResponse,
  PostV1CardPrintingOrderPrintCardRequestData,
  PostV1CardPrintingOrderPrintCardRequestResponse,
  PostV1CardPrintingOrderPrintCardRequestUpdateData,
  PostV1CardPrintingOrderPrintCardRequestUpdateResponse,
  PostV1CardPrintingPrintCardRequestData,
  PostV1CardPrintingPrintCardRequestResponse,
  GetV1CardPrintingPrintCardRequestByPrintCardRequestIdData,
  GetV1CardPrintingPrintCardRequestByPrintCardRequestIdResponse,
  PatchV1CardPrintingPrintCardRequestByPrintCardRequestIdData,
  PatchV1CardPrintingPrintCardRequestByPrintCardRequestIdResponse,
  DeleteV1CardPrintingPrintCardRequestByPrintCardRequestIdData,
  DeleteV1CardPrintingPrintCardRequestByPrintCardRequestIdResponse,
  PostV1CardPrintingServiceAccountOpsAccountMergeData,
  PostV1CardPrintingServiceAccountOpsAccountMergeResponse,
  PostV1AccountOpsDataRetentionRunStartData,
  PostV1AccountOpsDataRetentionRunStartResponse,
  PostV1AccountOpsDataRetentionRunByDataRetentionRunIdClearData,
  PostV1AccountOpsDataRetentionRunByDataRetentionRunIdClearResponse,
  PostV1AccountOpsDataRetentionRunByDataRetentionRunIdCompleteData,
  PostV1AccountOpsDataRetentionRunByDataRetentionRunIdCompleteResponse,
  PostV1AccountOpsGuestLoginData,
  PostV1AccountOpsGuestLoginResponse,
  PostV1AccountOpsGuestMfaLoginCompleteData,
  PostV1AccountOpsGuestMfaLoginCompleteResponse,
  PostV1AccountOpsGuestMfaLoginSendCodeData,
  PostV1AccountOpsGuestMfaLoginSendCodeResponse,
  PostV1AccountOpsGuestMfaLoginStartData,
  PostV1AccountOpsGuestMfaLoginStartResponse,
  PostV1AccountOpsGuestMfaLoginByCodeIdResendData,
  PostV1AccountOpsGuestMfaLoginByCodeIdResendResponse,
  PostV1AccountOpsGuestWorkspaceByWorkspaceIdLoginData,
  PostV1AccountOpsGuestWorkspaceByWorkspaceIdLoginResponse,
  PostV1AccountOpsGuestWorkspaceByWorkspaceIdMfaLoginCompleteData,
  PostV1AccountOpsGuestWorkspaceByWorkspaceIdMfaLoginCompleteResponse,
  PostV1AccountOpsMarketingSyncRunStartData,
  PostV1AccountOpsMarketingSyncRunStartResponse,
  PostV1AccountOpsMarketingSyncRunByMarketingSyncRunIdCompleteData,
  PostV1AccountOpsMarketingSyncRunByMarketingSyncRunIdCompleteResponse,
  PostV1AccountOpsMarketingSyncRunByMarketingSyncRunIdProcessData,
  PostV1AccountOpsMarketingSyncRunByMarketingSyncRunIdProcessResponse,
  PostV1AccountOpsOrderMarketingSyncRunStartData,
  PostV1AccountOpsOrderMarketingSyncRunStartResponse,
  PostV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdCompleteData,
  PostV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdCompleteResponse,
  PostV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdProcessData,
  PostV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdProcessResponse,
  GetV1SearchInternalTeamData,
  GetV1SearchInternalTeamResponse,
  GetV1SearchTeamData,
  GetV1SearchTeamResponse,
  PostV1TeamManagementInviteAcceptData,
  PostV1TeamManagementInviteAcceptResponse,
  GetV1TeamManagementInviteByInviteIdData,
  GetV1TeamManagementInviteByInviteIdResponse,
  GetV1TeamManagementMemberByUserIdData,
  GetV1TeamManagementMemberByUserIdResponse,
  PostV1TeamManagementServiceTeamCardsData,
  PostV1TeamManagementServiceTeamCardsResponse,
  PostV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequestedData,
  PostV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequestedResponse,
  PostV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailApprovedData,
  PostV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailApprovedResponse,
  PostV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailDeniedData,
  PostV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailDeniedResponse,
  GetV1TeamManagementTeamData,
  GetV1TeamManagementTeamResponse,
  PostV1TeamManagementTeamData,
  PostV1TeamManagementTeamResponse,
  PostV1TeamManagementTeamLinkTeamAccessRequestData,
  PostV1TeamManagementTeamLinkTeamAccessRequestResponse,
  GetV1TeamManagementTeamMemberByTeamMemberIdData,
  GetV1TeamManagementTeamMemberByTeamMemberIdResponse,
  DeleteV1TeamManagementTeamMemberByTeamMemberIdData,
  DeleteV1TeamManagementTeamMemberByTeamMemberIdResponse,
  PostV1TeamManagementTeamProfilesData,
  PostV1TeamManagementTeamProfilesResponse,
  GetV1TeamManagementTeamByTeamIdData,
  GetV1TeamManagementTeamByTeamIdResponse,
  PatchV1TeamManagementTeamByTeamIdData,
  PatchV1TeamManagementTeamByTeamIdResponse,
  DeleteV1TeamManagementTeamByTeamIdData,
  DeleteV1TeamManagementTeamByTeamIdResponse,
  DeleteV1TeamManagementTeamByTeamIdHardDeleteData,
  DeleteV1TeamManagementTeamByTeamIdHardDeleteResponse,
  GetV1TeamManagementTeamByTeamIdInviteData,
  GetV1TeamManagementTeamByTeamIdInviteResponse,
  PostV1TeamManagementTeamByTeamIdInviteData,
  PostV1TeamManagementTeamByTeamIdInviteResponse,
  GetV1TeamManagementTeamByTeamIdInviteByInviteIdData,
  GetV1TeamManagementTeamByTeamIdInviteByInviteIdResponse,
  DeleteV1TeamManagementTeamByTeamIdInviteByInviteIdData,
  DeleteV1TeamManagementTeamByTeamIdInviteByInviteIdResponse,
  DeleteV1TeamManagementTeamByTeamIdInviteByInviteIdHardDeleteData,
  DeleteV1TeamManagementTeamByTeamIdInviteByInviteIdHardDeleteResponse,
  PostV1TeamManagementTeamByTeamIdInviteByInviteIdResendData,
  PostV1TeamManagementTeamByTeamIdInviteByInviteIdResendResponse,
  GetV1TeamManagementTeamByTeamIdMemberData,
  GetV1TeamManagementTeamByTeamIdMemberResponse,
  GetV1TeamManagementTeamByTeamIdMemberByUserIdData,
  GetV1TeamManagementTeamByTeamIdMemberByUserIdResponse,
  PatchV1TeamManagementTeamByTeamIdMemberByUserIdData,
  PatchV1TeamManagementTeamByTeamIdMemberByUserIdResponse,
  DeleteV1TeamManagementTeamByTeamIdMemberByUserIdData,
  DeleteV1TeamManagementTeamByTeamIdMemberByUserIdResponse,
  GetV1TeamManagementTeamByTeamIdMemberByUserIdRoleData,
  GetV1TeamManagementTeamByTeamIdMemberByUserIdRoleResponse,
  PutV1TeamManagementTeamByTeamIdOwnerData,
  PutV1TeamManagementTeamByTeamIdOwnerResponse,
  GetV1TeamManagementTeamByTeamIdTeamAccessRequestData,
  GetV1TeamManagementTeamByTeamIdTeamAccessRequestResponse,
  PostV1TeamManagementTeamByTeamIdTeamAccessRequestData,
  PostV1TeamManagementTeamByTeamIdTeamAccessRequestResponse,
  GetV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdData,
  GetV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdResponse,
  DeleteV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdData,
  DeleteV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdResponse,
  PostV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdApproveData,
  PostV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdApproveResponse,
  PostV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdDenyData,
  PostV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdDenyResponse,
  PostV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequestedData,
  PostV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequestedResponse,
  DeleteV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdHardDeleteData,
  DeleteV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdHardDeleteResponse,
  GetV1TeamManagementTeamByTeamIdTeamCardData,
  GetV1TeamManagementTeamByTeamIdTeamCardResponse,
  PostV1TeamManagementTeamByTeamIdTeamCardData,
  PostV1TeamManagementTeamByTeamIdTeamCardResponse,
  GetV1TeamManagementTeamByTeamIdTeamCardByTeamCardIdData,
  GetV1TeamManagementTeamByTeamIdTeamCardByTeamCardIdResponse,
  DeleteV1TeamManagementTeamByTeamIdTeamCardByTeamCardIdHardDeleteData,
  DeleteV1TeamManagementTeamByTeamIdTeamCardByTeamCardIdHardDeleteResponse,
  GetV1TeamManagementTeamByTeamIdTeamLinkData,
  GetV1TeamManagementTeamByTeamIdTeamLinkResponse,
  PostV1TeamManagementTeamByTeamIdTeamLinkData,
  PostV1TeamManagementTeamByTeamIdTeamLinkResponse,
  GetV1TeamManagementTeamByTeamIdTeamLinkUserByUserIdData,
  GetV1TeamManagementTeamByTeamIdTeamLinkUserByUserIdResponse,
  GetV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdData,
  GetV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdResponse,
  DeleteV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdData,
  DeleteV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdResponse,
  DeleteV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdHardDeleteData,
  DeleteV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdHardDeleteResponse,
  GetV1TeamManagementUserByUserIdInviteData,
  GetV1TeamManagementUserByUserIdInviteResponse,
  OptionsV1CommunicationEmailTemplateResponse,
  OptionsV1CommunicationEmailTemplateByEmailTemplateIdData,
  OptionsV1CommunicationEmailTemplateByEmailTemplateIdResponse,
  OptionsV1CommunicationMfaCodeByCodeIdResendData,
  OptionsV1CommunicationMfaCodeByCodeIdResendResponse,
  OptionsV1CommunicationMfaCodeByCodeIdVerifyData,
  OptionsV1CommunicationMfaCodeByCodeIdVerifyResponse,
  OptionsV1CommunicationMfaCodeByUserIdCreateData,
  OptionsV1CommunicationMfaCodeByUserIdCreateResponse,
  OptionsV1CommunicationTextTemplateResponse,
  OptionsV1CommunicationTextTemplateByTextTemplateIdData,
  OptionsV1CommunicationTextTemplateByTextTemplateIdResponse,
  OptionsV1SearchUserResponse,
  OptionsV1SearchUserInternalResponse,
  OptionsV1UserManagementAccountOpsAccountMergeResponse,
  OptionsV1UserManagementAccountOpsDataRetentionClearResponse,
  OptionsV1UserManagementAccountOpsDataRetentionUpdateResponse,
  OptionsV1UserManagementAccountOpsMarketingStatusUpdateResponse,
  OptionsV1UserManagementApiLoginResponse,
  OptionsV1UserManagementExternalServiceUsersResponse,
  OptionsV1UserManagementExternalServiceUsersByUserIdData,
  OptionsV1UserManagementExternalServiceUsersByUserIdResponse,
  OptionsV1UserManagementExternalServiceUsersByUserIdHardDeleteData,
  OptionsV1UserManagementExternalServiceUsersByUserIdHardDeleteResponse,
  OptionsV1UserManagementGuestWorkspaceByWorkspaceIdLoginData,
  OptionsV1UserManagementGuestWorkspaceByWorkspaceIdLoginResponse,
  OptionsV1UserManagementGuestWorkspaceByWorkspaceIdMfaLoginCompleteData,
  OptionsV1UserManagementGuestWorkspaceByWorkspaceIdMfaLoginCompleteResponse,
  OptionsV1UserManagementLoginResponse,
  OptionsV1UserManagementLogoutResponse,
  OptionsV1UserManagementMfaLoginCompleteResponse,
  OptionsV1UserManagementMfaLoginSendCodeResponse,
  OptionsV1UserManagementMfaLoginStartResponse,
  OptionsV1UserManagementMfaLoginByCodeIdResendData,
  OptionsV1UserManagementMfaLoginByCodeIdResendResponse,
  OptionsV1UserManagementPoliciesResponse,
  OptionsV1UserManagementPoliciesAgreementResponse,
  OptionsV1UserManagementPoliciesCurrentResponse,
  OptionsV1UserManagementPoliciesUploadResponse,
  OptionsV1UserManagementPoliciesByPolicyNameAccessData,
  OptionsV1UserManagementPoliciesByPolicyNameAccessResponse,
  OptionsV1UserManagementPoliciesByVersionIdData,
  OptionsV1UserManagementPoliciesByVersionIdResponse,
  OptionsV1UserManagementServiceUsersResponse,
  OptionsV1UserManagementServiceUsersRegistrationResponse,
  OptionsV1UserManagementTokenOrganizationByOrganizationIdRefreshData,
  OptionsV1UserManagementTokenOrganizationByOrganizationIdRefreshResponse,
  OptionsV1UserManagementTokenRefreshResponse,
  OptionsV1UserManagementUserWorkspacePublicProfilesResponse,
  OptionsV1UserManagementUserWorkspaceUserPiiDataEntryBulkResponse,
  OptionsV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryData,
  OptionsV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryResponse,
  OptionsV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryUploadData,
  OptionsV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryUploadResponse,
  OptionsV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryIdData,
  OptionsV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryIdResponse,
  OptionsV1UserManagementUsersResponse,
  OptionsV1UserManagementUsersEmailVerificationConfirmResponse,
  OptionsV1UserManagementUsersEmailVerificationRequestResponse,
  OptionsV1UserManagementUsersGuestUserRegistrationResponse,
  OptionsV1UserManagementUsersGuestUserRegistrationCompleteResponse,
  OptionsV1UserManagementUsersPasswordConfirmResponse,
  OptionsV1UserManagementUsersPasswordResetResponse,
  OptionsV1UserManagementUsersPublicProfilesResponse,
  OptionsV1UserManagementUsersRegistrationResponse,
  OptionsV1UserManagementUsersRegistrationUsernameAvailableResponse,
  OptionsV1UserManagementUsersByCodeIdVerifyPhoneResendData,
  OptionsV1UserManagementUsersByCodeIdVerifyPhoneResendResponse,
  OptionsV1UserManagementUsersByCodeIdVerifyPhoneVerifyData,
  OptionsV1UserManagementUsersByCodeIdVerifyPhoneVerifyResponse,
  OptionsV1UserManagementUsersByUserIdData,
  OptionsV1UserManagementUsersByUserIdResponse,
  OptionsV1UserManagementUsersByUserIdEmailData,
  OptionsV1UserManagementUsersByUserIdEmailResponse,
  OptionsV1UserManagementUsersByUserIdGuestEmailData,
  OptionsV1UserManagementUsersByUserIdGuestEmailResponse,
  OptionsV1UserManagementUsersByUserIdHardDeleteData,
  OptionsV1UserManagementUsersByUserIdHardDeleteResponse,
  OptionsV1UserManagementUsersByUserIdPasswordData,
  OptionsV1UserManagementUsersByUserIdPasswordResponse,
  OptionsV1UserManagementUsersByUserIdUserPiiDataEntryData,
  OptionsV1UserManagementUsersByUserIdUserPiiDataEntryResponse,
  OptionsV1UserManagementUsersByUserIdUserPiiDataEntryUploadData,
  OptionsV1UserManagementUsersByUserIdUserPiiDataEntryUploadResponse,
  OptionsV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryIdData,
  OptionsV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryIdResponse,
  OptionsV1UserManagementUsersByUserIdVerifyPhoneStartData,
  OptionsV1UserManagementUsersByUserIdVerifyPhoneStartResponse,
  OptionsV1OrganizationManagementAccountOpsDataRetentionClearResponse,
  OptionsV1OrganizationManagementAccountOpsMemberWorkspaceBulkResponse,
  OptionsV1OrganizationManagementGuestFamilyRegistrationCreateResponse,
  OptionsV1OrganizationManagementGuestFamilyRegistrationByOrganizationIdCompleteData,
  OptionsV1OrganizationManagementGuestFamilyRegistrationByOrganizationIdCompleteResponse,
  OptionsV1OrganizationManagementInviteAcceptResponse,
  OptionsV1OrganizationManagementInviteByInviteIdData,
  OptionsV1OrganizationManagementInviteByInviteIdResponse,
  OptionsV1OrganizationManagementMemberWorkspaceBulkResponse,
  OptionsV1OrganizationManagementMemberByUserIdData,
  OptionsV1OrganizationManagementMemberByUserIdResponse,
  OptionsV1OrganizationManagementOrganizationResponse,
  OptionsV1OrganizationManagementOrganizationMemberByOrganizationMemberIdData,
  OptionsV1OrganizationManagementOrganizationMemberByOrganizationMemberIdResponse,
  OptionsV1OrganizationManagementOrganizationWorkspaceOrganizationPiiDataEntryBulkResponse,
  OptionsV1OrganizationManagementOrganizationWorkspaceProfilesResponse,
  OptionsV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryData,
  OptionsV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryResponse,
  OptionsV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryUploadData,
  OptionsV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryUploadResponse,
  OptionsV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdData,
  OptionsV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdResponse,
  OptionsV1OrganizationManagementOrganizationProfilesResponse,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdData,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdResponse,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdHardDeleteData,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdHardDeleteResponse,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdInviteData,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdInviteResponse,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdData,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdResponse,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdHardDeleteData,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdHardDeleteResponse,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdResendData,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdResendResponse,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdMemberData,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdMemberResponse,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdMemberChildData,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdMemberChildResponse,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdData,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdResponse,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdRoleData,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdRoleResponse,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryData,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryResponse,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryUploadData,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryUploadResponse,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdData,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdResponse,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdOwnerData,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdOwnerResponse,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdTagsData,
  OptionsV1OrganizationManagementOrganizationByOrganizationIdTagsResponse,
  OptionsV1OrganizationManagementUserByUserIdInviteData,
  OptionsV1OrganizationManagementUserByUserIdInviteResponse,
  OptionsV1SearchInternalOrganizationResponse,
  OptionsV1SearchOrganizationResponse,
  OptionsV1ApiUserApiUserByUserIdByUserIdData,
  OptionsV1ApiUserApiUserByUserIdByUserIdResponse,
  OptionsV1ApiUserApiUserByUserIdByUserIdHardDeleteData,
  OptionsV1ApiUserApiUserByUserIdByUserIdHardDeleteResponse,
  OptionsV1ApiUserOrganizationByOrganizationIdData,
  OptionsV1ApiUserOrganizationByOrganizationIdResponse,
  OptionsV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdData,
  OptionsV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdResponse,
  OptionsV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdHardDeleteData,
  OptionsV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdHardDeleteResponse,
  OptionsV1CardJamCardResponse,
  OptionsV1CardJamCardPackResponse,
  OptionsV1CardJamCardPackByCardPackIdData,
  OptionsV1CardJamCardPackByCardPackIdResponse,
  OptionsV1CardJamCardPackByCardPackIdHardDeleteData,
  OptionsV1CardJamCardPackByCardPackIdHardDeleteResponse,
  OptionsV1CardJamCardSetResponse,
  OptionsV1CardJamCardSetPackResponse,
  OptionsV1CardJamCardSetPackCardSetByCardSetIdCardSetPackTypeByCardSetPackTypeData,
  OptionsV1CardJamCardSetPackCardSetByCardSetIdCardSetPackTypeByCardSetPackTypeResponse,
  OptionsV1CardJamCardSetPackByCardSetPackIdData,
  OptionsV1CardJamCardSetPackByCardSetPackIdResponse,
  OptionsV1CardJamCardSetPackByCardSetPackIdHardDeleteData,
  OptionsV1CardJamCardSetPackByCardSetPackIdHardDeleteResponse,
  OptionsV1CardJamCardSetByCardSetIdData,
  OptionsV1CardJamCardSetByCardSetIdResponse,
  OptionsV1CardJamCardSetByCardSetIdHardDeleteData,
  OptionsV1CardJamCardSetByCardSetIdHardDeleteResponse,
  OptionsV1CardJamCardSetByCardSetIdValidateData,
  OptionsV1CardJamCardSetByCardSetIdValidateResponse,
  OptionsV1CardJamCardVariantAttributeResponse,
  OptionsV1CardJamCardVariantAttributeRawResponse,
  OptionsV1CardJamCardVariantAttributeByCardVariantAttributeData,
  OptionsV1CardJamCardVariantAttributeByCardVariantAttributeResponse,
  OptionsV1CardJamCardVariantAttributeByCardVariantAttributeHardDeleteData,
  OptionsV1CardJamCardVariantAttributeByCardVariantAttributeHardDeleteResponse,
  OptionsV1CardJamLocalAdminCardDownloadsResponse,
  OptionsV1CardJamLocalAdminCardUploadResponse,
  OptionsV1CardJamMarketingCampaignResponse,
  OptionsV1CardJamMarketingCampaignByMarketingCampaignIdData,
  OptionsV1CardJamMarketingCampaignByMarketingCampaignIdResponse,
  OptionsV1CardJamMarketingCampaignByMarketingCampaignIdActivateData,
  OptionsV1CardJamMarketingCampaignByMarketingCampaignIdActivateResponse,
  OptionsV1CardJamMarketingCampaignByMarketingCampaignIdCardPackData,
  OptionsV1CardJamMarketingCampaignByMarketingCampaignIdCardPackResponse,
  OptionsV1CardJamMarketingCampaignByMarketingCampaignIdCardPackByMarketingCampaignCardPackIdData,
  OptionsV1CardJamMarketingCampaignByMarketingCampaignIdCardPackByMarketingCampaignCardPackIdResponse,
  OptionsV1CardJamMarketingCampaignByMarketingCampaignIdDeactivateData,
  OptionsV1CardJamMarketingCampaignByMarketingCampaignIdDeactivateResponse,
  OptionsV1CardJamMarketingCampaignByMarketingCampaignIdHardDeleteData,
  OptionsV1CardJamMarketingCampaignByMarketingCampaignIdHardDeleteResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeDecreaseData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeDecreaseResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeIncreaseData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeIncreaseResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeIdData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeIdResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeIdHardDeleteData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeIdHardDeleteResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignDecreaseData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignDecreaseResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignIncreaseData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignIncreaseResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignIdData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignIdResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignIdHardDeleteData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignIdHardDeleteResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardFullData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardFullResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardInternalData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardInternalResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardSetData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardSetResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardSetByCardSetIdData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardSetByCardSetIdResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdFinalizeData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdFinalizeResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdUpdateData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdUpdateResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdVariantData,
  OptionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdVariantResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdMarketingCampaignClaimData,
  OptionsV1CardJamWorkspaceByWorkspaceIdMarketingCampaignClaimResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackData,
  OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackDecreaseData,
  OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackDecreaseResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackIncreaseData,
  OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackIncreaseResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdData,
  OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdHardDeleteData,
  OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdHardDeleteResponse,
  OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdOpenData,
  OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdOpenResponse,
  OptionsV1OrderManagementAbandonedCartReminderResponse,
  OptionsV1OrderManagementAccountOpsMarketingStatusUpdateResponse,
  OptionsV1OrderManagementDiscountCouponResponse,
  OptionsV1OrderManagementDiscountCouponByDiscountCouponIdData,
  OptionsV1OrderManagementDiscountCouponByDiscountCouponIdResponse,
  OptionsV1OrderManagementDiscountCouponByDiscountCouponIdHardDeleteData,
  OptionsV1OrderManagementDiscountCouponByDiscountCouponIdHardDeleteResponse,
  OptionsV1OrderManagementFreeCardCouponResponse,
  OptionsV1OrderManagementFreeCardCouponByFreeCardCouponIdData,
  OptionsV1OrderManagementFreeCardCouponByFreeCardCouponIdResponse,
  OptionsV1OrderManagementFreeCardCouponByFreeCardCouponIdHardDeleteData,
  OptionsV1OrderManagementFreeCardCouponByFreeCardCouponIdHardDeleteResponse,
  OptionsV1OrderManagementOrderResponse,
  OptionsV1OrderManagementOrderPrintingStartedBulkResponse,
  OptionsV1OrderManagementOrderShippedBulkResponse,
  OptionsV1OrderManagementOrderByOrderIdData,
  OptionsV1OrderManagementOrderByOrderIdResponse,
  OptionsV1OrderManagementOrderByOrderIdPrintingStartedData,
  OptionsV1OrderManagementOrderByOrderIdPrintingStartedResponse,
  OptionsV1OrderManagementOrderByOrderIdShippedData,
  OptionsV1OrderManagementOrderByOrderIdShippedResponse,
  OptionsV1OrderManagementProductPriceResponse,
  OptionsV1OrderManagementProductPriceProductTypeByProductTypeData,
  OptionsV1OrderManagementProductPriceProductTypeByProductTypeResponse,
  OptionsV1OrderManagementProductPriceByProductPriceIdData,
  OptionsV1OrderManagementProductPriceByProductPriceIdResponse,
  OptionsV1OrderManagementProductPriceByProductPriceIdHardDeleteData,
  OptionsV1OrderManagementProductPriceByProductPriceIdHardDeleteResponse,
  OptionsV1OrderManagementServiceAccountOpsAccountMergeResponse,
  OptionsV1OrderManagementServiceAccountOpsDataRetentionClearResponse,
  OptionsV1OrderManagementServiceOrderResponse,
  OptionsV1OrderManagementServiceWorkspaceOrderStatisticsResponse,
  OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdCheckoutByOrderIdTimeoutData,
  OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdCheckoutByOrderIdTimeoutResponse,
  OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmationData,
  OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmationResponse,
  OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmationData,
  OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmationResponse,
  OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcessData,
  OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcessResponse,
  OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShippedData,
  OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShippedResponse,
  OptionsV1OrderManagementStripeRetryResponse,
  OptionsV1OrderManagementStripeWebhookResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCartData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCartResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemCardData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemCardResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamCardData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamCardResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamPackData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamPackResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdHardDeleteData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdHardDeleteResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutStartData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutStartResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCancelData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCancelResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCheckoutCompleteData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCheckoutCompleteResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountDecreaseData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountDecreaseResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountHardDeleteData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountHardDeleteResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountIncreaseData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountIncreaseResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCouponClaimData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCouponClaimResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmationData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmationResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmationData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmationResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcessData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcessResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShippedData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShippedResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdHardDeleteData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdHardDeleteResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdRewardClaimData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdRewardClaimResponse,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdUpdateCardsData,
  OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdUpdateCardsResponse,
  OptionsV1CardPrintingLocalPrintCardRequestResponse,
  OptionsV1CardPrintingLocalPrintCardRequestCompleteResponse,
  OptionsV1CardPrintingOrderPrintCardRequestResponse,
  OptionsV1CardPrintingOrderPrintCardRequestUpdateResponse,
  OptionsV1CardPrintingPrintCardRequestResponse,
  OptionsV1CardPrintingPrintCardRequestByPrintCardRequestIdData,
  OptionsV1CardPrintingPrintCardRequestByPrintCardRequestIdResponse,
  OptionsV1CardPrintingServiceAccountOpsAccountMergeResponse,
  OptionsV1AccountOpsDataRetentionRunStartResponse,
  OptionsV1AccountOpsDataRetentionRunByDataRetentionRunIdClearData,
  OptionsV1AccountOpsDataRetentionRunByDataRetentionRunIdClearResponse,
  OptionsV1AccountOpsDataRetentionRunByDataRetentionRunIdCompleteData,
  OptionsV1AccountOpsDataRetentionRunByDataRetentionRunIdCompleteResponse,
  OptionsV1AccountOpsGuestLoginResponse,
  OptionsV1AccountOpsGuestMfaLoginCompleteResponse,
  OptionsV1AccountOpsGuestMfaLoginSendCodeResponse,
  OptionsV1AccountOpsGuestMfaLoginStartResponse,
  OptionsV1AccountOpsGuestMfaLoginByCodeIdResendData,
  OptionsV1AccountOpsGuestMfaLoginByCodeIdResendResponse,
  OptionsV1AccountOpsGuestWorkspaceByWorkspaceIdLoginData,
  OptionsV1AccountOpsGuestWorkspaceByWorkspaceIdLoginResponse,
  OptionsV1AccountOpsGuestWorkspaceByWorkspaceIdMfaLoginCompleteData,
  OptionsV1AccountOpsGuestWorkspaceByWorkspaceIdMfaLoginCompleteResponse,
  OptionsV1AccountOpsMarketingSyncRunStartResponse,
  OptionsV1AccountOpsMarketingSyncRunByMarketingSyncRunIdCompleteData,
  OptionsV1AccountOpsMarketingSyncRunByMarketingSyncRunIdCompleteResponse,
  OptionsV1AccountOpsMarketingSyncRunByMarketingSyncRunIdProcessData,
  OptionsV1AccountOpsMarketingSyncRunByMarketingSyncRunIdProcessResponse,
  OptionsV1AccountOpsOrderMarketingSyncRunStartResponse,
  OptionsV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdCompleteData,
  OptionsV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdCompleteResponse,
  OptionsV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdProcessData,
  OptionsV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdProcessResponse,
  OptionsV1SearchInternalTeamResponse,
  OptionsV1SearchTeamResponse,
  OptionsV1TeamManagementInviteAcceptResponse,
  OptionsV1TeamManagementInviteByInviteIdData,
  OptionsV1TeamManagementInviteByInviteIdResponse,
  OptionsV1TeamManagementMemberByUserIdData,
  OptionsV1TeamManagementMemberByUserIdResponse,
  OptionsV1TeamManagementServiceTeamCardsResponse,
  OptionsV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequestedData,
  OptionsV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequestedResponse,
  OptionsV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailApprovedData,
  OptionsV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailApprovedResponse,
  OptionsV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailDeniedData,
  OptionsV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailDeniedResponse,
  OptionsV1TeamManagementTeamResponse,
  OptionsV1TeamManagementTeamLinkTeamAccessRequestResponse,
  OptionsV1TeamManagementTeamMemberByTeamMemberIdData,
  OptionsV1TeamManagementTeamMemberByTeamMemberIdResponse,
  OptionsV1TeamManagementTeamProfilesResponse,
  OptionsV1TeamManagementTeamByTeamIdData,
  OptionsV1TeamManagementTeamByTeamIdResponse,
  OptionsV1TeamManagementTeamByTeamIdHardDeleteData,
  OptionsV1TeamManagementTeamByTeamIdHardDeleteResponse,
  OptionsV1TeamManagementTeamByTeamIdInviteData,
  OptionsV1TeamManagementTeamByTeamIdInviteResponse,
  OptionsV1TeamManagementTeamByTeamIdInviteByInviteIdData,
  OptionsV1TeamManagementTeamByTeamIdInviteByInviteIdResponse,
  OptionsV1TeamManagementTeamByTeamIdInviteByInviteIdHardDeleteData,
  OptionsV1TeamManagementTeamByTeamIdInviteByInviteIdHardDeleteResponse,
  OptionsV1TeamManagementTeamByTeamIdInviteByInviteIdResendData,
  OptionsV1TeamManagementTeamByTeamIdInviteByInviteIdResendResponse,
  OptionsV1TeamManagementTeamByTeamIdMemberData,
  OptionsV1TeamManagementTeamByTeamIdMemberResponse,
  OptionsV1TeamManagementTeamByTeamIdMemberByUserIdData,
  OptionsV1TeamManagementTeamByTeamIdMemberByUserIdResponse,
  OptionsV1TeamManagementTeamByTeamIdMemberByUserIdRoleData,
  OptionsV1TeamManagementTeamByTeamIdMemberByUserIdRoleResponse,
  OptionsV1TeamManagementTeamByTeamIdOwnerData,
  OptionsV1TeamManagementTeamByTeamIdOwnerResponse,
  OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestData,
  OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestResponse,
  OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdData,
  OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdResponse,
  OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdApproveData,
  OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdApproveResponse,
  OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdDenyData,
  OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdDenyResponse,
  OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequestedData,
  OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequestedResponse,
  OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdHardDeleteData,
  OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdHardDeleteResponse,
  OptionsV1TeamManagementTeamByTeamIdTeamCardData,
  OptionsV1TeamManagementTeamByTeamIdTeamCardResponse,
  OptionsV1TeamManagementTeamByTeamIdTeamCardByTeamCardIdData,
  OptionsV1TeamManagementTeamByTeamIdTeamCardByTeamCardIdResponse,
  OptionsV1TeamManagementTeamByTeamIdTeamCardByTeamCardIdHardDeleteData,
  OptionsV1TeamManagementTeamByTeamIdTeamCardByTeamCardIdHardDeleteResponse,
  OptionsV1TeamManagementTeamByTeamIdTeamLinkData,
  OptionsV1TeamManagementTeamByTeamIdTeamLinkResponse,
  OptionsV1TeamManagementTeamByTeamIdTeamLinkUserByUserIdData,
  OptionsV1TeamManagementTeamByTeamIdTeamLinkUserByUserIdResponse,
  OptionsV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdData,
  OptionsV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdResponse,
  OptionsV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdHardDeleteData,
  OptionsV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdHardDeleteResponse,
  OptionsV1TeamManagementUserByUserIdInviteData,
  OptionsV1TeamManagementUserByUserIdInviteResponse
} from "./types.gen";

export class V1Service {
  /**
   * A simple ViewSet for viewing and editing the email templates
   * associated with the system.
   * @param data The data for the request.
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1CommunicationEmailTemplate(
    data: GetV1CommunicationEmailTemplateData = {}
  ): CancelablePromise<GetV1CommunicationEmailTemplateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/communication/email-template",
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple ViewSet for viewing and editing the email templates
   * associated with the system.
   * @param data The data for the request.
   * @param data.data
   * @returns EmailTemplateView
   * @throws ApiError
   */
  public static postV1CommunicationEmailTemplate(
    data: PostV1CommunicationEmailTemplateData
  ): CancelablePromise<PostV1CommunicationEmailTemplateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/communication/email-template",
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing and editing the email templates
   * associated with the system.
   * @param data The data for the request.
   * @param data.emailTemplateId
   * @returns EmailTemplateView
   * @throws ApiError
   */
  public static getV1CommunicationEmailTemplateByEmailTemplateId(
    data: GetV1CommunicationEmailTemplateByEmailTemplateIdData
  ): CancelablePromise<GetV1CommunicationEmailTemplateByEmailTemplateIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/communication/email-template/{email_template_id}",
      path: {
        email_template_id: data.emailTemplateId
      }
    });
  }

  /**
   * A simple ViewSet for viewing and editing the email templates
   * associated with the system.
   * @param data The data for the request.
   * @param data.emailTemplateId
   * @param data.data
   * @returns EmailTemplateView
   * @throws ApiError
   */
  public static putV1CommunicationEmailTemplateByEmailTemplateId(
    data: PutV1CommunicationEmailTemplateByEmailTemplateIdData
  ): CancelablePromise<PutV1CommunicationEmailTemplateByEmailTemplateIdResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/v1/communication/email-template/{email_template_id}",
      path: {
        email_template_id: data.emailTemplateId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing and editing the email templates
   * associated with the system.
   * @param data The data for the request.
   * @param data.emailTemplateId
   * @param data.data
   * @returns EmailTemplateView
   * @throws ApiError
   */
  public static patchV1CommunicationEmailTemplateByEmailTemplateId(
    data: PatchV1CommunicationEmailTemplateByEmailTemplateIdData
  ): CancelablePromise<PatchV1CommunicationEmailTemplateByEmailTemplateIdResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/v1/communication/email-template/{email_template_id}",
      path: {
        email_template_id: data.emailTemplateId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing and editing the email templates
   * associated with the system.
   * @param data The data for the request.
   * @param data.emailTemplateId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1CommunicationEmailTemplateByEmailTemplateId(
    data: DeleteV1CommunicationEmailTemplateByEmailTemplateIdData
  ): CancelablePromise<DeleteV1CommunicationEmailTemplateByEmailTemplateIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/communication/email-template/{email_template_id}",
      path: {
        email_template_id: data.emailTemplateId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.codeId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1CommunicationMfaCodeByCodeIdResend(
    data: PostV1CommunicationMfaCodeByCodeIdResendData
  ): CancelablePromise<PostV1CommunicationMfaCodeByCodeIdResendResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/communication/mfa-code/{code_id}/resend",
      path: {
        code_id: data.codeId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.codeId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1CommunicationMfaCodeByCodeIdVerify(
    data: PostV1CommunicationMfaCodeByCodeIdVerifyData
  ): CancelablePromise<PostV1CommunicationMfaCodeByCodeIdVerifyResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/communication/mfa-code/{code_id}/verify",
      path: {
        code_id: data.codeId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.data
   * @returns MFACodeResponse
   * @throws ApiError
   */
  public static postV1CommunicationMfaCodeByUserIdCreate(
    data: PostV1CommunicationMfaCodeByUserIdCreateData
  ): CancelablePromise<PostV1CommunicationMfaCodeByUserIdCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/communication/mfa-code/{user_id}/create",
      path: {
        user_id: data.userId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing and editing the email templates
   * associated with the system.
   * @param data The data for the request.
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1CommunicationTextTemplate(
    data: GetV1CommunicationTextTemplateData = {}
  ): CancelablePromise<GetV1CommunicationTextTemplateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/communication/text-template",
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple ViewSet for viewing and editing the email templates
   * associated with the system.
   * @param data The data for the request.
   * @param data.data
   * @returns TextTemplateView
   * @throws ApiError
   */
  public static postV1CommunicationTextTemplate(
    data: PostV1CommunicationTextTemplateData
  ): CancelablePromise<PostV1CommunicationTextTemplateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/communication/text-template",
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing and editing the email templates
   * associated with the system.
   * @param data The data for the request.
   * @param data.textTemplateId
   * @returns TextTemplateView
   * @throws ApiError
   */
  public static getV1CommunicationTextTemplateByTextTemplateId(
    data: GetV1CommunicationTextTemplateByTextTemplateIdData
  ): CancelablePromise<GetV1CommunicationTextTemplateByTextTemplateIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/communication/text-template/{text_template_id}",
      path: {
        text_template_id: data.textTemplateId
      }
    });
  }

  /**
   * A simple ViewSet for viewing and editing the email templates
   * associated with the system.
   * @param data The data for the request.
   * @param data.textTemplateId
   * @param data.data
   * @returns TextTemplateView
   * @throws ApiError
   */
  public static putV1CommunicationTextTemplateByTextTemplateId(
    data: PutV1CommunicationTextTemplateByTextTemplateIdData
  ): CancelablePromise<PutV1CommunicationTextTemplateByTextTemplateIdResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/v1/communication/text-template/{text_template_id}",
      path: {
        text_template_id: data.textTemplateId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing and editing the email templates
   * associated with the system.
   * @param data The data for the request.
   * @param data.textTemplateId
   * @param data.data
   * @returns TextTemplateView
   * @throws ApiError
   */
  public static patchV1CommunicationTextTemplateByTextTemplateId(
    data: PatchV1CommunicationTextTemplateByTextTemplateIdData
  ): CancelablePromise<PatchV1CommunicationTextTemplateByTextTemplateIdResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/v1/communication/text-template/{text_template_id}",
      path: {
        text_template_id: data.textTemplateId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing and editing the email templates
   * associated with the system.
   * @param data The data for the request.
   * @param data.textTemplateId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1CommunicationTextTemplateByTextTemplateId(
    data: DeleteV1CommunicationTextTemplateByTextTemplateIdData
  ): CancelablePromise<DeleteV1CommunicationTextTemplateByTextTemplateIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/communication/text-template/{text_template_id}",
      path: {
        text_template_id: data.textTemplateId
      }
    });
  }

  /**
   * Search for a term among user public text.
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @param data.term The term to search for.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1SearchUser(
    data: GetV1SearchUserData = {}
  ): CancelablePromise<GetV1SearchUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/search/user",
      query: {
        limit: data.limit,
        offset: data.offset,
        term: data.term
      }
    });
  }

  /**
   * Internal Only: Search for a user among personally identifying information.  Returns a list
   * of workspaces that user has access to.
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @param data.term The term to search for.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1SearchUserInternal(
    data: GetV1SearchUserInternalData = {}
  ): CancelablePromise<GetV1SearchUserInternalResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/search/user/internal",
      query: {
        limit: data.limit,
        offset: data.offset,
        term: data.term
      }
    });
  }

  /**
   * A viewset for merging two account workspace ids
   * @param data The data for the request.
   * @param data.data
   * @returns AccountOpsAccountMergeResponse
   * @throws ApiError
   */
  public static postV1UserManagementAccountOpsAccountMerge(
    data: PostV1UserManagementAccountOpsAccountMergeData
  ): CancelablePromise<PostV1UserManagementAccountOpsAccountMergeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/account-ops/account-merge",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns AccountOpsDataRetentionClearResponse
   * @throws ApiError
   */
  public static postV1UserManagementAccountOpsDataRetentionClear(
    data: PostV1UserManagementAccountOpsDataRetentionClearData
  ): CancelablePromise<PostV1UserManagementAccountOpsDataRetentionClearResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/account-ops/data-retention-clear",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns AccountOpsDataRetentionUpdateResponse
   * @throws ApiError
   */
  public static postV1UserManagementAccountOpsDataRetentionUpdate(
    data: PostV1UserManagementAccountOpsDataRetentionUpdateData
  ): CancelablePromise<PostV1UserManagementAccountOpsDataRetentionUpdateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/account-ops/data-retention-update",
      body: data.data
    });
  }

  /**
   * A viewset for updating the user account's marketing_status (managed elsewhere)
   * @param data The data for the request.
   * @param data.data
   * @returns AccountOpsMarketingStatusUpdateResponse
   * @throws ApiError
   */
  public static postV1UserManagementAccountOpsMarketingStatusUpdate(
    data: PostV1UserManagementAccountOpsMarketingStatusUpdateData
  ): CancelablePromise<PostV1UserManagementAccountOpsMarketingStatusUpdateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/account-ops/marketing-status-update",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns ApiUserLoginResponse
   * @throws ApiError
   */
  public static postV1UserManagementApiLogin(
    data: PostV1UserManagementApiLoginData
  ): CancelablePromise<PostV1UserManagementApiLoginResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/api-login",
      body: data.data
    });
  }

  /**
   * External service users are users that are meant for representing accounts defined
   * to access external resources.  They may show up in end client assets somewhere and thus
   * need to resolve as regular users when prompted for information about them.
   * @param data The data for the request.
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1UserManagementExternalServiceUsers(
    data: GetV1UserManagementExternalServiceUsersData = {}
  ): CancelablePromise<GetV1UserManagementExternalServiceUsersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/user-management/external-service-users",
      query: {
        page: data.page
      }
    });
  }

  /**
   * External service users are users that are meant for representing accounts defined
   * to access external resources.  They may show up in end client assets somewhere and thus
   * need to resolve as regular users when prompted for information about them.
   * @param data The data for the request.
   * @param data.data
   * @returns ExternalServiceUserAccountView
   * @throws ApiError
   */
  public static postV1UserManagementExternalServiceUsers(
    data: PostV1UserManagementExternalServiceUsersData
  ): CancelablePromise<PostV1UserManagementExternalServiceUsersResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/external-service-users",
      body: data.data
    });
  }

  /**
   * External service users are users that are meant for representing accounts defined
   * to access external resources.  They may show up in end client assets somewhere and thus
   * need to resolve as regular users when prompted for information about them.
   * @param data The data for the request.
   * @param data.userId
   * @returns ExternalServiceUserAccountView
   * @throws ApiError
   */
  public static getV1UserManagementExternalServiceUsersByUserId(
    data: GetV1UserManagementExternalServiceUsersByUserIdData
  ): CancelablePromise<GetV1UserManagementExternalServiceUsersByUserIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/user-management/external-service-users/{user_id}",
      path: {
        user_id: data.userId
      }
    });
  }

  /**
   * External service users are users that are meant for representing accounts defined
   * to access external resources.  They may show up in end client assets somewhere and thus
   * need to resolve as regular users when prompted for information about them.
   * @param data The data for the request.
   * @param data.userId
   * @param data.data
   * @returns ExternalServiceUserAccountView
   * @throws ApiError
   */
  public static patchV1UserManagementExternalServiceUsersByUserId(
    data: PatchV1UserManagementExternalServiceUsersByUserIdData
  ): CancelablePromise<PatchV1UserManagementExternalServiceUsersByUserIdResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/v1/user-management/external-service-users/{user_id}",
      path: {
        user_id: data.userId
      },
      body: data.data
    });
  }

  /**
   * External service users are users that are meant for representing accounts defined
   * to access external resources.  They may show up in end client assets somewhere and thus
   * need to resolve as regular users when prompted for information about them.
   * @param data The data for the request.
   * @param data.userId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1UserManagementExternalServiceUsersByUserId(
    data: DeleteV1UserManagementExternalServiceUsersByUserIdData
  ): CancelablePromise<DeleteV1UserManagementExternalServiceUsersByUserIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/user-management/external-service-users/{user_id}",
      path: {
        user_id: data.userId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1UserManagementExternalServiceUsersByUserIdHardDelete(
    data: DeleteV1UserManagementExternalServiceUsersByUserIdHardDeleteData
  ): CancelablePromise<DeleteV1UserManagementExternalServiceUsersByUserIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/user-management/external-service-users/{user_id}/hard-delete",
      path: {
        user_id: data.userId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns GuestUserLoginResponse
   * @throws ApiError
   */
  public static postV1UserManagementGuestWorkspaceByWorkspaceIdLogin(
    data: PostV1UserManagementGuestWorkspaceByWorkspaceIdLoginData
  ): CancelablePromise<PostV1UserManagementGuestWorkspaceByWorkspaceIdLoginResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/guest/workspace/{workspace_id}/login",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns GuestMFAUserWorkspaceLoginCompleteResponse
   * @throws ApiError
   */
  public static postV1UserManagementGuestWorkspaceByWorkspaceIdMfaLoginComplete(
    data: PostV1UserManagementGuestWorkspaceByWorkspaceIdMfaLoginCompleteData
  ): CancelablePromise<PostV1UserManagementGuestWorkspaceByWorkspaceIdMfaLoginCompleteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/guest/workspace/{workspace_id}/mfa-login/complete",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns UserLoginResponse
   * @throws ApiError
   */
  public static postV1UserManagementLogin(
    data: PostV1UserManagementLoginData
  ): CancelablePromise<PostV1UserManagementLoginResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/login",
      body: data.data
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static postV1UserManagementLogout(): CancelablePromise<PostV1UserManagementLogoutResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/logout"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns MFAUserLoginCompleteResponse
   * @throws ApiError
   */
  public static postV1UserManagementMfaLoginComplete(
    data: PostV1UserManagementMfaLoginCompleteData
  ): CancelablePromise<PostV1UserManagementMfaLoginCompleteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/mfa-login/complete",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns MFAUserLoginSendCodeResponse
   * @throws ApiError
   */
  public static postV1UserManagementMfaLoginSendCode(
    data: PostV1UserManagementMfaLoginSendCodeData
  ): CancelablePromise<PostV1UserManagementMfaLoginSendCodeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/mfa-login/send-code",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns MFAUserLoginStartResponse
   * @throws ApiError
   */
  public static postV1UserManagementMfaLoginStart(
    data: PostV1UserManagementMfaLoginStartData
  ): CancelablePromise<PostV1UserManagementMfaLoginStartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/mfa-login/start",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.codeId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1UserManagementMfaLoginByCodeIdResend(
    data: PostV1UserManagementMfaLoginByCodeIdResendData
  ): CancelablePromise<PostV1UserManagementMfaLoginByCodeIdResendResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/mfa-login/{code_id}/resend",
      path: {
        code_id: data.codeId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1UserManagementPolicies(
    data: GetV1UserManagementPoliciesData = {}
  ): CancelablePromise<GetV1UserManagementPoliciesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/user-management/policies",
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple ViewSet for viewing and editing the email templates
   * associated with the system.
   * @param data The data for the request.
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1UserManagementPoliciesAgreement(
    data: PostV1UserManagementPoliciesAgreementData
  ): CancelablePromise<PostV1UserManagementPoliciesAgreementResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/policies/agreement",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1UserManagementPoliciesCurrent(
    data: GetV1UserManagementPoliciesCurrentData = {}
  ): CancelablePromise<GetV1UserManagementPoliciesCurrentResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/user-management/policies/current",
      query: {
        page: data.page
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1UserManagementPoliciesUpload(
    data: PostV1UserManagementPoliciesUploadData
  ): CancelablePromise<PostV1UserManagementPoliciesUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/policies/upload",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.policyName
   * @param data.page A page number within the paginated result set.
   * @returns PolicyAccessResponse
   * @throws ApiError
   */
  public static getV1UserManagementPoliciesByPolicyNameAccess(
    data: GetV1UserManagementPoliciesByPolicyNameAccessData
  ): CancelablePromise<GetV1UserManagementPoliciesByPolicyNameAccessResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/user-management/policies/{policy_name}/access",
      path: {
        policy_name: data.policyName
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.versionId A UUID string identifying this policy.
   * @returns PolicyView
   * @throws ApiError
   */
  public static getV1UserManagementPoliciesByVersionId(
    data: GetV1UserManagementPoliciesByVersionIdData
  ): CancelablePromise<GetV1UserManagementPoliciesByVersionIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/user-management/policies/{version_id}",
      path: {
        version_id: data.versionId
      }
    });
  }

  /**
   * A service endpoint for searching for users as part of longer running tasks
   * @param data The data for the request.
   * @param data.userType user_type
   * @param data.userTypeIn user_type__in
   * @param data.active active
   * @param data.adultUser adult_user
   * @param data.createdLt created__lt
   * @param data.createdGt created__gt
   * @param data.created created
   * @param data.dataRetentionStatus data_retention_status
   * @param data.dataRetentionStatusIn data_retention_status__in
   * @param data.marketingStatus marketing_status
   * @param data.marketingStatusIn marketing_status__in
   * @param data.userTypeNot user_type__not
   * @param data.userTypeNotIn user_type__not__in
   * @param data.dataRetentionStatusNot data_retention_status__not
   * @param data.dataRetentionStatusNotIn data_retention_status__not__in
   * @param data.marketingStatusNot marketing_status__not
   * @param data.marketingStatusNotIn marketing_status__not__in
   * @param data.page A page number within the paginated result set.
   * @param data.pageSize Number of results to return per page.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1UserManagementServiceUsers(
    data: GetV1UserManagementServiceUsersData = {}
  ): CancelablePromise<GetV1UserManagementServiceUsersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/user-management/service/users",
      query: {
        user_type: data.userType,
        user_type__in: data.userTypeIn,
        active: data.active,
        adult_user: data.adultUser,
        created__lt: data.createdLt,
        created__gt: data.createdGt,
        created: data.created,
        data_retention_status: data.dataRetentionStatus,
        data_retention_status__in: data.dataRetentionStatusIn,
        marketing_status: data.marketingStatus,
        marketing_status__in: data.marketingStatusIn,
        user_type__not: data.userTypeNot,
        user_type__not__in: data.userTypeNotIn,
        data_retention_status__not: data.dataRetentionStatusNot,
        data_retention_status__not__in: data.dataRetentionStatusNotIn,
        marketing_status__not: data.marketingStatusNot,
        marketing_status__not__in: data.marketingStatusNotIn,
        page: data.page,
        page_size: data.pageSize
      }
    });
  }

  /**
   * A service endpoint for searching for users as part of longer running tasks
   * @param data The data for the request.
   * @param data.data
   * @returns ServiceUserAccountViewResponse
   * @throws ApiError
   */
  public static postV1UserManagementServiceUsers(
    data: PostV1UserManagementServiceUsersData
  ): CancelablePromise<PostV1UserManagementServiceUsersResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/service/users",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns ChildUserRegistrationResponse
   * @throws ApiError
   */
  public static postV1UserManagementServiceUsersRegistration(
    data: PostV1UserManagementServiceUsersRegistrationData
  ): CancelablePromise<PostV1UserManagementServiceUsersRegistrationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/service/users/registration",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @returns OrganizationTokenRefreshResponse
   * @throws ApiError
   */
  public static postV1UserManagementTokenOrganizationByOrganizationIdRefresh(
    data: PostV1UserManagementTokenOrganizationByOrganizationIdRefreshData
  ): CancelablePromise<PostV1UserManagementTokenOrganizationByOrganizationIdRefreshResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/token/organization/{organization_id}/refresh",
      path: {
        organization_id: data.organizationId
      }
    });
  }

  /**
   * @returns TokenRefreshResponse
   * @throws ApiError
   */
  public static postV1UserManagementTokenRefresh(): CancelablePromise<PostV1UserManagementTokenRefreshResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/token/refresh"
    });
  }

  /**
   * Basic public profile information for users.
   * @param data The data for the request.
   * @param data.data
   * @returns UserWorkspacePublicProfileResponseView
   * @throws ApiError
   */
  public static postV1UserManagementUserWorkspacePublicProfiles(
    data: PostV1UserManagementUserWorkspacePublicProfilesData
  ): CancelablePromise<PostV1UserManagementUserWorkspacePublicProfilesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/user-workspace/public-profiles",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns UserWorkspacePIIDataEntryBulkView
   * @throws ApiError
   */
  public static postV1UserManagementUserWorkspaceUserPiiDataEntryBulk(
    data: PostV1UserManagementUserWorkspaceUserPiiDataEntryBulkData
  ): CancelablePromise<PostV1UserManagementUserWorkspaceUserPiiDataEntryBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/user-workspace/user-pii-data-entry-bulk",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntry(
    data: GetV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryData
  ): CancelablePromise<GetV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/user-management/user-workspace/{workspace_id}/user-pii-data-entry",
      path: {
        workspace_id: data.workspaceId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns UserWorkspacePIIDataEntryView
   * @throws ApiError
   */
  public static postV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntry(
    data: PostV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryData
  ): CancelablePromise<PostV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/user-workspace/{workspace_id}/user-pii-data-entry",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntry(
    data: DeleteV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryData
  ): CancelablePromise<DeleteV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/user-management/user-workspace/{workspace_id}/user-pii-data-entry",
      path: {
        workspace_id: data.workspaceId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryUpload(
    data: PostV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryUploadData
  ): CancelablePromise<PostV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/user-workspace/{workspace_id}/user-pii-data-entry/upload",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.userPiiDataEntryId
   * @returns UserWorkspacePIIDataEntryView
   * @throws ApiError
   */
  public static getV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryId(
    data: GetV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryIdData
  ): CancelablePromise<GetV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/user-management/user-workspace/{workspace_id}/user-pii-data-entry/{user_pii_data_entry_id}",
      path: {
        workspace_id: data.workspaceId,
        user_pii_data_entry_id: data.userPiiDataEntryId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.userPiiDataEntryId
   * @param data.data
   * @returns UserWorkspacePIIDataEntryView
   * @throws ApiError
   */
  public static patchV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryId(
    data: PatchV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryIdData
  ): CancelablePromise<PatchV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryIdResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/v1/user-management/user-workspace/{workspace_id}/user-pii-data-entry/{user_pii_data_entry_id}",
      path: {
        workspace_id: data.workspaceId,
        user_pii_data_entry_id: data.userPiiDataEntryId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.userPiiDataEntryId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryId(
    data: DeleteV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryIdData
  ): CancelablePromise<DeleteV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/user-management/user-workspace/{workspace_id}/user-pii-data-entry/{user_pii_data_entry_id}",
      path: {
        workspace_id: data.workspaceId,
        user_pii_data_entry_id: data.userPiiDataEntryId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1UserManagementUsers(
    data: GetV1UserManagementUsersData = {}
  ): CancelablePromise<GetV1UserManagementUsersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/user-management/users",
      query: {
        page: data.page
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1UserManagementUsersEmailVerificationConfirm(
    data: PostV1UserManagementUsersEmailVerificationConfirmData
  ): CancelablePromise<PostV1UserManagementUsersEmailVerificationConfirmResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/users/email-verification/confirm",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1UserManagementUsersEmailVerificationRequest(
    data: PostV1UserManagementUsersEmailVerificationRequestData
  ): CancelablePromise<PostV1UserManagementUsersEmailVerificationRequestResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/users/email-verification/request",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns GuestUserRegistrationResponse
   * @throws ApiError
   */
  public static postV1UserManagementUsersGuestUserRegistration(
    data: PostV1UserManagementUsersGuestUserRegistrationData
  ): CancelablePromise<PostV1UserManagementUsersGuestUserRegistrationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/users/guest-user-registration",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns GuestUserRegistrationResponse
   * @throws ApiError
   */
  public static postV1UserManagementUsersGuestUserRegistrationComplete(
    data: PostV1UserManagementUsersGuestUserRegistrationCompleteData
  ): CancelablePromise<PostV1UserManagementUsersGuestUserRegistrationCompleteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/users/guest-user-registration-complete",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1UserManagementUsersPasswordConfirm(
    data: PostV1UserManagementUsersPasswordConfirmData
  ): CancelablePromise<PostV1UserManagementUsersPasswordConfirmResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/users/password/confirm",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns ResetPasswordResponse
   * @throws ApiError
   */
  public static postV1UserManagementUsersPasswordReset(
    data: PostV1UserManagementUsersPasswordResetData
  ): CancelablePromise<PostV1UserManagementUsersPasswordResetResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/users/password/reset",
      body: data.data
    });
  }

  /**
   * Basic public profile information for users.
   * @param data The data for the request.
   * @param data.data
   * @returns UserAccountPublicProfileResponseView
   * @throws ApiError
   */
  public static postV1UserManagementUsersPublicProfiles(
    data: PostV1UserManagementUsersPublicProfilesData
  ): CancelablePromise<PostV1UserManagementUsersPublicProfilesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/users/public-profiles",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns UserRegistrationResponse
   * @throws ApiError
   */
  public static postV1UserManagementUsersRegistration(
    data: PostV1UserManagementUsersRegistrationData
  ): CancelablePromise<PostV1UserManagementUsersRegistrationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/users/registration",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1UserManagementUsersRegistrationUsernameAvailable(
    data: PostV1UserManagementUsersRegistrationUsernameAvailableData
  ): CancelablePromise<PostV1UserManagementUsersRegistrationUsernameAvailableResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/users/registration/username-available",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.codeId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1UserManagementUsersByCodeIdVerifyPhoneResend(
    data: PostV1UserManagementUsersByCodeIdVerifyPhoneResendData
  ): CancelablePromise<PostV1UserManagementUsersByCodeIdVerifyPhoneResendResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/users/{code_id}/verify-phone/resend",
      path: {
        code_id: data.codeId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.codeId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1UserManagementUsersByCodeIdVerifyPhoneVerify(
    data: PostV1UserManagementUsersByCodeIdVerifyPhoneVerifyData
  ): CancelablePromise<PostV1UserManagementUsersByCodeIdVerifyPhoneVerifyResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/users/{code_id}/verify-phone/verify",
      path: {
        code_id: data.codeId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns UserAccountView
   * @throws ApiError
   */
  public static getV1UserManagementUsersByUserId(
    data: GetV1UserManagementUsersByUserIdData
  ): CancelablePromise<GetV1UserManagementUsersByUserIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/user-management/users/{user_id}",
      path: {
        user_id: data.userId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.data
   * @returns UserAccountView
   * @throws ApiError
   */
  public static patchV1UserManagementUsersByUserId(
    data: PatchV1UserManagementUsersByUserIdData
  ): CancelablePromise<PatchV1UserManagementUsersByUserIdResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/v1/user-management/users/{user_id}",
      path: {
        user_id: data.userId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1UserManagementUsersByUserId(
    data: DeleteV1UserManagementUsersByUserIdData
  ): CancelablePromise<DeleteV1UserManagementUsersByUserIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/user-management/users/{user_id}",
      path: {
        user_id: data.userId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1UserManagementUsersByUserIdEmail(
    data: PostV1UserManagementUsersByUserIdEmailData
  ): CancelablePromise<PostV1UserManagementUsersByUserIdEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/users/{user_id}/email",
      path: {
        user_id: data.userId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.data
   * @returns UserAccountView
   * @throws ApiError
   */
  public static postV1UserManagementUsersByUserIdGuestEmail(
    data: PostV1UserManagementUsersByUserIdGuestEmailData
  ): CancelablePromise<PostV1UserManagementUsersByUserIdGuestEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/users/{user_id}/guest-email",
      path: {
        user_id: data.userId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1UserManagementUsersByUserIdHardDelete(
    data: DeleteV1UserManagementUsersByUserIdHardDeleteData
  ): CancelablePromise<DeleteV1UserManagementUsersByUserIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/user-management/users/{user_id}/hard-delete",
      path: {
        user_id: data.userId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1UserManagementUsersByUserIdPassword(
    data: PostV1UserManagementUsersByUserIdPasswordData
  ): CancelablePromise<PostV1UserManagementUsersByUserIdPasswordResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/users/{user_id}/password",
      path: {
        user_id: data.userId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1UserManagementUsersByUserIdUserPiiDataEntry(
    data: GetV1UserManagementUsersByUserIdUserPiiDataEntryData
  ): CancelablePromise<GetV1UserManagementUsersByUserIdUserPiiDataEntryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/user-management/users/{user_id}/user-pii-data-entry",
      path: {
        user_id: data.userId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.data
   * @returns UserPIIDataEntryView
   * @throws ApiError
   */
  public static postV1UserManagementUsersByUserIdUserPiiDataEntry(
    data: PostV1UserManagementUsersByUserIdUserPiiDataEntryData
  ): CancelablePromise<PostV1UserManagementUsersByUserIdUserPiiDataEntryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/users/{user_id}/user-pii-data-entry",
      path: {
        user_id: data.userId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1UserManagementUsersByUserIdUserPiiDataEntry(
    data: DeleteV1UserManagementUsersByUserIdUserPiiDataEntryData
  ): CancelablePromise<DeleteV1UserManagementUsersByUserIdUserPiiDataEntryResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/user-management/users/{user_id}/user-pii-data-entry",
      path: {
        user_id: data.userId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1UserManagementUsersByUserIdUserPiiDataEntryUpload(
    data: PostV1UserManagementUsersByUserIdUserPiiDataEntryUploadData
  ): CancelablePromise<PostV1UserManagementUsersByUserIdUserPiiDataEntryUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/users/{user_id}/user-pii-data-entry/upload",
      path: {
        user_id: data.userId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.userPiiDataEntryId
   * @returns UserPIIDataEntryView
   * @throws ApiError
   */
  public static getV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryId(
    data: GetV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryIdData
  ): CancelablePromise<GetV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/user-management/users/{user_id}/user-pii-data-entry/{user_pii_data_entry_id}",
      path: {
        user_id: data.userId,
        user_pii_data_entry_id: data.userPiiDataEntryId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.userPiiDataEntryId
   * @param data.data
   * @returns UserPIIDataEntryView
   * @throws ApiError
   */
  public static patchV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryId(
    data: PatchV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryIdData
  ): CancelablePromise<PatchV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryIdResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/v1/user-management/users/{user_id}/user-pii-data-entry/{user_pii_data_entry_id}",
      path: {
        user_id: data.userId,
        user_pii_data_entry_id: data.userPiiDataEntryId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.userPiiDataEntryId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryId(
    data: DeleteV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryIdData
  ): CancelablePromise<DeleteV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/user-management/users/{user_id}/user-pii-data-entry/{user_pii_data_entry_id}",
      path: {
        user_id: data.userId,
        user_pii_data_entry_id: data.userPiiDataEntryId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.data
   * @returns MFACodeResponse
   * @throws ApiError
   */
  public static postV1UserManagementUsersByUserIdVerifyPhoneStart(
    data: PostV1UserManagementUsersByUserIdVerifyPhoneStartData
  ): CancelablePromise<PostV1UserManagementUsersByUserIdVerifyPhoneStartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/user-management/users/{user_id}/verify-phone/start",
      path: {
        user_id: data.userId
      },
      body: data.data
    });
  }

  /**
   * A viewset for clearing information as per the data retention policy (managed elsewhere)
   * @param data The data for the request.
   * @param data.data
   * @returns AccountOpsDataRetentionClearResponse
   * @throws ApiError
   */
  public static postV1OrganizationManagementAccountOpsDataRetentionClear(
    data: PostV1OrganizationManagementAccountOpsDataRetentionClearData
  ): CancelablePromise<PostV1OrganizationManagementAccountOpsDataRetentionClearResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/organization-management/account-ops/data-retention-clear",
      body: data.data
    });
  }

  /**
   * Provides a bulk member to organzation workspace lookup with organization owners
   * request.
   * @param data The data for the request.
   * @param data.data
   * @returns AccountOpsMemberOrganizationWorkspaceListResponseView
   * @throws ApiError
   */
  public static postV1OrganizationManagementAccountOpsMemberWorkspaceBulk(
    data: PostV1OrganizationManagementAccountOpsMemberWorkspaceBulkData
  ): CancelablePromise<PostV1OrganizationManagementAccountOpsMemberWorkspaceBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/organization-management/account-ops/member-workspace-bulk",
      body: data.data
    });
  }

  /**
   * Guest Family Registration Create views.
   * @param data The data for the request.
   * @param data.data
   * @returns GuestFamilyRegistrationCreateResponse
   * @throws ApiError
   */
  public static postV1OrganizationManagementGuestFamilyRegistrationCreate(
    data: PostV1OrganizationManagementGuestFamilyRegistrationCreateData
  ): CancelablePromise<PostV1OrganizationManagementGuestFamilyRegistrationCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/organization-management/guest-family-registration/create",
      body: data.data
    });
  }

  /**
   * Guest Family Registration Complete views.
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.data
   * @returns GuestFamilyRegistrationCompleteResponse
   * @throws ApiError
   */
  public static postV1OrganizationManagementGuestFamilyRegistrationByOrganizationIdComplete(
    data: PostV1OrganizationManagementGuestFamilyRegistrationByOrganizationIdCompleteData
  ): CancelablePromise<PostV1OrganizationManagementGuestFamilyRegistrationByOrganizationIdCompleteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/organization-management/guest-family-registration/{organization_id}/complete",
      path: {
        organization_id: data.organizationId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1OrganizationManagementInviteAccept(
    data: PostV1OrganizationManagementInviteAcceptData
  ): CancelablePromise<PostV1OrganizationManagementInviteAcceptResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/organization-management/invite/accept",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.inviteId
   * @returns OrganizationInviteView
   * @throws ApiError
   */
  public static getV1OrganizationManagementInviteByInviteId(
    data: GetV1OrganizationManagementInviteByInviteIdData
  ): CancelablePromise<GetV1OrganizationManagementInviteByInviteIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/organization-management/invite/{invite_id}",
      path: {
        invite_id: data.inviteId
      }
    });
  }

  /**
   * Provides a bulk member to organzation workspace lookup request.
   * @param data The data for the request.
   * @param data.data
   * @returns MemberOrganizationWorkspaceListResponseView
   * @throws ApiError
   */
  public static postV1OrganizationManagementMemberWorkspaceBulk(
    data: PostV1OrganizationManagementMemberWorkspaceBulkData
  ): CancelablePromise<PostV1OrganizationManagementMemberWorkspaceBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/organization-management/member-workspace-bulk",
      body: data.data
    });
  }

  /**
   * Provides a member organization lookup request.
   * @param data The data for the request.
   * @param data.userId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1OrganizationManagementMemberByUserId(
    data: GetV1OrganizationManagementMemberByUserIdData
  ): CancelablePromise<GetV1OrganizationManagementMemberByUserIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/organization-management/member/{user_id}",
      path: {
        user_id: data.userId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * Base organization views with permissions and accesses.
   * @param data The data for the request.
   * @param data.tags tags
   * @param data.excludeTags exclude__tags
   * @param data.includeTags include__tags
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1OrganizationManagementOrganization(
    data: GetV1OrganizationManagementOrganizationData = {}
  ): CancelablePromise<GetV1OrganizationManagementOrganizationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/organization-management/organization",
      query: {
        tags: data.tags,
        exclude__tags: data.excludeTags,
        include__tags: data.includeTags,
        page: data.page
      }
    });
  }

  /**
   * Base organization views with permissions and accesses.
   * @param data The data for the request.
   * @param data.data
   * @returns OrganizationCreateResponse
   * @throws ApiError
   */
  public static postV1OrganizationManagementOrganization(
    data: PostV1OrganizationManagementOrganizationData
  ): CancelablePromise<PostV1OrganizationManagementOrganizationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/organization-management/organization",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationMemberId
   * @returns OrganizationMemberView
   * @throws ApiError
   */
  public static getV1OrganizationManagementOrganizationMemberByOrganizationMemberId(
    data: GetV1OrganizationManagementOrganizationMemberByOrganizationMemberIdData
  ): CancelablePromise<GetV1OrganizationManagementOrganizationMemberByOrganizationMemberIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/organization-management/organization-member/{organization_member_id}",
      path: {
        organization_member_id: data.organizationMemberId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationMemberId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1OrganizationManagementOrganizationMemberByOrganizationMemberId(
    data: DeleteV1OrganizationManagementOrganizationMemberByOrganizationMemberIdData
  ): CancelablePromise<DeleteV1OrganizationManagementOrganizationMemberByOrganizationMemberIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/organization-management/organization-member/{organization_member_id}",
      path: {
        organization_member_id: data.organizationMemberId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns OrganizationWorkspacePIIDataEntryBulkView
   * @throws ApiError
   */
  public static postV1OrganizationManagementOrganizationWorkspaceOrganizationPiiDataEntryBulk(
    data: PostV1OrganizationManagementOrganizationWorkspaceOrganizationPiiDataEntryBulkData
  ): CancelablePromise<PostV1OrganizationManagementOrganizationWorkspaceOrganizationPiiDataEntryBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/organization-management/organization-workspace/organization-pii-data-entry-bulk",
      body: data.data
    });
  }

  /**
   * Organization workspace profile lookup view.
   * @param data The data for the request.
   * @param data.data
   * @returns OrganizationWorkspaceProfileResponse
   * @throws ApiError
   */
  public static postV1OrganizationManagementOrganizationWorkspaceProfiles(
    data: PostV1OrganizationManagementOrganizationWorkspaceProfilesData
  ): CancelablePromise<PostV1OrganizationManagementOrganizationWorkspaceProfilesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/organization-management/organization-workspace/profiles",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntry(
    data: GetV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryData
  ): CancelablePromise<GetV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/organization-management/organization-workspace/{workspace_id}/organization-pii-data-entry",
      path: {
        workspace_id: data.workspaceId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns OrganizationWorkspacePIIDataEntryView
   * @throws ApiError
   */
  public static postV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntry(
    data: PostV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryData
  ): CancelablePromise<PostV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/organization-management/organization-workspace/{workspace_id}/organization-pii-data-entry",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntry(
    data: DeleteV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryData
  ): CancelablePromise<DeleteV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/organization-management/organization-workspace/{workspace_id}/organization-pii-data-entry",
      path: {
        workspace_id: data.workspaceId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryUpload(
    data: PostV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryUploadData
  ): CancelablePromise<PostV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/organization-management/organization-workspace/{workspace_id}/organization-pii-data-entry/upload",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.organizationPiiDataEntryId
   * @returns OrganizationWorkspacePIIDataEntryView
   * @throws ApiError
   */
  public static getV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryId(
    data: GetV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdData
  ): CancelablePromise<GetV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/organization-management/organization-workspace/{workspace_id}/organization-pii-data-entry/{organization_pii_data_entry_id}",
      path: {
        workspace_id: data.workspaceId,
        organization_pii_data_entry_id: data.organizationPiiDataEntryId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.organizationPiiDataEntryId
   * @param data.data
   * @returns OrganizationWorkspacePIIDataEntryView
   * @throws ApiError
   */
  public static patchV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryId(
    data: PatchV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdData
  ): CancelablePromise<PatchV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/v1/organization-management/organization-workspace/{workspace_id}/organization-pii-data-entry/{organization_pii_data_entry_id}",
      path: {
        workspace_id: data.workspaceId,
        organization_pii_data_entry_id: data.organizationPiiDataEntryId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.organizationPiiDataEntryId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryId(
    data: DeleteV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdData
  ): CancelablePromise<DeleteV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/organization-management/organization-workspace/{workspace_id}/organization-pii-data-entry/{organization_pii_data_entry_id}",
      path: {
        workspace_id: data.workspaceId,
        organization_pii_data_entry_id: data.organizationPiiDataEntryId
      }
    });
  }

  /**
   * Organization profile lookup view.
   * @param data The data for the request.
   * @param data.data
   * @returns OrganizationProfileResponse
   * @throws ApiError
   */
  public static postV1OrganizationManagementOrganizationProfiles(
    data: PostV1OrganizationManagementOrganizationProfilesData
  ): CancelablePromise<PostV1OrganizationManagementOrganizationProfilesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/organization-management/organization/profiles",
      body: data.data
    });
  }

  /**
   * Base organization views with permissions and accesses.
   * @param data The data for the request.
   * @param data.organizationId
   * @returns OrganizationView
   * @throws ApiError
   */
  public static getV1OrganizationManagementOrganizationByOrganizationId(
    data: GetV1OrganizationManagementOrganizationByOrganizationIdData
  ): CancelablePromise<GetV1OrganizationManagementOrganizationByOrganizationIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/organization-management/organization/{organization_id}",
      path: {
        organization_id: data.organizationId
      }
    });
  }

  /**
   * Base organization views with permissions and accesses.
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.data
   * @returns OrganizationView
   * @throws ApiError
   */
  public static patchV1OrganizationManagementOrganizationByOrganizationId(
    data: PatchV1OrganizationManagementOrganizationByOrganizationIdData
  ): CancelablePromise<PatchV1OrganizationManagementOrganizationByOrganizationIdResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/v1/organization-management/organization/{organization_id}",
      path: {
        organization_id: data.organizationId
      },
      body: data.data
    });
  }

  /**
   * Base organization views with permissions and accesses.
   * @param data The data for the request.
   * @param data.organizationId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1OrganizationManagementOrganizationByOrganizationId(
    data: DeleteV1OrganizationManagementOrganizationByOrganizationIdData
  ): CancelablePromise<DeleteV1OrganizationManagementOrganizationByOrganizationIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/organization-management/organization/{organization_id}",
      path: {
        organization_id: data.organizationId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1OrganizationManagementOrganizationByOrganizationIdHardDelete(
    data: DeleteV1OrganizationManagementOrganizationByOrganizationIdHardDeleteData
  ): CancelablePromise<DeleteV1OrganizationManagementOrganizationByOrganizationIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/organization-management/organization/{organization_id}/hard-delete",
      path: {
        organization_id: data.organizationId
      }
    });
  }

  /**
   * Base organization views with custom permissions and accesses.
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1OrganizationManagementOrganizationByOrganizationIdInvite(
    data: GetV1OrganizationManagementOrganizationByOrganizationIdInviteData
  ): CancelablePromise<GetV1OrganizationManagementOrganizationByOrganizationIdInviteResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/organization-management/organization/{organization_id}/invite",
      path: {
        organization_id: data.organizationId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * Base organization views with custom permissions and accesses.
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.data
   * @returns OrganizationInviteView
   * @throws ApiError
   */
  public static postV1OrganizationManagementOrganizationByOrganizationIdInvite(
    data: PostV1OrganizationManagementOrganizationByOrganizationIdInviteData
  ): CancelablePromise<PostV1OrganizationManagementOrganizationByOrganizationIdInviteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/organization-management/organization/{organization_id}/invite",
      path: {
        organization_id: data.organizationId
      },
      body: data.data
    });
  }

  /**
   * Base organization views with custom permissions and accesses.
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.inviteId
   * @returns OrganizationInviteView
   * @throws ApiError
   */
  public static getV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteId(
    data: GetV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdData
  ): CancelablePromise<GetV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/organization-management/organization/{organization_id}/invite/{invite_id}",
      path: {
        organization_id: data.organizationId,
        invite_id: data.inviteId
      }
    });
  }

  /**
   * Base organization views with custom permissions and accesses.
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.inviteId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteId(
    data: DeleteV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdData
  ): CancelablePromise<DeleteV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/organization-management/organization/{organization_id}/invite/{invite_id}",
      path: {
        organization_id: data.organizationId,
        invite_id: data.inviteId
      }
    });
  }

  /**
   * Base organization views with custom permissions and accesses.
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.inviteId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdHardDelete(
    data: DeleteV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdHardDeleteData
  ): CancelablePromise<DeleteV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/organization-management/organization/{organization_id}/invite/{invite_id}/hard-delete",
      path: {
        organization_id: data.organizationId,
        invite_id: data.inviteId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.inviteId
   * @param data.data
   * @returns OrganizationInviteCreateResponse
   * @throws ApiError
   */
  public static postV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdResend(
    data: PostV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdResendData
  ): CancelablePromise<PostV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdResendResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/organization-management/organization/{organization_id}/invite/{invite_id}/resend",
      path: {
        organization_id: data.organizationId,
        invite_id: data.inviteId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1OrganizationManagementOrganizationByOrganizationIdMember(
    data: GetV1OrganizationManagementOrganizationByOrganizationIdMemberData
  ): CancelablePromise<GetV1OrganizationManagementOrganizationByOrganizationIdMemberResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/organization-management/organization/{organization_id}/member",
      path: {
        organization_id: data.organizationId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * Base organization views with custom permissions and accesses.
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.data
   * @returns OrganizationMemberChildCreate
   * @throws ApiError
   */
  public static postV1OrganizationManagementOrganizationByOrganizationIdMemberChild(
    data: PostV1OrganizationManagementOrganizationByOrganizationIdMemberChildData
  ): CancelablePromise<PostV1OrganizationManagementOrganizationByOrganizationIdMemberChildResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/organization-management/organization/{organization_id}/member-child",
      path: {
        organization_id: data.organizationId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.userId
   * @returns OrganizationMemberViewResponse
   * @throws ApiError
   */
  public static getV1OrganizationManagementOrganizationByOrganizationIdMemberByUserId(
    data: GetV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdData
  ): CancelablePromise<GetV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/organization-management/organization/{organization_id}/member/{user_id}",
      path: {
        organization_id: data.organizationId,
        user_id: data.userId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.userId
   * @param data.data
   * @returns OrganizationMemberChangeRole
   * @throws ApiError
   */
  public static patchV1OrganizationManagementOrganizationByOrganizationIdMemberByUserId(
    data: PatchV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdData
  ): CancelablePromise<PatchV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/v1/organization-management/organization/{organization_id}/member/{user_id}",
      path: {
        organization_id: data.organizationId,
        user_id: data.userId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.userId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1OrganizationManagementOrganizationByOrganizationIdMemberByUserId(
    data: DeleteV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdData
  ): CancelablePromise<DeleteV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/organization-management/organization/{organization_id}/member/{user_id}",
      path: {
        organization_id: data.organizationId,
        user_id: data.userId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.userId
   * @param data.page A page number within the paginated result set.
   * @returns OrganizationMemberRoleView
   * @throws ApiError
   */
  public static getV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdRole(
    data: GetV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdRoleData
  ): CancelablePromise<GetV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdRoleResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/organization-management/organization/{organization_id}/member/{user_id}/role",
      path: {
        organization_id: data.organizationId,
        user_id: data.userId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntry(
    data: GetV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryData
  ): CancelablePromise<GetV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/organization-management/organization/{organization_id}/organization-pii-data-entry",
      path: {
        organization_id: data.organizationId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.data
   * @returns OrganizationPIIDataEntryView
   * @throws ApiError
   */
  public static postV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntry(
    data: PostV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryData
  ): CancelablePromise<PostV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/organization-management/organization/{organization_id}/organization-pii-data-entry",
      path: {
        organization_id: data.organizationId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntry(
    data: DeleteV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryData
  ): CancelablePromise<DeleteV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/organization-management/organization/{organization_id}/organization-pii-data-entry",
      path: {
        organization_id: data.organizationId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryUpload(
    data: PostV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryUploadData
  ): CancelablePromise<PostV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/organization-management/organization/{organization_id}/organization-pii-data-entry/upload",
      path: {
        organization_id: data.organizationId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.organizationPiiDataEntryId
   * @returns OrganizationPIIDataEntryView
   * @throws ApiError
   */
  public static getV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryId(
    data: GetV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdData
  ): CancelablePromise<GetV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/organization-management/organization/{organization_id}/organization-pii-data-entry/{organization_pii_data_entry_id}",
      path: {
        organization_id: data.organizationId,
        organization_pii_data_entry_id: data.organizationPiiDataEntryId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.organizationPiiDataEntryId
   * @param data.data
   * @returns OrganizationPIIDataEntryView
   * @throws ApiError
   */
  public static patchV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryId(
    data: PatchV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdData
  ): CancelablePromise<PatchV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/v1/organization-management/organization/{organization_id}/organization-pii-data-entry/{organization_pii_data_entry_id}",
      path: {
        organization_id: data.organizationId,
        organization_pii_data_entry_id: data.organizationPiiDataEntryId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.organizationPiiDataEntryId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryId(
    data: DeleteV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdData
  ): CancelablePromise<DeleteV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/organization-management/organization/{organization_id}/organization-pii-data-entry/{organization_pii_data_entry_id}",
      path: {
        organization_id: data.organizationId,
        organization_pii_data_entry_id: data.organizationPiiDataEntryId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.data
   * @returns OrganizationSetParameterResponse
   * @throws ApiError
   */
  public static putV1OrganizationManagementOrganizationByOrganizationIdOwner(
    data: PutV1OrganizationManagementOrganizationByOrganizationIdOwnerData
  ): CancelablePromise<PutV1OrganizationManagementOrganizationByOrganizationIdOwnerResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/v1/organization-management/organization/{organization_id}/owner",
      path: {
        organization_id: data.organizationId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.data
   * @returns OrganizationSetParameterResponse
   * @throws ApiError
   */
  public static putV1OrganizationManagementOrganizationByOrganizationIdTags(
    data: PutV1OrganizationManagementOrganizationByOrganizationIdTagsData
  ): CancelablePromise<PutV1OrganizationManagementOrganizationByOrganizationIdTagsResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/v1/organization-management/organization/{organization_id}/tags",
      path: {
        organization_id: data.organizationId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1OrganizationManagementUserByUserIdInvite(
    data: GetV1OrganizationManagementUserByUserIdInviteData
  ): CancelablePromise<GetV1OrganizationManagementUserByUserIdInviteResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/organization-management/user/{user_id}/invite",
      path: {
        user_id: data.userId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * Search for a term among organization text.
   * @param data The data for the request.
   * @param data.tags tags
   * @param data.excludeTags exclude__tags
   * @param data.includeTags include__tags
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @param data.term The term to search for.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1SearchInternalOrganization(
    data: GetV1SearchInternalOrganizationData = {}
  ): CancelablePromise<GetV1SearchInternalOrganizationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/search/internal/organization",
      query: {
        tags: data.tags,
        exclude__tags: data.excludeTags,
        include__tags: data.includeTags,
        limit: data.limit,
        offset: data.offset,
        term: data.term
      }
    });
  }

  /**
   * Search for a term among organization text.
   * @param data The data for the request.
   * @param data.tags tags
   * @param data.excludeTags exclude__tags
   * @param data.includeTags include__tags
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @param data.term The term to search for.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1SearchOrganization(
    data: GetV1SearchOrganizationData = {}
  ): CancelablePromise<GetV1SearchOrganizationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/search/organization",
      query: {
        tags: data.tags,
        exclude__tags: data.excludeTags,
        include__tags: data.includeTags,
        limit: data.limit,
        offset: data.offset,
        term: data.term
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns ApiUserStatusResponse
   * @throws ApiError
   */
  public static getV1ApiUserApiUserByUserIdByUserId(
    data: GetV1ApiUserApiUserByUserIdByUserIdData
  ): CancelablePromise<GetV1ApiUserApiUserByUserIdByUserIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/api-user/api-user-by-user-id/{user_id}",
      path: {
        user_id: data.userId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1ApiUserApiUserByUserIdByUserId(
    data: DeleteV1ApiUserApiUserByUserIdByUserIdData
  ): CancelablePromise<DeleteV1ApiUserApiUserByUserIdByUserIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/api-user/api-user-by-user-id/{user_id}",
      path: {
        user_id: data.userId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1ApiUserApiUserByUserIdByUserIdHardDelete(
    data: DeleteV1ApiUserApiUserByUserIdByUserIdHardDeleteData
  ): CancelablePromise<DeleteV1ApiUserApiUserByUserIdByUserIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/api-user/api-user-by-user-id/{user_id}/hard-delete",
      path: {
        user_id: data.userId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1ApiUserOrganizationByOrganizationId(
    data: GetV1ApiUserOrganizationByOrganizationIdData
  ): CancelablePromise<GetV1ApiUserOrganizationByOrganizationIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/api-user/organization/{organization_id}",
      path: {
        organization_id: data.organizationId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.data
   * @returns OrganizationApiUserView
   * @throws ApiError
   */
  public static postV1ApiUserOrganizationByOrganizationId(
    data: PostV1ApiUserOrganizationByOrganizationIdData
  ): CancelablePromise<PostV1ApiUserOrganizationByOrganizationIdResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/api-user/organization/{organization_id}",
      path: {
        organization_id: data.organizationId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.apiUserId
   * @returns OrganizationApiUserView
   * @throws ApiError
   */
  public static getV1ApiUserOrganizationByOrganizationIdApiUserByApiUserId(
    data: GetV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdData
  ): CancelablePromise<GetV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/api-user/organization/{organization_id}/api-user/{api_user_id}",
      path: {
        organization_id: data.organizationId,
        api_user_id: data.apiUserId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.apiUserId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1ApiUserOrganizationByOrganizationIdApiUserByApiUserId(
    data: DeleteV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdData
  ): CancelablePromise<DeleteV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/api-user/organization/{organization_id}/api-user/{api_user_id}",
      path: {
        organization_id: data.organizationId,
        api_user_id: data.apiUserId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.apiUserId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdHardDelete(
    data: DeleteV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdHardDeleteData
  ): CancelablePromise<DeleteV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/api-user/organization/{organization_id}/api-user/{api_user_id}/hard-delete",
      path: {
        organization_id: data.organizationId,
        api_user_id: data.apiUserId
      }
    });
  }

  /**
   * A simple ViewSet for Looking at all Card Generations
   * associated with the system.
   * @param data The data for the request.
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1CardJamCard(
    data: GetV1CardJamCardData = {}
  ): CancelablePromise<GetV1CardJamCardResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/card",
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple ViewSet for creating CardPacks and uploading sample
   * photos of the various pieces
   * @param data The data for the request.
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1CardJamCardPack(
    data: GetV1CardJamCardPackData = {}
  ): CancelablePromise<GetV1CardJamCardPackResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/card-pack",
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple ViewSet for creating CardPacks and uploading sample
   * photos of the various pieces
   * @param data The data for the request.
   * @param data.data
   * @returns CardPackResponse
   * @throws ApiError
   */
  public static postV1CardJamCardPack(
    data: PostV1CardJamCardPackData
  ): CancelablePromise<PostV1CardJamCardPackResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/card-pack",
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing and deleting individual CardPacks
   * @param data The data for the request.
   * @param data.cardPackId
   * @returns CardPackResponse
   * @throws ApiError
   */
  public static getV1CardJamCardPackByCardPackId(
    data: GetV1CardJamCardPackByCardPackIdData
  ): CancelablePromise<GetV1CardJamCardPackByCardPackIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/card-pack/{card_pack_id}",
      path: {
        card_pack_id: data.cardPackId
      }
    });
  }

  /**
   * A simple ViewSet for viewing and deleting individual CardPacks
   * @param data The data for the request.
   * @param data.cardPackId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1CardJamCardPackByCardPackId(
    data: DeleteV1CardJamCardPackByCardPackIdData
  ): CancelablePromise<DeleteV1CardJamCardPackByCardPackIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/card-jam/card-pack/{card_pack_id}",
      path: {
        card_pack_id: data.cardPackId
      }
    });
  }

  /**
   * A simple ViewSet for viewing and deleting individual CardPacks
   * @param data The data for the request.
   * @param data.cardPackId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1CardJamCardPackByCardPackIdHardDelete(
    data: DeleteV1CardJamCardPackByCardPackIdHardDeleteData
  ): CancelablePromise<DeleteV1CardJamCardPackByCardPackIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/card-jam/card-pack/{card_pack_id}/hard-delete",
      path: {
        card_pack_id: data.cardPackId
      }
    });
  }

  /**
   * A simple ViewSet for creating CardSets and uploading sample
   * photos of the various pieces
   * @param data The data for the request.
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1CardJamCardSet(
    data: GetV1CardJamCardSetData = {}
  ): CancelablePromise<GetV1CardJamCardSetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/card-set",
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple ViewSet for creating CardSets and uploading sample
   * photos of the various pieces
   * @param data The data for the request.
   * @param data.data
   * @returns CardSetResponse
   * @throws ApiError
   */
  public static postV1CardJamCardSet(
    data: PostV1CardJamCardSetData
  ): CancelablePromise<PostV1CardJamCardSetResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/card-set",
      body: data.data
    });
  }

  /**
   * A simple ViewSet for creating CardSetPack relationships
   * @param data The data for the request.
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1CardJamCardSetPack(
    data: GetV1CardJamCardSetPackData = {}
  ): CancelablePromise<GetV1CardJamCardSetPackResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/card-set-pack",
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple ViewSet for creating CardSetPack relationships
   * @param data The data for the request.
   * @param data.data
   * @returns CardSetPackResponse
   * @throws ApiError
   */
  public static postV1CardJamCardSetPack(
    data: PostV1CardJamCardSetPackData
  ): CancelablePromise<PostV1CardJamCardSetPackResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/card-set-pack",
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing and deleting individual CardSets
   * @param data The data for the request.
   * @param data.cardSetId
   * @param data.cardSetPackType
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1CardJamCardSetPackCardSetByCardSetIdCardSetPackTypeByCardSetPackType(
    data: GetV1CardJamCardSetPackCardSetByCardSetIdCardSetPackTypeByCardSetPackTypeData
  ): CancelablePromise<GetV1CardJamCardSetPackCardSetByCardSetIdCardSetPackTypeByCardSetPackTypeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/card-set-pack/card-set/{card_set_id}/card-set-pack-type/{card_set_pack_type}",
      path: {
        card_set_id: data.cardSetId,
        card_set_pack_type: data.cardSetPackType
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple ViewSet for viewing and deleting individual CardSets
   * @param data The data for the request.
   * @param data.cardSetPackId
   * @returns CardSetPackResponse
   * @throws ApiError
   */
  public static getV1CardJamCardSetPackByCardSetPackId(
    data: GetV1CardJamCardSetPackByCardSetPackIdData
  ): CancelablePromise<GetV1CardJamCardSetPackByCardSetPackIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/card-set-pack/{card_set_pack_id}",
      path: {
        card_set_pack_id: data.cardSetPackId
      }
    });
  }

  /**
   * A simple ViewSet for viewing and deleting individual CardSets
   * @param data The data for the request.
   * @param data.cardSetPackId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1CardJamCardSetPackByCardSetPackId(
    data: DeleteV1CardJamCardSetPackByCardSetPackIdData
  ): CancelablePromise<DeleteV1CardJamCardSetPackByCardSetPackIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/card-jam/card-set-pack/{card_set_pack_id}",
      path: {
        card_set_pack_id: data.cardSetPackId
      }
    });
  }

  /**
   * A simple ViewSet for viewing and deleting individual CardSets
   * @param data The data for the request.
   * @param data.cardSetPackId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1CardJamCardSetPackByCardSetPackIdHardDelete(
    data: DeleteV1CardJamCardSetPackByCardSetPackIdHardDeleteData
  ): CancelablePromise<DeleteV1CardJamCardSetPackByCardSetPackIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/card-jam/card-set-pack/{card_set_pack_id}/hard-delete",
      path: {
        card_set_pack_id: data.cardSetPackId
      }
    });
  }

  /**
   * A simple ViewSet for viewing and deleting individual CardSets
   * @param data The data for the request.
   * @param data.cardSetId
   * @returns CardSetResponse
   * @throws ApiError
   */
  public static getV1CardJamCardSetByCardSetId(
    data: GetV1CardJamCardSetByCardSetIdData
  ): CancelablePromise<GetV1CardJamCardSetByCardSetIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/card-set/{card_set_id}",
      path: {
        card_set_id: data.cardSetId
      }
    });
  }

  /**
   * A simple ViewSet for viewing and deleting individual CardSets
   * @param data The data for the request.
   * @param data.cardSetId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1CardJamCardSetByCardSetId(
    data: DeleteV1CardJamCardSetByCardSetIdData
  ): CancelablePromise<DeleteV1CardJamCardSetByCardSetIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/card-jam/card-set/{card_set_id}",
      path: {
        card_set_id: data.cardSetId
      }
    });
  }

  /**
   * A simple ViewSet for viewing and deleting individual CardSets
   * @param data The data for the request.
   * @param data.cardSetId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1CardJamCardSetByCardSetIdHardDelete(
    data: DeleteV1CardJamCardSetByCardSetIdHardDeleteData
  ): CancelablePromise<DeleteV1CardJamCardSetByCardSetIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/card-jam/card-set/{card_set_id}/hard-delete",
      path: {
        card_set_id: data.cardSetId
      }
    });
  }

  /**
   * A simple ViewSet for determining if a Build is valid
   * @param data The data for the request.
   * @param data.cardSetId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1CardJamCardSetByCardSetIdValidate(
    data: PostV1CardJamCardSetByCardSetIdValidateData
  ): CancelablePromise<PostV1CardJamCardSetByCardSetIdValidateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/card-set/{card_set_id}/validate",
      path: {
        card_set_id: data.cardSetId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for creating CardVariantAttribute asset data
   * @param data The data for the request.
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1CardJamCardVariantAttribute(
    data: GetV1CardJamCardVariantAttributeData = {}
  ): CancelablePromise<GetV1CardJamCardVariantAttributeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/card-variant-attribute",
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple ViewSet for creating CardVariantAttribute asset data
   * @param data The data for the request.
   * @param data.data
   * @returns CardVariantAttributeView
   * @throws ApiError
   */
  public static postV1CardJamCardVariantAttribute(
    data: PostV1CardJamCardVariantAttributeData
  ): CancelablePromise<PostV1CardJamCardVariantAttributeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/card-variant-attribute",
      body: data.data
    });
  }

  /**
   * A simple ViewSet for creating CardVariantAttribute asset data raw
   * @param data The data for the request.
   * @param data.data
   * @returns CardVariantAttributeView
   * @throws ApiError
   */
  public static postV1CardJamCardVariantAttributeRaw(
    data: PostV1CardJamCardVariantAttributeRawData
  ): CancelablePromise<PostV1CardJamCardVariantAttributeRawResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/card-variant-attribute-raw",
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing and updating CardVariantAttribute asset data
   * @param data The data for the request.
   * @param data.cardVariantAttribute
   * @returns CardVariantAttributeView
   * @throws ApiError
   */
  public static getV1CardJamCardVariantAttributeByCardVariantAttribute(
    data: GetV1CardJamCardVariantAttributeByCardVariantAttributeData
  ): CancelablePromise<GetV1CardJamCardVariantAttributeByCardVariantAttributeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/card-variant-attribute/{card_variant_attribute}",
      path: {
        card_variant_attribute: data.cardVariantAttribute
      }
    });
  }

  /**
   * A simple ViewSet for viewing and updating CardVariantAttribute asset data
   * @param data The data for the request.
   * @param data.cardVariantAttribute
   * @param data.data
   * @returns CardVariantAttributeView
   * @throws ApiError
   */
  public static postV1CardJamCardVariantAttributeByCardVariantAttribute(
    data: PostV1CardJamCardVariantAttributeByCardVariantAttributeData
  ): CancelablePromise<PostV1CardJamCardVariantAttributeByCardVariantAttributeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/card-variant-attribute/{card_variant_attribute}",
      path: {
        card_variant_attribute: data.cardVariantAttribute
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for hard delete CardVariantAttribute asset data
   * @param data The data for the request.
   * @param data.cardVariantAttribute
   * @returns void
   * @throws ApiError
   */
  public static deleteV1CardJamCardVariantAttributeByCardVariantAttributeHardDelete(
    data: DeleteV1CardJamCardVariantAttributeByCardVariantAttributeHardDeleteData
  ): CancelablePromise<DeleteV1CardJamCardVariantAttributeByCardVariantAttributeHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/card-jam/card-variant-attribute/{card_variant_attribute}/hard-delete",
      path: {
        card_variant_attribute: data.cardVariantAttribute
      }
    });
  }

  /**
   * An internal Viewset for other systems to bulk gather card
   * download links.
   * @param data The data for the request.
   * @param data.data
   * @returns ServiceCardsDownloadView
   * @throws ApiError
   */
  public static postV1CardJamLocalAdminCardDownloads(
    data: PostV1CardJamLocalAdminCardDownloadsData
  ): CancelablePromise<PostV1CardJamLocalAdminCardDownloadsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/local-admin/card-downloads",
      body: data.data
    });
  }

  /**
   * A simple ViewSet for uploading a card to a workspace.
   * @param data The data for the request.
   * @param data.data
   * @returns CardOpView
   * @throws ApiError
   */
  public static postV1CardJamLocalAdminCardUpload(
    data: PostV1CardJamLocalAdminCardUploadData
  ): CancelablePromise<PostV1CardJamLocalAdminCardUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/local-admin/card-upload",
      body: data.data
    });
  }

  /**
   * A simple endpoint for adding Marketing campaigns and
   * view existing marketing campaigns
   * @param data The data for the request.
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1CardJamMarketingCampaign(
    data: GetV1CardJamMarketingCampaignData = {}
  ): CancelablePromise<GetV1CardJamMarketingCampaignResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/marketing-campaign",
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple endpoint for adding Marketing campaigns and
   * view existing marketing campaigns
   * @param data The data for the request.
   * @param data.data
   * @returns MarketingCampaignResponse
   * @throws ApiError
   */
  public static postV1CardJamMarketingCampaign(
    data: PostV1CardJamMarketingCampaignData
  ): CancelablePromise<PostV1CardJamMarketingCampaignResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/marketing-campaign",
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing Marketing Campaigns
   * @param data The data for the request.
   * @param data.marketingCampaignId
   * @returns MarketingCampaignResponse
   * @throws ApiError
   */
  public static getV1CardJamMarketingCampaignByMarketingCampaignId(
    data: GetV1CardJamMarketingCampaignByMarketingCampaignIdData
  ): CancelablePromise<GetV1CardJamMarketingCampaignByMarketingCampaignIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/marketing-campaign/{marketing_campaign_id}",
      path: {
        marketing_campaign_id: data.marketingCampaignId
      }
    });
  }

  /**
   * A simple ViewSet for activating a Marketing Campaign
   * @param data The data for the request.
   * @param data.marketingCampaignId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1CardJamMarketingCampaignByMarketingCampaignIdActivate(
    data: PostV1CardJamMarketingCampaignByMarketingCampaignIdActivateData
  ): CancelablePromise<PostV1CardJamMarketingCampaignByMarketingCampaignIdActivateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/marketing-campaign/{marketing_campaign_id}/activate",
      path: {
        marketing_campaign_id: data.marketingCampaignId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for Adding Card Packs to a marketing campaign
   * @param data The data for the request.
   * @param data.marketingCampaignId
   * @param data.data
   * @returns MarketingCampaignCardPackResponse
   * @throws ApiError
   */
  public static postV1CardJamMarketingCampaignByMarketingCampaignIdCardPack(
    data: PostV1CardJamMarketingCampaignByMarketingCampaignIdCardPackData
  ): CancelablePromise<PostV1CardJamMarketingCampaignByMarketingCampaignIdCardPackResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/marketing-campaign/{marketing_campaign_id}/card-pack",
      path: {
        marketing_campaign_id: data.marketingCampaignId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for Deleting Card Packs from a marketing campaign
   * @param data The data for the request.
   * @param data.marketingCampaignId
   * @param data.marketingCampaignCardPackId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1CardJamMarketingCampaignByMarketingCampaignIdCardPackByMarketingCampaignCardPackId(
    data: DeleteV1CardJamMarketingCampaignByMarketingCampaignIdCardPackByMarketingCampaignCardPackIdData
  ): CancelablePromise<DeleteV1CardJamMarketingCampaignByMarketingCampaignIdCardPackByMarketingCampaignCardPackIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/card-jam/marketing-campaign/{marketing_campaign_id}/card-pack/{marketing_campaign_card_pack_id}",
      path: {
        marketing_campaign_id: data.marketingCampaignId,
        marketing_campaign_card_pack_id: data.marketingCampaignCardPackId
      }
    });
  }

  /**
   * A simple ViewSet for deactivating a Marketing Campaign
   * @param data The data for the request.
   * @param data.marketingCampaignId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1CardJamMarketingCampaignByMarketingCampaignIdDeactivate(
    data: PostV1CardJamMarketingCampaignByMarketingCampaignIdDeactivateData
  ): CancelablePromise<PostV1CardJamMarketingCampaignByMarketingCampaignIdDeactivateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/marketing-campaign/{marketing_campaign_id}/deactivate",
      path: {
        marketing_campaign_id: data.marketingCampaignId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for hard deleting Marketing Campaigns
   * @param data The data for the request.
   * @param data.marketingCampaignId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1CardJamMarketingCampaignByMarketingCampaignIdHardDelete(
    data: DeleteV1CardJamMarketingCampaignByMarketingCampaignIdHardDeleteData
  ): CancelablePromise<DeleteV1CardJamMarketingCampaignByMarketingCampaignIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/card-jam/marketing-campaign/{marketing_campaign_id}/hard-delete",
      path: {
        marketing_campaign_id: data.marketingCampaignId
      }
    });
  }

  /**
   * A simple ViewSet for starting Card Generation within a workspace
   * associated with the system and looking up existing Cards.
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1CardJamWorkspaceByWorkspaceIdCard(
    data: GetV1CardJamWorkspaceByWorkspaceIdCardData
  ): CancelablePromise<GetV1CardJamWorkspaceByWorkspaceIdCardResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/workspace/{workspace_id}/card",
      path: {
        workspace_id: data.workspaceId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple ViewSet for starting Card Generation within a workspace
   * associated with the system and looking up existing Cards.
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns CardOpView
   * @throws ApiError
   */
  public static postV1CardJamWorkspaceByWorkspaceIdCard(
    data: PostV1CardJamWorkspaceByWorkspaceIdCardData
  ): CancelablePromise<PostV1CardJamWorkspaceByWorkspaceIdCardResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/workspace/{workspace_id}/card",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple view for adding Attributes to a user's workspace and view the attributes
   * available on a user's workspace
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1CardJamWorkspaceByWorkspaceIdCardAttribute(
    data: GetV1CardJamWorkspaceByWorkspaceIdCardAttributeData
  ): CancelablePromise<GetV1CardJamWorkspaceByWorkspaceIdCardAttributeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/workspace/{workspace_id}/card-attribute",
      path: {
        workspace_id: data.workspaceId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple view for adding Attributes to a user's workspace and view the attributes
   * available on a user's workspace
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns CardAttributeResponse
   * @throws ApiError
   */
  public static postV1CardJamWorkspaceByWorkspaceIdCardAttribute(
    data: PostV1CardJamWorkspaceByWorkspaceIdCardAttributeData
  ): CancelablePromise<PostV1CardJamWorkspaceByWorkspaceIdCardAttributeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/workspace/{workspace_id}/card-attribute",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple view for decreasing Attributes in a user's workspace
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns CardAttributeResponse
   * @returns void
   * @throws ApiError
   */
  public static postV1CardJamWorkspaceByWorkspaceIdCardAttributeDecrease(
    data: PostV1CardJamWorkspaceByWorkspaceIdCardAttributeDecreaseData
  ): CancelablePromise<PostV1CardJamWorkspaceByWorkspaceIdCardAttributeDecreaseResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/workspace/{workspace_id}/card-attribute/decrease",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple view for increasing Attributes in a user's workspace
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns CardAttributeResponse
   * @throws ApiError
   */
  public static postV1CardJamWorkspaceByWorkspaceIdCardAttributeIncrease(
    data: PostV1CardJamWorkspaceByWorkspaceIdCardAttributeIncreaseData
  ): CancelablePromise<PostV1CardJamWorkspaceByWorkspaceIdCardAttributeIncreaseResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/workspace/{workspace_id}/card-attribute/increase",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing individually owned Card Attributes
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardAttributeId
   * @returns CardAttributeResponse
   * @throws ApiError
   */
  public static getV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeId(
    data: GetV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeIdData
  ): CancelablePromise<GetV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/workspace/{workspace_id}/card-attribute/{card_attribute_id}",
      path: {
        workspace_id: data.workspaceId,
        card_attribute_id: data.cardAttributeId
      }
    });
  }

  /**
   * A simple ViewSet for hard deleting individual CardAttributes
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardAttributeId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeIdHardDelete(
    data: DeleteV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeIdHardDeleteData
  ): CancelablePromise<DeleteV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/card-jam/workspace/{workspace_id}/card-attribute/{card_attribute_id}/hard-delete",
      path: {
        workspace_id: data.workspaceId,
        card_attribute_id: data.cardAttributeId
      }
    });
  }

  /**
   * A simple design for adding Designs to a user's workspace and view the designs
   * available on a user's workspace
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1CardJamWorkspaceByWorkspaceIdCardDesign(
    data: GetV1CardJamWorkspaceByWorkspaceIdCardDesignData
  ): CancelablePromise<GetV1CardJamWorkspaceByWorkspaceIdCardDesignResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/workspace/{workspace_id}/card-design",
      path: {
        workspace_id: data.workspaceId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple design for adding Designs to a user's workspace and view the designs
   * available on a user's workspace
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns CardDesignResponse
   * @throws ApiError
   */
  public static postV1CardJamWorkspaceByWorkspaceIdCardDesign(
    data: PostV1CardJamWorkspaceByWorkspaceIdCardDesignData
  ): CancelablePromise<PostV1CardJamWorkspaceByWorkspaceIdCardDesignResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/workspace/{workspace_id}/card-design",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple design for decreasing Designs in a user's workspace
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns CardDesignResponse
   * @returns void
   * @throws ApiError
   */
  public static postV1CardJamWorkspaceByWorkspaceIdCardDesignDecrease(
    data: PostV1CardJamWorkspaceByWorkspaceIdCardDesignDecreaseData
  ): CancelablePromise<PostV1CardJamWorkspaceByWorkspaceIdCardDesignDecreaseResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/workspace/{workspace_id}/card-design/decrease",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple design for increasing Designs in a user's workspace
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns CardDesignResponse
   * @throws ApiError
   */
  public static postV1CardJamWorkspaceByWorkspaceIdCardDesignIncrease(
    data: PostV1CardJamWorkspaceByWorkspaceIdCardDesignIncreaseData
  ): CancelablePromise<PostV1CardJamWorkspaceByWorkspaceIdCardDesignIncreaseResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/workspace/{workspace_id}/card-design/increase",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing individually owned Card Designs
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardDesignId
   * @returns CardDesignResponse
   * @throws ApiError
   */
  public static getV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignId(
    data: GetV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignIdData
  ): CancelablePromise<GetV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/workspace/{workspace_id}/card-design/{card_design_id}",
      path: {
        workspace_id: data.workspaceId,
        card_design_id: data.cardDesignId
      }
    });
  }

  /**
   * A simple ViewSet for hard deleting individual CardDesigns
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardDesignId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignIdHardDelete(
    data: DeleteV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignIdHardDeleteData
  ): CancelablePromise<DeleteV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/card-jam/workspace/{workspace_id}/card-design/{card_design_id}/hard-delete",
      path: {
        workspace_id: data.workspaceId,
        card_design_id: data.cardDesignId
      }
    });
  }

  /**
   * A simple ViewSet for starting Card Generation with full control
   * over card generation for users.
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns CardOpView
   * @throws ApiError
   */
  public static postV1CardJamWorkspaceByWorkspaceIdCardFull(
    data: PostV1CardJamWorkspaceByWorkspaceIdCardFullData
  ): CancelablePromise<PostV1CardJamWorkspaceByWorkspaceIdCardFullResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/workspace/{workspace_id}/card-full",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for starting Card Generation with full control
   * over card generation.
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns CardOpView
   * @throws ApiError
   */
  public static postV1CardJamWorkspaceByWorkspaceIdCardInternal(
    data: PostV1CardJamWorkspaceByWorkspaceIdCardInternalData
  ): CancelablePromise<PostV1CardJamWorkspaceByWorkspaceIdCardInternalResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/workspace/{workspace_id}/card-internal",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing CardSets of users and what CardDesigns and
   * CardAttributes they have access to
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1CardJamWorkspaceByWorkspaceIdCardSet(
    data: GetV1CardJamWorkspaceByWorkspaceIdCardSetData
  ): CancelablePromise<GetV1CardJamWorkspaceByWorkspaceIdCardSetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/workspace/{workspace_id}/card-set",
      path: {
        workspace_id: data.workspaceId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple ViewSet for viewing a CardSet of users and what CardDesigns and
   * CardAttributes they have access to
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardSetId
   * @returns WorkspaceCardSetResponse
   * @throws ApiError
   */
  public static getV1CardJamWorkspaceByWorkspaceIdCardSetByCardSetId(
    data: GetV1CardJamWorkspaceByWorkspaceIdCardSetByCardSetIdData
  ): CancelablePromise<GetV1CardJamWorkspaceByWorkspaceIdCardSetByCardSetIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/workspace/{workspace_id}/card-set/{card_set_id}",
      path: {
        workspace_id: data.workspaceId,
        card_set_id: data.cardSetId
      }
    });
  }

  /**
   * A simple ViewSet for viewing Card and Card Generation Status
   * associated with the system.
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardId
   * @returns SwaggerCardView
   * @throws ApiError
   */
  public static getV1CardJamWorkspaceByWorkspaceIdCardByCardId(
    data: GetV1CardJamWorkspaceByWorkspaceIdCardByCardIdData
  ): CancelablePromise<GetV1CardJamWorkspaceByWorkspaceIdCardByCardIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/workspace/{workspace_id}/card/{card_id}",
      path: {
        workspace_id: data.workspaceId,
        card_id: data.cardId
      }
    });
  }

  /**
   * A simple ViewSet for viewing Card and Card Generation Status
   * associated with the system.
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1CardJamWorkspaceByWorkspaceIdCardByCardId(
    data: DeleteV1CardJamWorkspaceByWorkspaceIdCardByCardIdData
  ): CancelablePromise<DeleteV1CardJamWorkspaceByWorkspaceIdCardByCardIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/card-jam/workspace/{workspace_id}/card/{card_id}",
      path: {
        workspace_id: data.workspaceId,
        card_id: data.cardId
      }
    });
  }

  /**
   * A simple ViewSet for Finalizing a Card Generation.
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardId
   * @param data.data
   * @returns CardView
   * @throws ApiError
   */
  public static postV1CardJamWorkspaceByWorkspaceIdCardByCardIdFinalize(
    data: PostV1CardJamWorkspaceByWorkspaceIdCardByCardIdFinalizeData
  ): CancelablePromise<PostV1CardJamWorkspaceByWorkspaceIdCardByCardIdFinalizeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/workspace/{workspace_id}/card/{card_id}/finalize",
      path: {
        workspace_id: data.workspaceId,
        card_id: data.cardId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for Updating Card Athlete Info and Requesting a new
   * Card Generation.
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardId
   * @param data.data
   * @returns CardView
   * @throws ApiError
   */
  public static postV1CardJamWorkspaceByWorkspaceIdCardByCardIdUpdate(
    data: PostV1CardJamWorkspaceByWorkspaceIdCardByCardIdUpdateData
  ): CancelablePromise<PostV1CardJamWorkspaceByWorkspaceIdCardByCardIdUpdateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/workspace/{workspace_id}/card/{card_id}/update",
      path: {
        workspace_id: data.workspaceId,
        card_id: data.cardId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for Updating Card Athlete Info and Requesting a new
   * Card Generation.
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardId
   * @param data.data
   * @returns CardOpView
   * @throws ApiError
   */
  public static postV1CardJamWorkspaceByWorkspaceIdCardByCardIdVariant(
    data: PostV1CardJamWorkspaceByWorkspaceIdCardByCardIdVariantData
  ): CancelablePromise<PostV1CardJamWorkspaceByWorkspaceIdCardByCardIdVariantResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/workspace/{workspace_id}/card/{card_id}/variant",
      path: {
        workspace_id: data.workspaceId,
        card_id: data.cardId
      },
      body: data.data
    });
  }

  /**
   * A simple endpoint for claiming the packs of a current marketing campaign.
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns MarketingCampaignClaimResponse
   * @throws ApiError
   */
  public static postV1CardJamWorkspaceByWorkspaceIdMarketingCampaignClaim(
    data: PostV1CardJamWorkspaceByWorkspaceIdMarketingCampaignClaimData
  ): CancelablePromise<PostV1CardJamWorkspaceByWorkspaceIdMarketingCampaignClaimResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/workspace/{workspace_id}/marketing-campaign-claim",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple endpoint for adding Unopened Card Packs to a user's workspace and
   * view the unopened card packs available on a user's workspace
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1CardJamWorkspaceByWorkspaceIdUnopenedCardPack(
    data: GetV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackData
  ): CancelablePromise<GetV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/workspace/{workspace_id}/unopened-card-pack",
      path: {
        workspace_id: data.workspaceId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple endpoint for adding Unopened Card Packs to a user's workspace and
   * view the unopened card packs available on a user's workspace
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns UnopenedCardPackCreateUpdateResponse
   * @throws ApiError
   */
  public static postV1CardJamWorkspaceByWorkspaceIdUnopenedCardPack(
    data: PostV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackData
  ): CancelablePromise<PostV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/workspace/{workspace_id}/unopened-card-pack",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple endpoint for decreasing Unopened Card Packs in a user's workspace
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns UnopenedCardPackCreateUpdateResponse
   * @returns void
   * @throws ApiError
   */
  public static postV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackDecrease(
    data: PostV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackDecreaseData
  ): CancelablePromise<PostV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackDecreaseResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/workspace/{workspace_id}/unopened-card-pack/decrease",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple endpoint for increasing Unopened Card Packs in a user's workspace
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns UnopenedCardPackCreateUpdateResponse
   * @throws ApiError
   */
  public static postV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackIncrease(
    data: PostV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackIncreaseData
  ): CancelablePromise<PostV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackIncreaseResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/workspace/{workspace_id}/unopened-card-pack/increase",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing individually owned Unopened Card Packs
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.unopenedCardPackId
   * @returns UnopenedCardPackResponse
   * @throws ApiError
   */
  public static getV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackId(
    data: GetV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdData
  ): CancelablePromise<GetV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-jam/workspace/{workspace_id}/unopened-card-pack/{unopened_card_pack_id}",
      path: {
        workspace_id: data.workspaceId,
        unopened_card_pack_id: data.unopenedCardPackId
      }
    });
  }

  /**
   * A simple ViewSet for hard deleting individual UnopenedCardPacks
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.unopenedCardPackId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdHardDelete(
    data: DeleteV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdHardDeleteData
  ): CancelablePromise<DeleteV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/card-jam/workspace/{workspace_id}/unopened-card-pack/{unopened_card_pack_id}/hard-delete",
      path: {
        workspace_id: data.workspaceId,
        unopened_card_pack_id: data.unopenedCardPackId
      }
    });
  }

  /**
   * A simple endpoint for opening unopened card packs in a user's workspace
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.unopenedCardPackId
   * @param data.data
   * @returns OpenUnopenedCardPackResponse
   * @throws ApiError
   */
  public static postV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdOpen(
    data: PostV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdOpenData
  ): CancelablePromise<PostV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdOpenResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-jam/workspace/{workspace_id}/unopened-card-pack/{unopened_card_pack_id}/open",
      path: {
        workspace_id: data.workspaceId,
        unopened_card_pack_id: data.unopenedCardPackId
      },
      body: data.data
    });
  }

  /**
   * A simple viewset forsending an abandoned cart email
   * @param data The data for the request.
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1OrderManagementAbandonedCartReminder(
    data: PostV1OrderManagementAbandonedCartReminderData
  ): CancelablePromise<PostV1OrderManagementAbandonedCartReminderResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/abandoned-cart-reminder",
      body: data.data
    });
  }

  /**
   * A viewset for updating an order's marketing_status (managed elsewhere)
   * @param data The data for the request.
   * @param data.data
   * @returns AccountOpsMarketingStatusUpdateResponse
   * @throws ApiError
   */
  public static postV1OrderManagementAccountOpsMarketingStatusUpdate(
    data: PostV1OrderManagementAccountOpsMarketingStatusUpdateData
  ): CancelablePromise<PostV1OrderManagementAccountOpsMarketingStatusUpdateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/account-ops/marketing-status-update",
      body: data.data
    });
  }

  /**
   * A simple endpoint for creating Free Card Coupons
   * @param data The data for the request.
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1OrderManagementDiscountCoupon(
    data: GetV1OrderManagementDiscountCouponData = {}
  ): CancelablePromise<GetV1OrderManagementDiscountCouponResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/order-management/discount-coupon",
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple endpoint for creating Free Card Coupons
   * @param data The data for the request.
   * @param data.data
   * @returns DiscountCouponView
   * @throws ApiError
   */
  public static postV1OrderManagementDiscountCoupon(
    data: PostV1OrderManagementDiscountCouponData
  ): CancelablePromise<PostV1OrderManagementDiscountCouponResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/discount-coupon",
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing a free card coupon details
   * @param data The data for the request.
   * @param data.discountCouponId
   * @returns DiscountCouponView
   * @throws ApiError
   */
  public static getV1OrderManagementDiscountCouponByDiscountCouponId(
    data: GetV1OrderManagementDiscountCouponByDiscountCouponIdData
  ): CancelablePromise<GetV1OrderManagementDiscountCouponByDiscountCouponIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/order-management/discount-coupon/{discount_coupon_id}",
      path: {
        discount_coupon_id: data.discountCouponId
      }
    });
  }

  /**
   * A simple ViewSet for deleting a free card coupon
   * @param data The data for the request.
   * @param data.discountCouponId
   * @returns DiscountCouponView
   * @throws ApiError
   */
  public static deleteV1OrderManagementDiscountCouponByDiscountCouponIdHardDelete(
    data: DeleteV1OrderManagementDiscountCouponByDiscountCouponIdHardDeleteData
  ): CancelablePromise<DeleteV1OrderManagementDiscountCouponByDiscountCouponIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/order-management/discount-coupon/{discount_coupon_id}/hard-delete",
      path: {
        discount_coupon_id: data.discountCouponId
      }
    });
  }

  /**
   * A simple endpoint for creating Free Card Coupons
   * @param data The data for the request.
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1OrderManagementFreeCardCoupon(
    data: GetV1OrderManagementFreeCardCouponData = {}
  ): CancelablePromise<GetV1OrderManagementFreeCardCouponResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/order-management/free-card-coupon",
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple endpoint for creating Free Card Coupons
   * @param data The data for the request.
   * @param data.data
   * @returns FreeCardCouponView
   * @throws ApiError
   */
  public static postV1OrderManagementFreeCardCoupon(
    data: PostV1OrderManagementFreeCardCouponData
  ): CancelablePromise<PostV1OrderManagementFreeCardCouponResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/free-card-coupon",
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing a free card coupon details
   * @param data The data for the request.
   * @param data.freeCardCouponId
   * @returns FreeCardCouponView
   * @throws ApiError
   */
  public static getV1OrderManagementFreeCardCouponByFreeCardCouponId(
    data: GetV1OrderManagementFreeCardCouponByFreeCardCouponIdData
  ): CancelablePromise<GetV1OrderManagementFreeCardCouponByFreeCardCouponIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/order-management/free-card-coupon/{free_card_coupon_id}",
      path: {
        free_card_coupon_id: data.freeCardCouponId
      }
    });
  }

  /**
   * A simple ViewSet for deleting a free card coupon
   * @param data The data for the request.
   * @param data.freeCardCouponId
   * @returns FreeCardCouponView
   * @throws ApiError
   */
  public static deleteV1OrderManagementFreeCardCouponByFreeCardCouponIdHardDelete(
    data: DeleteV1OrderManagementFreeCardCouponByFreeCardCouponIdHardDeleteData
  ): CancelablePromise<DeleteV1OrderManagementFreeCardCouponByFreeCardCouponIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/order-management/free-card-coupon/{free_card_coupon_id}/hard-delete",
      path: {
        free_card_coupon_id: data.freeCardCouponId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1OrderManagementOrder(
    data: GetV1OrderManagementOrderData = {}
  ): CancelablePromise<GetV1OrderManagementOrderResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/order-management/order",
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple viewset for changing the order state to printing started on a bulk basis
   * @param data The data for the request.
   * @param data.data
   * @returns OrderInternalOpView
   * @throws ApiError
   */
  public static postV1OrderManagementOrderPrintingStartedBulk(
    data: PostV1OrderManagementOrderPrintingStartedBulkData
  ): CancelablePromise<PostV1OrderManagementOrderPrintingStartedBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/order/printing-started-bulk",
      body: data.data
    });
  }

  /**
   * A simple viewset for changing the order state to shipped on a bulk basis
   * @param data The data for the request.
   * @param data.data
   * @returns OrderInternalOpView
   * @throws ApiError
   */
  public static postV1OrderManagementOrderShippedBulk(
    data: PostV1OrderManagementOrderShippedBulkData
  ): CancelablePromise<PostV1OrderManagementOrderShippedBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/order/shipped-bulk",
      body: data.data
    });
  }

  /**
   * A simple viewset for viewing a specific order
   * @param data The data for the request.
   * @param data.orderId
   * @returns OrderInternalView
   * @throws ApiError
   */
  public static getV1OrderManagementOrderByOrderId(
    data: GetV1OrderManagementOrderByOrderIdData
  ): CancelablePromise<GetV1OrderManagementOrderByOrderIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/order-management/order/{order_id}",
      path: {
        order_id: data.orderId
      }
    });
  }

  /**
   * A simple viewset for changing the order state
   * @param data The data for the request.
   * @param data.orderId
   * @param data.data
   * @returns OrderInternalOpView
   * @throws ApiError
   */
  public static postV1OrderManagementOrderByOrderIdPrintingStarted(
    data: PostV1OrderManagementOrderByOrderIdPrintingStartedData
  ): CancelablePromise<PostV1OrderManagementOrderByOrderIdPrintingStartedResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/order/{order_id}/printing-started",
      path: {
        order_id: data.orderId
      },
      body: data.data
    });
  }

  /**
   * A simple viewset for changing the order state
   * @param data The data for the request.
   * @param data.orderId
   * @param data.data
   * @returns OrderInternalOpView
   * @throws ApiError
   */
  public static postV1OrderManagementOrderByOrderIdShipped(
    data: PostV1OrderManagementOrderByOrderIdShippedData
  ): CancelablePromise<PostV1OrderManagementOrderByOrderIdShippedResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/order/{order_id}/shipped",
      path: {
        order_id: data.orderId
      },
      body: data.data
    });
  }

  /**
   * A simple design for adding ProductPrices to a user's workspace Cart
   * @param data The data for the request.
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1OrderManagementProductPrice(
    data: GetV1OrderManagementProductPriceData = {}
  ): CancelablePromise<GetV1OrderManagementProductPriceResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/order-management/product-price",
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple design for adding ProductPrices to a user's workspace Cart
   * @param data The data for the request.
   * @param data.data
   * @returns ProductPriceView
   * @throws ApiError
   */
  public static postV1OrderManagementProductPrice(
    data: PostV1OrderManagementProductPriceData
  ): CancelablePromise<PostV1OrderManagementProductPriceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/product-price",
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing specific product type pricing
   * @param data The data for the request.
   * @param data.productType
   * @returns ProductPriceView
   * @throws ApiError
   */
  public static getV1OrderManagementProductPriceProductTypeByProductType(
    data: GetV1OrderManagementProductPriceProductTypeByProductTypeData
  ): CancelablePromise<GetV1OrderManagementProductPriceProductTypeByProductTypeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/order-management/product-price-product-type/{product_type}",
      path: {
        product_type: data.productType
      }
    });
  }

  /**
   * A simple ViewSet for viewing and editing individual Product Prices
   * @param data The data for the request.
   * @param data.productPriceId
   * @returns ProductPriceView
   * @throws ApiError
   */
  public static getV1OrderManagementProductPriceByProductPriceId(
    data: GetV1OrderManagementProductPriceByProductPriceIdData
  ): CancelablePromise<GetV1OrderManagementProductPriceByProductPriceIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/order-management/product-price/{product_price_id}",
      path: {
        product_price_id: data.productPriceId
      }
    });
  }

  /**
   * A simple ViewSet for viewing and editing individual Product Prices
   * @param data The data for the request.
   * @param data.productPriceId
   * @param data.data
   * @returns ProductPriceView
   * @throws ApiError
   */
  public static patchV1OrderManagementProductPriceByProductPriceId(
    data: PatchV1OrderManagementProductPriceByProductPriceIdData
  ): CancelablePromise<PatchV1OrderManagementProductPriceByProductPriceIdResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/v1/order-management/product-price/{product_price_id}",
      path: {
        product_price_id: data.productPriceId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing and editing individual Product Prices
   * @param data The data for the request.
   * @param data.productPriceId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1OrderManagementProductPriceByProductPriceId(
    data: DeleteV1OrderManagementProductPriceByProductPriceIdData
  ): CancelablePromise<DeleteV1OrderManagementProductPriceByProductPriceIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/order-management/product-price/{product_price_id}",
      path: {
        product_price_id: data.productPriceId
      }
    });
  }

  /**
   * A simple ViewSet for hard deleting individual Product Prices
   * @param data The data for the request.
   * @param data.productPriceId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1OrderManagementProductPriceByProductPriceIdHardDelete(
    data: DeleteV1OrderManagementProductPriceByProductPriceIdHardDeleteData
  ): CancelablePromise<DeleteV1OrderManagementProductPriceByProductPriceIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/order-management/product-price/{product_price_id}/hard-delete",
      path: {
        product_price_id: data.productPriceId
      }
    });
  }

  /**
   * A viewset for merging two account workspace ids
   * @param data The data for the request.
   * @param data.data
   * @returns AccountOpsAccountMergeResponse
   * @throws ApiError
   */
  public static postV1OrderManagementServiceAccountOpsAccountMerge(
    data: PostV1OrderManagementServiceAccountOpsAccountMergeData
  ): CancelablePromise<PostV1OrderManagementServiceAccountOpsAccountMergeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/service/account-ops/account-merge",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns AccountOpsDataRetentionClearResponse
   * @throws ApiError
   */
  public static postV1OrderManagementServiceAccountOpsDataRetentionClear(
    data: PostV1OrderManagementServiceAccountOpsDataRetentionClearData
  ): CancelablePromise<PostV1OrderManagementServiceAccountOpsDataRetentionClearResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/service/account-ops/data-retention-clear",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id id
   * @param data.orderStatus order_status
   * @param data.orderStatusIn order_status__in
   * @param data.active active
   * @param data.createdLt created__lt
   * @param data.createdGt created__gt
   * @param data.created created
   * @param data.marketingStatus marketing_status
   * @param data.marketingStatusIn marketing_status__in
   * @param data.orderByUserId order_by_user_id
   * @param data.workspaceId workspace_id
   * @param data.orderStatusNot order_status__not
   * @param data.orderStatusNotIn order_status__not__in
   * @param data.marketingStatusNot marketing_status__not
   * @param data.marketingStatusNotIn marketing_status__not__in
   * @param data.page A page number within the paginated result set.
   * @param data.pageSize Number of results to return per page.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1OrderManagementServiceOrder(
    data: GetV1OrderManagementServiceOrderData = {}
  ): CancelablePromise<GetV1OrderManagementServiceOrderResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/order-management/service/order",
      query: {
        id: data.id,
        order_status: data.orderStatus,
        order_status__in: data.orderStatusIn,
        active: data.active,
        created__lt: data.createdLt,
        created__gt: data.createdGt,
        created: data.created,
        marketing_status: data.marketingStatus,
        marketing_status__in: data.marketingStatusIn,
        order_by_user_id: data.orderByUserId,
        workspace_id: data.workspaceId,
        order_status__not: data.orderStatusNot,
        order_status__not__in: data.orderStatusNotIn,
        marketing_status__not: data.marketingStatusNot,
        marketing_status__not__in: data.marketingStatusNotIn,
        page: data.page,
        page_size: data.pageSize
      }
    });
  }

  /**
   * A viewset for getting order statistics of input workspace ids
   * @param data The data for the request.
   * @param data.data
   * @returns WorkspaceOrderStatisticsResponse
   * @throws ApiError
   */
  public static postV1OrderManagementServiceWorkspaceOrderStatistics(
    data: PostV1OrderManagementServiceWorkspaceOrderStatisticsData
  ): CancelablePromise<PostV1OrderManagementServiceWorkspaceOrderStatisticsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/service/workspace-order-statistics",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns OrderOpView
   * @throws ApiError
   */
  public static postV1OrderManagementServiceWorkspaceByWorkspaceIdCheckoutByOrderIdTimeout(
    data: PostV1OrderManagementServiceWorkspaceByWorkspaceIdCheckoutByOrderIdTimeoutData
  ): CancelablePromise<PostV1OrderManagementServiceWorkspaceByWorkspaceIdCheckoutByOrderIdTimeoutResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/service/workspace/{workspace_id}/checkout/{order_id}/timeout",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      }
    });
  }

  /**
   * A viewset to send the order confirmation email.
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmation(
    data: PostV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmationData
  ): CancelablePromise<PostV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/service/workspace/{workspace_id}/order/{order_id}/email/confirmation",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      body: data.data
    });
  }

  /**
   * A viewset to send the order update confirmation email.
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmation(
    data: PostV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmationData
  ): CancelablePromise<PostV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/service/workspace/{workspace_id}/order/{order_id}/email/update-confirmation",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      body: data.data
    });
  }

  /**
   * A viewset to send the order update in_process email.
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcess(
    data: PostV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcessData
  ): CancelablePromise<PostV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcessResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/service/workspace/{workspace_id}/order/{order_id}/email/update-in-process",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      body: data.data
    });
  }

  /**
   * A viewset to send the order update shipped email.
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShipped(
    data: PostV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShippedData
  ): CancelablePromise<PostV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShippedResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/service/workspace/{workspace_id}/order/{order_id}/email/update-shipped",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      body: data.data
    });
  }

  /**
   * A simple viewset for retrying the processing of stripe events
   * @param data The data for the request.
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1OrderManagementStripeRetry(
    data: PostV1OrderManagementStripeRetryData
  ): CancelablePromise<PostV1OrderManagementStripeRetryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/stripe/retry",
      body: data.data
    });
  }

  /**
   * A simple viewset for processing stripe webhook events
   * @returns void
   * @throws ApiError
   */
  public static postV1OrderManagementStripeWebhook(): CancelablePromise<PostV1OrderManagementStripeWebhookResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/stripe/webhook"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.page A page number within the paginated result set.
   * @param data.freeCardsToUse
   * @param data.discountCode
   * @returns CartFullView
   * @throws ApiError
   */
  public static getV1OrderManagementWorkspaceByWorkspaceIdCart(
    data: GetV1OrderManagementWorkspaceByWorkspaceIdCartData
  ): CancelablePromise<GetV1OrderManagementWorkspaceByWorkspaceIdCartResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/order-management/workspace/{workspace_id}/cart",
      path: {
        workspace_id: data.workspaceId
      },
      query: {
        page: data.page,
        free_cards_to_use: data.freeCardsToUse,
        discount_code: data.discountCode
      }
    });
  }

  /**
   * A simple design for adding CartItems to a user's workspace Cart
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1OrderManagementWorkspaceByWorkspaceIdCartCartItem(
    data: GetV1OrderManagementWorkspaceByWorkspaceIdCartCartItemData
  ): CancelablePromise<GetV1OrderManagementWorkspaceByWorkspaceIdCartCartItemResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/order-management/workspace/{workspace_id}/cart/cart-item",
      path: {
        workspace_id: data.workspaceId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple design for adding CartItems to a user's workspace Cart
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns CartItemView
   * @throws ApiError
   */
  public static postV1OrderManagementWorkspaceByWorkspaceIdCartCartItemCard(
    data: PostV1OrderManagementWorkspaceByWorkspaceIdCartCartItemCardData
  ): CancelablePromise<PostV1OrderManagementWorkspaceByWorkspaceIdCartCartItemCardResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/workspace/{workspace_id}/cart/cart-item/card",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple design for adding Team Cards to a user's workspace Cart
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns CartItemView
   * @throws ApiError
   */
  public static postV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamCard(
    data: PostV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamCardData
  ): CancelablePromise<PostV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamCardResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/workspace/{workspace_id}/cart/cart-item/team-card",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple design for adding Team Packs to a user's workspace Cart
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns CartItemView
   * @throws ApiError
   */
  public static postV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamPack(
    data: PostV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamPackData
  ): CancelablePromise<PostV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamPackResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/workspace/{workspace_id}/cart/cart-item/team-pack",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for viewing and editing individual Cart Items
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cartItemId
   * @returns CartItemView
   * @throws ApiError
   */
  public static getV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemId(
    data: GetV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdData
  ): CancelablePromise<GetV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/order-management/workspace/{workspace_id}/cart/cart-item/{cart_item_id}",
      path: {
        workspace_id: data.workspaceId,
        cart_item_id: data.cartItemId
      }
    });
  }

  /**
   * A simple ViewSet for viewing and editing individual Cart Items
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cartItemId
   * @param data.data
   * @returns CartItemView
   * @throws ApiError
   */
  public static patchV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemId(
    data: PatchV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdData
  ): CancelablePromise<PatchV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/v1/order-management/workspace/{workspace_id}/cart/cart-item/{cart_item_id}",
      path: {
        workspace_id: data.workspaceId,
        cart_item_id: data.cartItemId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for hard deleting individual Cart Items
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cartItemId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdHardDelete(
    data: DeleteV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdHardDeleteData
  ): CancelablePromise<DeleteV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/order-management/workspace/{workspace_id}/cart/cart-item/{cart_item_id}/hard-delete",
      path: {
        workspace_id: data.workspaceId,
        cart_item_id: data.cartItemId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns SwaggerCheckoutStartResponse
   * @throws ApiError
   */
  public static postV1OrderManagementWorkspaceByWorkspaceIdCheckoutStart(
    data: PostV1OrderManagementWorkspaceByWorkspaceIdCheckoutStartData
  ): CancelablePromise<PostV1OrderManagementWorkspaceByWorkspaceIdCheckoutStartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/workspace/{workspace_id}/checkout/start",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns OrderOpView
   * @throws ApiError
   */
  public static getV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderId(
    data: GetV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdData
  ): CancelablePromise<GetV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/order-management/workspace/{workspace_id}/checkout/{order_id}",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns OrderOpView
   * @throws ApiError
   */
  public static postV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCancel(
    data: PostV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCancelData
  ): CancelablePromise<PostV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCancelResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/workspace/{workspace_id}/checkout/{order_id}/cancel",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns OrderOpView
   * @throws ApiError
   */
  public static postV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCheckoutComplete(
    data: PostV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCheckoutCompleteData
  ): CancelablePromise<PostV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCheckoutCompleteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/workspace/{workspace_id}/checkout/{order_id}/checkout-complete",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      query: data
    });
  }

  /**
   * A simple ViewSet for viewing a workspace's free card count
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.page A page number within the paginated result set.
   * @returns WorkspaceFreeCardCountView
   * @throws ApiError
   */
  public static getV1OrderManagementWorkspaceByWorkspaceIdFreeCardCount(
    data: GetV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountData
  ): CancelablePromise<GetV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/order-management/workspace/{workspace_id}/free-card-count",
      path: {
        workspace_id: data.workspaceId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple endpoint for decreasing Free Card Count in a user's workspace
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns WorkspaceFreeCardCountView
   * @throws ApiError
   */
  public static postV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountDecrease(
    data: PostV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountDecreaseData
  ): CancelablePromise<PostV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountDecreaseResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/workspace/{workspace_id}/free-card-count/decrease",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple ViewSet for hard deleting individual FreeCardCounts
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountHardDelete(
    data: DeleteV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountHardDeleteData
  ): CancelablePromise<DeleteV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/order-management/workspace/{workspace_id}/free-card-count/hard-delete",
      path: {
        workspace_id: data.workspaceId
      }
    });
  }

  /**
   * A simple endpoint for increasing Free Card Count in a user's workspace
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns WorkspaceFreeCardCountView
   * @throws ApiError
   */
  public static postV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountIncrease(
    data: PostV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountIncreaseData
  ): CancelablePromise<PostV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountIncreaseResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/workspace/{workspace_id}/free-card-count/increase",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple endpoint for creating Free Card Coupons
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns FreeCardCouponClaimResponse
   * @throws ApiError
   */
  public static postV1OrderManagementWorkspaceByWorkspaceIdFreeCardCouponClaim(
    data: PostV1OrderManagementWorkspaceByWorkspaceIdFreeCardCouponClaimData
  ): CancelablePromise<PostV1OrderManagementWorkspaceByWorkspaceIdFreeCardCouponClaimResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/workspace/{workspace_id}/free-card-coupon-claim",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A simple viewset for viewing all orders on a workspace
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1OrderManagementWorkspaceByWorkspaceIdOrder(
    data: GetV1OrderManagementWorkspaceByWorkspaceIdOrderData
  ): CancelablePromise<GetV1OrderManagementWorkspaceByWorkspaceIdOrderResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/order-management/workspace/{workspace_id}/order",
      path: {
        workspace_id: data.workspaceId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * A simple viewset for viewing a specific order on a workspace
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns OrderView
   * @throws ApiError
   */
  public static getV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderId(
    data: GetV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdData
  ): CancelablePromise<GetV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/order-management/workspace/{workspace_id}/order/{order_id}",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      }
    });
  }

  /**
   * A viewset to send the order confirmation email. This will ignore all checks
   * and force a send.
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmation(
    data: PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmationData
  ): CancelablePromise<PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/workspace/{workspace_id}/order/{order_id}/email/confirmation",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      body: data.data
    });
  }

  /**
   * A viewset to send the order update confirmation email. This will ignore all checks
   * and force a send.
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmation(
    data: PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmationData
  ): CancelablePromise<PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/workspace/{workspace_id}/order/{order_id}/email/update-confirmation",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      body: data.data
    });
  }

  /**
   * A viewset to send the order update in_process email. This will ignore all checks
   * and force a send.
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcess(
    data: PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcessData
  ): CancelablePromise<PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcessResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/workspace/{workspace_id}/order/{order_id}/email/update-in-process",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      body: data.data
    });
  }

  /**
   * A viewset to send the order update shipped email. This will ignore all checks
   * and force a send.
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShipped(
    data: PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShippedData
  ): CancelablePromise<PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShippedResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/workspace/{workspace_id}/order/{order_id}/email/update-shipped",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      body: data.data
    });
  }

  /**
   * A simple viewset for viewing a specific order on a workspace
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdHardDelete(
    data: DeleteV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdHardDeleteData
  ): CancelablePromise<DeleteV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/order-management/workspace/{workspace_id}/order/{order_id}/hard-delete",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns OrderRewardResponse
   * @throws ApiError
   */
  public static postV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdRewardClaim(
    data: PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdRewardClaimData
  ): CancelablePromise<PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdRewardClaimResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/workspace/{workspace_id}/order/{order_id}/reward-claim",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @param data.data
   * @returns OrderUpdateCardsResponse
   * @throws ApiError
   */
  public static postV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdUpdateCards(
    data: PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdUpdateCardsData
  ): CancelablePromise<PostV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdUpdateCardsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/order-management/workspace/{workspace_id}/order/{order_id}/update-cards",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      body: data.data
    });
  }

  /**
   * A simple viewset for viewing the print card requests that need to be completed
   * @param data The data for the request.
   * @param data.printCardRequestStatus print_card_request_status
   * @param data.active active
   * @param data.printFinalizedTimeLt print_finalized_time__lt
   * @param data.printFinalizedTimeGt print_finalized_time__gt
   * @param data.printFinalizedTime print_finalized_time
   * @param data.page A page number within the paginated result set.
   * @param data.pageSize Number of results to return per page.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1CardPrintingLocalPrintCardRequest(
    data: GetV1CardPrintingLocalPrintCardRequestData = {}
  ): CancelablePromise<GetV1CardPrintingLocalPrintCardRequestResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-printing/local-print-card-request",
      query: {
        print_card_request_status: data.printCardRequestStatus,
        active: data.active,
        print_finalized_time__lt: data.printFinalizedTimeLt,
        print_finalized_time__gt: data.printFinalizedTimeGt,
        print_finalized_time: data.printFinalizedTime,
        page: data.page,
        page_size: data.pageSize
      }
    });
  }

  /**
   * A simple viewset to complete print card requests that need to be completed
   * @param data The data for the request.
   * @param data.data
   * @returns PrintCardRequestView
   * @throws ApiError
   */
  public static postV1CardPrintingLocalPrintCardRequestComplete(
    data: PostV1CardPrintingLocalPrintCardRequestCompleteData
  ): CancelablePromise<PostV1CardPrintingLocalPrintCardRequestCompleteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-printing/local-print-card-request-complete",
      body: data.data
    });
  }

  /**
   * A simple viewset for creating print card requests from orders
   * @param data The data for the request.
   * @param data.data
   * @returns PrintCardRequestView
   * @throws ApiError
   */
  public static postV1CardPrintingOrderPrintCardRequest(
    data: PostV1CardPrintingOrderPrintCardRequestData
  ): CancelablePromise<PostV1CardPrintingOrderPrintCardRequestResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-printing/order-print-card-request",
      body: data.data
    });
  }

  /**
   * A simple viewset for updating (by delete and create) print card requests from
   * existing order print card requests
   * @param data The data for the request.
   * @param data.data
   * @returns PrintCardRequestView
   * @throws ApiError
   */
  public static postV1CardPrintingOrderPrintCardRequestUpdate(
    data: PostV1CardPrintingOrderPrintCardRequestUpdateData
  ): CancelablePromise<PostV1CardPrintingOrderPrintCardRequestUpdateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-printing/order-print-card-request-update",
      body: data.data
    });
  }

  /**
   * A simple viewset for creating print card requests
   * @param data The data for the request.
   * @param data.data
   * @returns PrintCardRequestView
   * @throws ApiError
   */
  public static postV1CardPrintingPrintCardRequest(
    data: PostV1CardPrintingPrintCardRequestData
  ): CancelablePromise<PostV1CardPrintingPrintCardRequestResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-printing/print-card-request",
      body: data.data
    });
  }

  /**
   * A simple viewset for viewing and updating specific print card request
   * @param data The data for the request.
   * @param data.printCardRequestId
   * @returns PrintCardRequestView
   * @throws ApiError
   */
  public static getV1CardPrintingPrintCardRequestByPrintCardRequestId(
    data: GetV1CardPrintingPrintCardRequestByPrintCardRequestIdData
  ): CancelablePromise<GetV1CardPrintingPrintCardRequestByPrintCardRequestIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/card-printing/print-card-request/{print_card_request_id}",
      path: {
        print_card_request_id: data.printCardRequestId
      }
    });
  }

  /**
   * A simple viewset for viewing and updating specific print card request
   * @param data The data for the request.
   * @param data.printCardRequestId
   * @param data.data
   * @returns PrintCardRequestView
   * @throws ApiError
   */
  public static patchV1CardPrintingPrintCardRequestByPrintCardRequestId(
    data: PatchV1CardPrintingPrintCardRequestByPrintCardRequestIdData
  ): CancelablePromise<PatchV1CardPrintingPrintCardRequestByPrintCardRequestIdResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/v1/card-printing/print-card-request/{print_card_request_id}",
      path: {
        print_card_request_id: data.printCardRequestId
      },
      body: data.data
    });
  }

  /**
   * A simple viewset for viewing and updating specific print card request
   * @param data The data for the request.
   * @param data.printCardRequestId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1CardPrintingPrintCardRequestByPrintCardRequestId(
    data: DeleteV1CardPrintingPrintCardRequestByPrintCardRequestIdData
  ): CancelablePromise<DeleteV1CardPrintingPrintCardRequestByPrintCardRequestIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/card-printing/print-card-request/{print_card_request_id}",
      path: {
        print_card_request_id: data.printCardRequestId
      }
    });
  }

  /**
   * A viewset for merging two account workspace ids
   * @param data The data for the request.
   * @param data.data
   * @returns AccountOpsAccountMergeResponse
   * @throws ApiError
   */
  public static postV1CardPrintingServiceAccountOpsAccountMerge(
    data: PostV1CardPrintingServiceAccountOpsAccountMergeData
  ): CancelablePromise<PostV1CardPrintingServiceAccountOpsAccountMergeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/card-printing/service/account-ops/account-merge",
      body: data.data
    });
  }

  /**
   * A viewset to start iterating through data retention clears
   * @param data The data for the request.
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1AccountOpsDataRetentionRunStart(
    data: PostV1AccountOpsDataRetentionRunStartData
  ): CancelablePromise<PostV1AccountOpsDataRetentionRunStartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/account-ops/data-retention-run/start",
      body: data.data
    });
  }

  /**
   * A viewset to iterate through data retention clears from the cron system
   * @param data The data for the request.
   * @param data.dataRetentionRunId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1AccountOpsDataRetentionRunByDataRetentionRunIdClear(
    data: PostV1AccountOpsDataRetentionRunByDataRetentionRunIdClearData
  ): CancelablePromise<PostV1AccountOpsDataRetentionRunByDataRetentionRunIdClearResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/account-ops/data-retention-run/{data_retention_run_id}/clear",
      path: {
        data_retention_run_id: data.dataRetentionRunId
      },
      body: data.data
    });
  }

  /**
   * A viewset to iterate through data retention completes from the cron system
   * @param data The data for the request.
   * @param data.dataRetentionRunId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1AccountOpsDataRetentionRunByDataRetentionRunIdComplete(
    data: PostV1AccountOpsDataRetentionRunByDataRetentionRunIdCompleteData
  ): CancelablePromise<PostV1AccountOpsDataRetentionRunByDataRetentionRunIdCompleteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/account-ops/data-retention-run/{data_retention_run_id}/complete",
      path: {
        data_retention_run_id: data.dataRetentionRunId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns GuestUserLoginResponse
   * @throws ApiError
   */
  public static postV1AccountOpsGuestLogin(
    data: PostV1AccountOpsGuestLoginData
  ): CancelablePromise<PostV1AccountOpsGuestLoginResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/account-ops/guest/login",
      body: data.data,
      errors: {
        300: ""
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns GuestUserMFALoginCompleteResponse
   * @throws ApiError
   */
  public static postV1AccountOpsGuestMfaLoginComplete(
    data: PostV1AccountOpsGuestMfaLoginCompleteData
  ): CancelablePromise<PostV1AccountOpsGuestMfaLoginCompleteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/account-ops/guest/mfa-login/complete",
      body: data.data,
      errors: {
        300: ""
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns GuestUserMFALoginSendCodeResponse
   * @throws ApiError
   */
  public static postV1AccountOpsGuestMfaLoginSendCode(
    data: PostV1AccountOpsGuestMfaLoginSendCodeData
  ): CancelablePromise<PostV1AccountOpsGuestMfaLoginSendCodeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/account-ops/guest/mfa-login/send-code",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns GuestUserMFALoginStartResponse
   * @throws ApiError
   */
  public static postV1AccountOpsGuestMfaLoginStart(
    data: PostV1AccountOpsGuestMfaLoginStartData
  ): CancelablePromise<PostV1AccountOpsGuestMfaLoginStartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/account-ops/guest/mfa-login/start",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.codeId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1AccountOpsGuestMfaLoginByCodeIdResend(
    data: PostV1AccountOpsGuestMfaLoginByCodeIdResendData
  ): CancelablePromise<PostV1AccountOpsGuestMfaLoginByCodeIdResendResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/account-ops/guest/mfa-login/{code_id}/resend",
      path: {
        code_id: data.codeId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns GuestUserWorkspaceLoginResponse
   * @throws ApiError
   */
  public static postV1AccountOpsGuestWorkspaceByWorkspaceIdLogin(
    data: PostV1AccountOpsGuestWorkspaceByWorkspaceIdLoginData
  ): CancelablePromise<PostV1AccountOpsGuestWorkspaceByWorkspaceIdLoginResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/account-ops/guest/workspace/{workspace_id}/login",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.data
   * @returns GuestUserMFAWorkspaceLoginCompleteResponse
   * @throws ApiError
   */
  public static postV1AccountOpsGuestWorkspaceByWorkspaceIdMfaLoginComplete(
    data: PostV1AccountOpsGuestWorkspaceByWorkspaceIdMfaLoginCompleteData
  ): CancelablePromise<PostV1AccountOpsGuestWorkspaceByWorkspaceIdMfaLoginCompleteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/account-ops/guest/workspace/{workspace_id}/mfa-login/complete",
      path: {
        workspace_id: data.workspaceId
      },
      body: data.data
    });
  }

  /**
   * A viewset to start iterating through marketing sync
   * @param data The data for the request.
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1AccountOpsMarketingSyncRunStart(
    data: PostV1AccountOpsMarketingSyncRunStartData
  ): CancelablePromise<PostV1AccountOpsMarketingSyncRunStartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/account-ops/marketing-sync-run/start",
      body: data.data
    });
  }

  /**
   * A viewset to iterate through marketing sync completes from the cron system
   * @param data The data for the request.
   * @param data.marketingSyncRunId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1AccountOpsMarketingSyncRunByMarketingSyncRunIdComplete(
    data: PostV1AccountOpsMarketingSyncRunByMarketingSyncRunIdCompleteData
  ): CancelablePromise<PostV1AccountOpsMarketingSyncRunByMarketingSyncRunIdCompleteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/account-ops/marketing-sync-run/{marketing_sync_run_id}/complete",
      path: {
        marketing_sync_run_id: data.marketingSyncRunId
      },
      body: data.data
    });
  }

  /**
   * A viewset to iterate through marketing sync from the cron system
   * @param data The data for the request.
   * @param data.marketingSyncRunId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1AccountOpsMarketingSyncRunByMarketingSyncRunIdProcess(
    data: PostV1AccountOpsMarketingSyncRunByMarketingSyncRunIdProcessData
  ): CancelablePromise<PostV1AccountOpsMarketingSyncRunByMarketingSyncRunIdProcessResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/account-ops/marketing-sync-run/{marketing_sync_run_id}/process",
      path: {
        marketing_sync_run_id: data.marketingSyncRunId
      },
      body: data.data
    });
  }

  /**
   * A viewset to start iterating through marketing sync
   * @param data The data for the request.
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1AccountOpsOrderMarketingSyncRunStart(
    data: PostV1AccountOpsOrderMarketingSyncRunStartData
  ): CancelablePromise<PostV1AccountOpsOrderMarketingSyncRunStartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/account-ops/order-marketing-sync-run/start",
      body: data.data
    });
  }

  /**
   * A viewset to iterate through marketing sync completes from the cron system
   * @param data The data for the request.
   * @param data.orderMarketingSyncRunId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdComplete(
    data: PostV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdCompleteData
  ): CancelablePromise<PostV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdCompleteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/account-ops/order-marketing-sync-run/{order_marketing_sync_run_id}/complete",
      path: {
        order_marketing_sync_run_id: data.orderMarketingSyncRunId
      },
      body: data.data
    });
  }

  /**
   * A viewset to iterate through marketing sync from the cron system
   * @param data The data for the request.
   * @param data.orderMarketingSyncRunId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdProcess(
    data: PostV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdProcessData
  ): CancelablePromise<PostV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdProcessResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/account-ops/order-marketing-sync-run/{order_marketing_sync_run_id}/process",
      path: {
        order_marketing_sync_run_id: data.orderMarketingSyncRunId
      },
      body: data.data
    });
  }

  /**
   * Search for a term among team text.
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @param data.term The term to search for.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1SearchInternalTeam(
    data: GetV1SearchInternalTeamData = {}
  ): CancelablePromise<GetV1SearchInternalTeamResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/search/internal/team",
      query: {
        limit: data.limit,
        offset: data.offset,
        term: data.term
      }
    });
  }

  /**
   * Search for a term among team text.
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.offset The initial index from which to return the results.
   * @param data.term The term to search for.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1SearchTeam(
    data: GetV1SearchTeamData = {}
  ): CancelablePromise<GetV1SearchTeamResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/search/team",
      query: {
        limit: data.limit,
        offset: data.offset,
        term: data.term
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1TeamManagementInviteAccept(
    data: PostV1TeamManagementInviteAcceptData
  ): CancelablePromise<PostV1TeamManagementInviteAcceptResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/team-management/invite/accept",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.inviteId
   * @returns TeamInviteView
   * @throws ApiError
   */
  public static getV1TeamManagementInviteByInviteId(
    data: GetV1TeamManagementInviteByInviteIdData
  ): CancelablePromise<GetV1TeamManagementInviteByInviteIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/team-management/invite/{invite_id}",
      path: {
        invite_id: data.inviteId
      }
    });
  }

  /**
   * Provides a member team lookup request.
   * @param data The data for the request.
   * @param data.userId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1TeamManagementMemberByUserId(
    data: GetV1TeamManagementMemberByUserIdData
  ): CancelablePromise<GetV1TeamManagementMemberByUserIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/team-management/member/{user_id}",
      path: {
        user_id: data.userId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * This team card list always returns all the cards associated with a team.
   * @param data The data for the request.
   * @param data.data
   * @returns TeamCardRawView
   * @throws ApiError
   */
  public static postV1TeamManagementServiceTeamCards(
    data: PostV1TeamManagementServiceTeamCardsData
  ): CancelablePromise<PostV1TeamManagementServiceTeamCardsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/team-management/service/team-cards",
      body: data.data
    });
  }

  /**
   * Try to send the Team Link creator the Team Access Request email.  This is rate
   * limited to prevent spam from the same user.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamAccessRequestId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequested(
    data: PostV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequestedData
  ): CancelablePromise<PostV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequestedResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/team-management/service/team/{team_id}/team-access-request/{team_access_request_id}/email/access-requested",
      path: {
        team_id: data.teamId,
        team_access_request_id: data.teamAccessRequestId
      },
      body: data.data
    });
  }

  /**
   * Notify the Team Access Request user that their access has been approved.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamAccessRequestId
   * @returns void
   * @throws ApiError
   */
  public static postV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailApproved(
    data: PostV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailApprovedData
  ): CancelablePromise<PostV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailApprovedResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/team-management/service/team/{team_id}/team-access-request/{team_access_request_id}/email/approved",
      path: {
        team_id: data.teamId,
        team_access_request_id: data.teamAccessRequestId
      }
    });
  }

  /**
   * Notify the Team Access Request user that their access has been denied.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamAccessRequestId
   * @returns void
   * @throws ApiError
   */
  public static postV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailDenied(
    data: PostV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailDeniedData
  ): CancelablePromise<PostV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailDeniedResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/team-management/service/team/{team_id}/team-access-request/{team_access_request_id}/email/denied",
      path: {
        team_id: data.teamId,
        team_access_request_id: data.teamAccessRequestId
      }
    });
  }

  /**
   * Base team views with permissions and accesses.
   * @param data The data for the request.
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1TeamManagementTeam(
    data: GetV1TeamManagementTeamData = {}
  ): CancelablePromise<GetV1TeamManagementTeamResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/team-management/team",
      query: {
        page: data.page
      }
    });
  }

  /**
   * Base team views with permissions and accesses.
   * @param data The data for the request.
   * @param data.data
   * @returns TeamCreateResponse
   * @throws ApiError
   */
  public static postV1TeamManagementTeam(
    data: PostV1TeamManagementTeamData
  ): CancelablePromise<PostV1TeamManagementTeamResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/team-management/team",
      body: data.data
    });
  }

  /**
   * Use the Team Link to create a Team Request Access.
   * @param data The data for the request.
   * @param data.data
   * @returns TeamAccessRequestView
   * @throws ApiError
   */
  public static postV1TeamManagementTeamLinkTeamAccessRequest(
    data: PostV1TeamManagementTeamLinkTeamAccessRequestData
  ): CancelablePromise<PostV1TeamManagementTeamLinkTeamAccessRequestResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/team-management/team-link/team-access-request",
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamMemberId
   * @returns TeamMemberView
   * @throws ApiError
   */
  public static getV1TeamManagementTeamMemberByTeamMemberId(
    data: GetV1TeamManagementTeamMemberByTeamMemberIdData
  ): CancelablePromise<GetV1TeamManagementTeamMemberByTeamMemberIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/team-management/team-member/{team_member_id}",
      path: {
        team_member_id: data.teamMemberId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamMemberId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1TeamManagementTeamMemberByTeamMemberId(
    data: DeleteV1TeamManagementTeamMemberByTeamMemberIdData
  ): CancelablePromise<DeleteV1TeamManagementTeamMemberByTeamMemberIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/team-management/team-member/{team_member_id}",
      path: {
        team_member_id: data.teamMemberId
      }
    });
  }

  /**
   * Team profile lookup view.
   * @param data The data for the request.
   * @param data.data
   * @returns TeamProfileResponse
   * @throws ApiError
   */
  public static postV1TeamManagementTeamProfiles(
    data: PostV1TeamManagementTeamProfilesData
  ): CancelablePromise<PostV1TeamManagementTeamProfilesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/team-management/team/profiles",
      body: data.data
    });
  }

  /**
   * Base team views with permissions and accesses.
   * @param data The data for the request.
   * @param data.teamId
   * @returns TeamView
   * @throws ApiError
   */
  public static getV1TeamManagementTeamByTeamId(
    data: GetV1TeamManagementTeamByTeamIdData
  ): CancelablePromise<GetV1TeamManagementTeamByTeamIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/team-management/team/{team_id}",
      path: {
        team_id: data.teamId
      }
    });
  }

  /**
   * Base team views with permissions and accesses.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.data
   * @returns TeamView
   * @throws ApiError
   */
  public static patchV1TeamManagementTeamByTeamId(
    data: PatchV1TeamManagementTeamByTeamIdData
  ): CancelablePromise<PatchV1TeamManagementTeamByTeamIdResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/v1/team-management/team/{team_id}",
      path: {
        team_id: data.teamId
      },
      body: data.data
    });
  }

  /**
   * Base team views with permissions and accesses.
   * @param data The data for the request.
   * @param data.teamId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1TeamManagementTeamByTeamId(
    data: DeleteV1TeamManagementTeamByTeamIdData
  ): CancelablePromise<DeleteV1TeamManagementTeamByTeamIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/team-management/team/{team_id}",
      path: {
        team_id: data.teamId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1TeamManagementTeamByTeamIdHardDelete(
    data: DeleteV1TeamManagementTeamByTeamIdHardDeleteData
  ): CancelablePromise<DeleteV1TeamManagementTeamByTeamIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/team-management/team/{team_id}/hard-delete",
      path: {
        team_id: data.teamId
      }
    });
  }

  /**
   * Base team views with custom permissions and accesses.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1TeamManagementTeamByTeamIdInvite(
    data: GetV1TeamManagementTeamByTeamIdInviteData
  ): CancelablePromise<GetV1TeamManagementTeamByTeamIdInviteResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/team-management/team/{team_id}/invite",
      path: {
        team_id: data.teamId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * Base team views with custom permissions and accesses.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.data
   * @returns TeamInviteView
   * @throws ApiError
   */
  public static postV1TeamManagementTeamByTeamIdInvite(
    data: PostV1TeamManagementTeamByTeamIdInviteData
  ): CancelablePromise<PostV1TeamManagementTeamByTeamIdInviteResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/team-management/team/{team_id}/invite",
      path: {
        team_id: data.teamId
      },
      body: data.data
    });
  }

  /**
   * Base team views with custom permissions and accesses.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.inviteId
   * @returns TeamInviteView
   * @throws ApiError
   */
  public static getV1TeamManagementTeamByTeamIdInviteByInviteId(
    data: GetV1TeamManagementTeamByTeamIdInviteByInviteIdData
  ): CancelablePromise<GetV1TeamManagementTeamByTeamIdInviteByInviteIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/team-management/team/{team_id}/invite/{invite_id}",
      path: {
        team_id: data.teamId,
        invite_id: data.inviteId
      }
    });
  }

  /**
   * Base team views with custom permissions and accesses.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.inviteId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1TeamManagementTeamByTeamIdInviteByInviteId(
    data: DeleteV1TeamManagementTeamByTeamIdInviteByInviteIdData
  ): CancelablePromise<DeleteV1TeamManagementTeamByTeamIdInviteByInviteIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/team-management/team/{team_id}/invite/{invite_id}",
      path: {
        team_id: data.teamId,
        invite_id: data.inviteId
      }
    });
  }

  /**
   * Base team views with custom permissions and accesses.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.inviteId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1TeamManagementTeamByTeamIdInviteByInviteIdHardDelete(
    data: DeleteV1TeamManagementTeamByTeamIdInviteByInviteIdHardDeleteData
  ): CancelablePromise<DeleteV1TeamManagementTeamByTeamIdInviteByInviteIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/team-management/team/{team_id}/invite/{invite_id}/hard-delete",
      path: {
        team_id: data.teamId,
        invite_id: data.inviteId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.inviteId
   * @param data.data
   * @returns TeamInviteCreateResponse
   * @throws ApiError
   */
  public static postV1TeamManagementTeamByTeamIdInviteByInviteIdResend(
    data: PostV1TeamManagementTeamByTeamIdInviteByInviteIdResendData
  ): CancelablePromise<PostV1TeamManagementTeamByTeamIdInviteByInviteIdResendResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/team-management/team/{team_id}/invite/{invite_id}/resend",
      path: {
        team_id: data.teamId,
        invite_id: data.inviteId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1TeamManagementTeamByTeamIdMember(
    data: GetV1TeamManagementTeamByTeamIdMemberData
  ): CancelablePromise<GetV1TeamManagementTeamByTeamIdMemberResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/team-management/team/{team_id}/member",
      path: {
        team_id: data.teamId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.userId
   * @returns TeamMemberViewResponse
   * @throws ApiError
   */
  public static getV1TeamManagementTeamByTeamIdMemberByUserId(
    data: GetV1TeamManagementTeamByTeamIdMemberByUserIdData
  ): CancelablePromise<GetV1TeamManagementTeamByTeamIdMemberByUserIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/team-management/team/{team_id}/member/{user_id}",
      path: {
        team_id: data.teamId,
        user_id: data.userId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.userId
   * @param data.data
   * @returns TeamMemberChangeRole
   * @throws ApiError
   */
  public static patchV1TeamManagementTeamByTeamIdMemberByUserId(
    data: PatchV1TeamManagementTeamByTeamIdMemberByUserIdData
  ): CancelablePromise<PatchV1TeamManagementTeamByTeamIdMemberByUserIdResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/v1/team-management/team/{team_id}/member/{user_id}",
      path: {
        team_id: data.teamId,
        user_id: data.userId
      },
      body: data.data
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.userId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1TeamManagementTeamByTeamIdMemberByUserId(
    data: DeleteV1TeamManagementTeamByTeamIdMemberByUserIdData
  ): CancelablePromise<DeleteV1TeamManagementTeamByTeamIdMemberByUserIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/team-management/team/{team_id}/member/{user_id}",
      path: {
        team_id: data.teamId,
        user_id: data.userId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.userId
   * @param data.page A page number within the paginated result set.
   * @returns TeamMemberRoleView
   * @throws ApiError
   */
  public static getV1TeamManagementTeamByTeamIdMemberByUserIdRole(
    data: GetV1TeamManagementTeamByTeamIdMemberByUserIdRoleData
  ): CancelablePromise<GetV1TeamManagementTeamByTeamIdMemberByUserIdRoleResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/team-management/team/{team_id}/member/{user_id}/role",
      path: {
        team_id: data.teamId,
        user_id: data.userId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.data
   * @returns TeamSetParameterResponse
   * @throws ApiError
   */
  public static putV1TeamManagementTeamByTeamIdOwner(
    data: PutV1TeamManagementTeamByTeamIdOwnerData
  ): CancelablePromise<PutV1TeamManagementTeamByTeamIdOwnerResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/v1/team-management/team/{team_id}/owner",
      path: {
        team_id: data.teamId
      },
      body: data.data
    });
  }

  /**
   * Team Access Request List/Create views.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1TeamManagementTeamByTeamIdTeamAccessRequest(
    data: GetV1TeamManagementTeamByTeamIdTeamAccessRequestData
  ): CancelablePromise<GetV1TeamManagementTeamByTeamIdTeamAccessRequestResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/team-management/team/{team_id}/team-access-request",
      path: {
        team_id: data.teamId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * Team Access Request List/Create views.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.data
   * @returns TeamAccessRequestView
   * @throws ApiError
   */
  public static postV1TeamManagementTeamByTeamIdTeamAccessRequest(
    data: PostV1TeamManagementTeamByTeamIdTeamAccessRequestData
  ): CancelablePromise<PostV1TeamManagementTeamByTeamIdTeamAccessRequestResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/team-management/team/{team_id}/team-access-request",
      path: {
        team_id: data.teamId
      },
      body: data.data
    });
  }

  /**
   * Team Access Request Detail view with team admin checks.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamAccessRequestId
   * @returns TeamAccessRequestView
   * @throws ApiError
   */
  public static getV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestId(
    data: GetV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdData
  ): CancelablePromise<GetV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/team-management/team/{team_id}/team-access-request/{team_access_request_id}",
      path: {
        team_id: data.teamId,
        team_access_request_id: data.teamAccessRequestId
      }
    });
  }

  /**
   * Team Access Request Detail view with team admin checks.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamAccessRequestId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestId(
    data: DeleteV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdData
  ): CancelablePromise<DeleteV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/team-management/team/{team_id}/team-access-request/{team_access_request_id}",
      path: {
        team_id: data.teamId,
        team_access_request_id: data.teamAccessRequestId
      }
    });
  }

  /**
   * Team Access Request Approval view with team admin checks.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamAccessRequestId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdApprove(
    data: PostV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdApproveData
  ): CancelablePromise<PostV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdApproveResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/team-management/team/{team_id}/team-access-request/{team_access_request_id}/approve",
      path: {
        team_id: data.teamId,
        team_access_request_id: data.teamAccessRequestId
      }
    });
  }

  /**
   * Team Access Request Denail view with team admin checks.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamAccessRequestId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdDeny(
    data: PostV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdDenyData
  ): CancelablePromise<PostV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdDenyResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/team-management/team/{team_id}/team-access-request/{team_access_request_id}/deny",
      path: {
        team_id: data.teamId,
        team_access_request_id: data.teamAccessRequestId
      }
    });
  }

  /**
   * Send the Team Link creator the Team Access Request email.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamAccessRequestId
   * @param data.data
   * @returns void
   * @throws ApiError
   */
  public static postV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequested(
    data: PostV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequestedData
  ): CancelablePromise<PostV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequestedResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/team-management/team/{team_id}/team-access-request/{team_access_request_id}/email/access-requested",
      path: {
        team_id: data.teamId,
        team_access_request_id: data.teamAccessRequestId
      },
      body: data.data
    });
  }

  /**
   * Team Access Request Hard Delete view with team admin checks.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamAccessRequestId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdHardDelete(
    data: DeleteV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdHardDeleteData
  ): CancelablePromise<DeleteV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/team-management/team/{team_id}/team-access-request/{team_access_request_id}/hard-delete",
      path: {
        team_id: data.teamId,
        team_access_request_id: data.teamAccessRequestId
      }
    });
  }

  /**
   * Base team views with custom permissions and accesses.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1TeamManagementTeamByTeamIdTeamCard(
    data: GetV1TeamManagementTeamByTeamIdTeamCardData
  ): CancelablePromise<GetV1TeamManagementTeamByTeamIdTeamCardResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/team-management/team/{team_id}/team-card",
      path: {
        team_id: data.teamId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * Base team views with custom permissions and accesses.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.data
   * @returns TeamCardRawView
   * @throws ApiError
   */
  public static postV1TeamManagementTeamByTeamIdTeamCard(
    data: PostV1TeamManagementTeamByTeamIdTeamCardData
  ): CancelablePromise<PostV1TeamManagementTeamByTeamIdTeamCardResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/team-management/team/{team_id}/team-card",
      path: {
        team_id: data.teamId
      },
      body: data.data
    });
  }

  /**
   * Team Card Detail view.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamCardId
   * @returns TeamCardRawView
   * @throws ApiError
   */
  public static getV1TeamManagementTeamByTeamIdTeamCardByTeamCardId(
    data: GetV1TeamManagementTeamByTeamIdTeamCardByTeamCardIdData
  ): CancelablePromise<GetV1TeamManagementTeamByTeamIdTeamCardByTeamCardIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/team-management/team/{team_id}/team-card/{team_card_id}",
      path: {
        team_id: data.teamId,
        team_card_id: data.teamCardId
      }
    });
  }

  /**
   * Team Card hard delete view.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamCardId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1TeamManagementTeamByTeamIdTeamCardByTeamCardIdHardDelete(
    data: DeleteV1TeamManagementTeamByTeamIdTeamCardByTeamCardIdHardDeleteData
  ): CancelablePromise<DeleteV1TeamManagementTeamByTeamIdTeamCardByTeamCardIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/team-management/team/{team_id}/team-card/{team_card_id}/hard-delete",
      path: {
        team_id: data.teamId,
        team_card_id: data.teamCardId
      }
    });
  }

  /**
   * Team Link List/Create views with team admin checks.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1TeamManagementTeamByTeamIdTeamLink(
    data: GetV1TeamManagementTeamByTeamIdTeamLinkData
  ): CancelablePromise<GetV1TeamManagementTeamByTeamIdTeamLinkResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/team-management/team/{team_id}/team-link",
      path: {
        team_id: data.teamId
      },
      query: {
        page: data.page
      }
    });
  }

  /**
   * Team Link List/Create views with team admin checks.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.data
   * @returns TeamLinkView
   * @throws ApiError
   */
  public static postV1TeamManagementTeamByTeamIdTeamLink(
    data: PostV1TeamManagementTeamByTeamIdTeamLinkData
  ): CancelablePromise<PostV1TeamManagementTeamByTeamIdTeamLinkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/team-management/team/{team_id}/team-link",
      path: {
        team_id: data.teamId
      }
    });
  }

  /**
   * Team Link Detail views for a user's team link with team member checks.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.userId
   * @returns TeamLinkView
   * @throws ApiError
   */
  public static getV1TeamManagementTeamByTeamIdTeamLinkUserByUserId(
    data: GetV1TeamManagementTeamByTeamIdTeamLinkUserByUserIdData
  ): CancelablePromise<GetV1TeamManagementTeamByTeamIdTeamLinkUserByUserIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/team-management/team/{team_id}/team-link/user/{user_id}",
      path: {
        team_id: data.teamId,
        user_id: data.userId
      }
    });
  }

  /**
   * Team Link Detail views with team admin checks.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamLinkId
   * @returns TeamLinkView
   * @throws ApiError
   */
  public static getV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkId(
    data: GetV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdData
  ): CancelablePromise<GetV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/team-management/team/{team_id}/team-link/{team_link_id}",
      path: {
        team_id: data.teamId,
        team_link_id: data.teamLinkId
      }
    });
  }

  /**
   * Team Link Detail views with team admin checks.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamLinkId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkId(
    data: DeleteV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdData
  ): CancelablePromise<DeleteV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/team-management/team/{team_id}/team-link/{team_link_id}",
      path: {
        team_id: data.teamId,
        team_link_id: data.teamLinkId
      }
    });
  }

  /**
   * Team Link views with team admin checks.
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamLinkId
   * @returns void
   * @throws ApiError
   */
  public static deleteV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdHardDelete(
    data: DeleteV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdHardDeleteData
  ): CancelablePromise<DeleteV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/team-management/team/{team_id}/team-link/{team_link_id}/hard-delete",
      path: {
        team_id: data.teamId,
        team_link_id: data.teamLinkId
      }
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.page A page number within the paginated result set.
   * @returns unknown
   * @throws ApiError
   */
  public static getV1TeamManagementUserByUserIdInvite(
    data: GetV1TeamManagementUserByUserIdInviteData
  ): CancelablePromise<GetV1TeamManagementUserByUserIdInviteResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/team-management/user/{user_id}/invite",
      path: {
        user_id: data.userId
      },
      query: {
        page: data.page
      }
    });
  }
}

export class CorsService {
  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CommunicationEmailTemplate(): CancelablePromise<OptionsV1CommunicationEmailTemplateResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/communication/email-template",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.emailTemplateId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CommunicationEmailTemplateByEmailTemplateId(
    data: OptionsV1CommunicationEmailTemplateByEmailTemplateIdData
  ): CancelablePromise<OptionsV1CommunicationEmailTemplateByEmailTemplateIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/communication/email-template/{email_template_id}",
      path: {
        email_template_id: data.emailTemplateId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.codeId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CommunicationMfaCodeByCodeIdResend(
    data: OptionsV1CommunicationMfaCodeByCodeIdResendData
  ): CancelablePromise<OptionsV1CommunicationMfaCodeByCodeIdResendResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/communication/mfa-code/{code_id}/resend",
      path: {
        code_id: data.codeId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.codeId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CommunicationMfaCodeByCodeIdVerify(
    data: OptionsV1CommunicationMfaCodeByCodeIdVerifyData
  ): CancelablePromise<OptionsV1CommunicationMfaCodeByCodeIdVerifyResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/communication/mfa-code/{code_id}/verify",
      path: {
        code_id: data.codeId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CommunicationMfaCodeByUserIdCreate(
    data: OptionsV1CommunicationMfaCodeByUserIdCreateData
  ): CancelablePromise<OptionsV1CommunicationMfaCodeByUserIdCreateResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/communication/mfa-code/{user_id}/create",
      path: {
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CommunicationTextTemplate(): CancelablePromise<OptionsV1CommunicationTextTemplateResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/communication/text-template",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.textTemplateId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CommunicationTextTemplateByTextTemplateId(
    data: OptionsV1CommunicationTextTemplateByTextTemplateIdData
  ): CancelablePromise<OptionsV1CommunicationTextTemplateByTextTemplateIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/communication/text-template/{text_template_id}",
      path: {
        text_template_id: data.textTemplateId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1SearchUser(): CancelablePromise<OptionsV1SearchUserResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/search/user",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1SearchUserInternal(): CancelablePromise<OptionsV1SearchUserInternalResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/search/user/internal",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementAccountOpsAccountMerge(): CancelablePromise<OptionsV1UserManagementAccountOpsAccountMergeResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/account-ops/account-merge",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementAccountOpsDataRetentionClear(): CancelablePromise<OptionsV1UserManagementAccountOpsDataRetentionClearResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/account-ops/data-retention-clear",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementAccountOpsDataRetentionUpdate(): CancelablePromise<OptionsV1UserManagementAccountOpsDataRetentionUpdateResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/account-ops/data-retention-update",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementAccountOpsMarketingStatusUpdate(): CancelablePromise<OptionsV1UserManagementAccountOpsMarketingStatusUpdateResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/account-ops/marketing-status-update",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementApiLogin(): CancelablePromise<OptionsV1UserManagementApiLoginResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/api-login",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementExternalServiceUsers(): CancelablePromise<OptionsV1UserManagementExternalServiceUsersResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/external-service-users",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementExternalServiceUsersByUserId(
    data: OptionsV1UserManagementExternalServiceUsersByUserIdData
  ): CancelablePromise<OptionsV1UserManagementExternalServiceUsersByUserIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/external-service-users/{user_id}",
      path: {
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementExternalServiceUsersByUserIdHardDelete(
    data: OptionsV1UserManagementExternalServiceUsersByUserIdHardDeleteData
  ): CancelablePromise<OptionsV1UserManagementExternalServiceUsersByUserIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/external-service-users/{user_id}/hard-delete",
      path: {
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementGuestWorkspaceByWorkspaceIdLogin(
    data: OptionsV1UserManagementGuestWorkspaceByWorkspaceIdLoginData
  ): CancelablePromise<OptionsV1UserManagementGuestWorkspaceByWorkspaceIdLoginResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/guest/workspace/{workspace_id}/login",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementGuestWorkspaceByWorkspaceIdMfaLoginComplete(
    data: OptionsV1UserManagementGuestWorkspaceByWorkspaceIdMfaLoginCompleteData
  ): CancelablePromise<OptionsV1UserManagementGuestWorkspaceByWorkspaceIdMfaLoginCompleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/guest/workspace/{workspace_id}/mfa-login/complete",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementLogin(): CancelablePromise<OptionsV1UserManagementLoginResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/login",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementLogout(): CancelablePromise<OptionsV1UserManagementLogoutResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/logout",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementMfaLoginComplete(): CancelablePromise<OptionsV1UserManagementMfaLoginCompleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/mfa-login/complete",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementMfaLoginSendCode(): CancelablePromise<OptionsV1UserManagementMfaLoginSendCodeResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/mfa-login/send-code",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementMfaLoginStart(): CancelablePromise<OptionsV1UserManagementMfaLoginStartResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/mfa-login/start",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.codeId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementMfaLoginByCodeIdResend(
    data: OptionsV1UserManagementMfaLoginByCodeIdResendData
  ): CancelablePromise<OptionsV1UserManagementMfaLoginByCodeIdResendResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/mfa-login/{code_id}/resend",
      path: {
        code_id: data.codeId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementPolicies(): CancelablePromise<OptionsV1UserManagementPoliciesResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/policies",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementPoliciesAgreement(): CancelablePromise<OptionsV1UserManagementPoliciesAgreementResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/policies/agreement",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementPoliciesCurrent(): CancelablePromise<OptionsV1UserManagementPoliciesCurrentResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/policies/current",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementPoliciesUpload(): CancelablePromise<OptionsV1UserManagementPoliciesUploadResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/policies/upload",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.policyName
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementPoliciesByPolicyNameAccess(
    data: OptionsV1UserManagementPoliciesByPolicyNameAccessData
  ): CancelablePromise<OptionsV1UserManagementPoliciesByPolicyNameAccessResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/policies/{policy_name}/access",
      path: {
        policy_name: data.policyName
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.versionId A UUID string identifying this policy.
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementPoliciesByVersionId(
    data: OptionsV1UserManagementPoliciesByVersionIdData
  ): CancelablePromise<OptionsV1UserManagementPoliciesByVersionIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/policies/{version_id}",
      path: {
        version_id: data.versionId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementServiceUsers(): CancelablePromise<OptionsV1UserManagementServiceUsersResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/service/users",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementServiceUsersRegistration(): CancelablePromise<OptionsV1UserManagementServiceUsersRegistrationResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/service/users/registration",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementTokenOrganizationByOrganizationIdRefresh(
    data: OptionsV1UserManagementTokenOrganizationByOrganizationIdRefreshData
  ): CancelablePromise<OptionsV1UserManagementTokenOrganizationByOrganizationIdRefreshResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/token/organization/{organization_id}/refresh",
      path: {
        organization_id: data.organizationId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementTokenRefresh(): CancelablePromise<OptionsV1UserManagementTokenRefreshResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/token/refresh",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUserWorkspacePublicProfiles(): CancelablePromise<OptionsV1UserManagementUserWorkspacePublicProfilesResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/user-workspace/public-profiles",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUserWorkspaceUserPiiDataEntryBulk(): CancelablePromise<OptionsV1UserManagementUserWorkspaceUserPiiDataEntryBulkResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/user-workspace/user-pii-data-entry-bulk",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntry(
    data: OptionsV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryData
  ): CancelablePromise<OptionsV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/user-workspace/{workspace_id}/user-pii-data-entry",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryUpload(
    data: OptionsV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryUploadData
  ): CancelablePromise<OptionsV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryUploadResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/user-workspace/{workspace_id}/user-pii-data-entry/upload",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.userPiiDataEntryId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryId(
    data: OptionsV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryIdData
  ): CancelablePromise<OptionsV1UserManagementUserWorkspaceByWorkspaceIdUserPiiDataEntryByUserPiiDataEntryIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/user-workspace/{workspace_id}/user-pii-data-entry/{user_pii_data_entry_id}",
      path: {
        workspace_id: data.workspaceId,
        user_pii_data_entry_id: data.userPiiDataEntryId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsers(): CancelablePromise<OptionsV1UserManagementUsersResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersEmailVerificationConfirm(): CancelablePromise<OptionsV1UserManagementUsersEmailVerificationConfirmResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/email-verification/confirm",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersEmailVerificationRequest(): CancelablePromise<OptionsV1UserManagementUsersEmailVerificationRequestResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/email-verification/request",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersGuestUserRegistration(): CancelablePromise<OptionsV1UserManagementUsersGuestUserRegistrationResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/guest-user-registration",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersGuestUserRegistrationComplete(): CancelablePromise<OptionsV1UserManagementUsersGuestUserRegistrationCompleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/guest-user-registration-complete",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersPasswordConfirm(): CancelablePromise<OptionsV1UserManagementUsersPasswordConfirmResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/password/confirm",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersPasswordReset(): CancelablePromise<OptionsV1UserManagementUsersPasswordResetResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/password/reset",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersPublicProfiles(): CancelablePromise<OptionsV1UserManagementUsersPublicProfilesResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/public-profiles",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersRegistration(): CancelablePromise<OptionsV1UserManagementUsersRegistrationResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/registration",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersRegistrationUsernameAvailable(): CancelablePromise<OptionsV1UserManagementUsersRegistrationUsernameAvailableResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/registration/username-available",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.codeId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersByCodeIdVerifyPhoneResend(
    data: OptionsV1UserManagementUsersByCodeIdVerifyPhoneResendData
  ): CancelablePromise<OptionsV1UserManagementUsersByCodeIdVerifyPhoneResendResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/{code_id}/verify-phone/resend",
      path: {
        code_id: data.codeId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.codeId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersByCodeIdVerifyPhoneVerify(
    data: OptionsV1UserManagementUsersByCodeIdVerifyPhoneVerifyData
  ): CancelablePromise<OptionsV1UserManagementUsersByCodeIdVerifyPhoneVerifyResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/{code_id}/verify-phone/verify",
      path: {
        code_id: data.codeId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersByUserId(
    data: OptionsV1UserManagementUsersByUserIdData
  ): CancelablePromise<OptionsV1UserManagementUsersByUserIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/{user_id}",
      path: {
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersByUserIdEmail(
    data: OptionsV1UserManagementUsersByUserIdEmailData
  ): CancelablePromise<OptionsV1UserManagementUsersByUserIdEmailResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/{user_id}/email",
      path: {
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersByUserIdGuestEmail(
    data: OptionsV1UserManagementUsersByUserIdGuestEmailData
  ): CancelablePromise<OptionsV1UserManagementUsersByUserIdGuestEmailResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/{user_id}/guest-email",
      path: {
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersByUserIdHardDelete(
    data: OptionsV1UserManagementUsersByUserIdHardDeleteData
  ): CancelablePromise<OptionsV1UserManagementUsersByUserIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/{user_id}/hard-delete",
      path: {
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersByUserIdPassword(
    data: OptionsV1UserManagementUsersByUserIdPasswordData
  ): CancelablePromise<OptionsV1UserManagementUsersByUserIdPasswordResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/{user_id}/password",
      path: {
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersByUserIdUserPiiDataEntry(
    data: OptionsV1UserManagementUsersByUserIdUserPiiDataEntryData
  ): CancelablePromise<OptionsV1UserManagementUsersByUserIdUserPiiDataEntryResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/{user_id}/user-pii-data-entry",
      path: {
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersByUserIdUserPiiDataEntryUpload(
    data: OptionsV1UserManagementUsersByUserIdUserPiiDataEntryUploadData
  ): CancelablePromise<OptionsV1UserManagementUsersByUserIdUserPiiDataEntryUploadResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/{user_id}/user-pii-data-entry/upload",
      path: {
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.userPiiDataEntryId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryId(
    data: OptionsV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryIdData
  ): CancelablePromise<OptionsV1UserManagementUsersByUserIdUserPiiDataEntryByUserPiiDataEntryIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/{user_id}/user-pii-data-entry/{user_pii_data_entry_id}",
      path: {
        user_id: data.userId,
        user_pii_data_entry_id: data.userPiiDataEntryId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1UserManagementUsersByUserIdVerifyPhoneStart(
    data: OptionsV1UserManagementUsersByUserIdVerifyPhoneStartData
  ): CancelablePromise<OptionsV1UserManagementUsersByUserIdVerifyPhoneStartResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/user-management/users/{user_id}/verify-phone/start",
      path: {
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementAccountOpsDataRetentionClear(): CancelablePromise<OptionsV1OrganizationManagementAccountOpsDataRetentionClearResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/account-ops/data-retention-clear",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementAccountOpsMemberWorkspaceBulk(): CancelablePromise<OptionsV1OrganizationManagementAccountOpsMemberWorkspaceBulkResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/account-ops/member-workspace-bulk",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementGuestFamilyRegistrationCreate(): CancelablePromise<OptionsV1OrganizationManagementGuestFamilyRegistrationCreateResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/guest-family-registration/create",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementGuestFamilyRegistrationByOrganizationIdComplete(
    data: OptionsV1OrganizationManagementGuestFamilyRegistrationByOrganizationIdCompleteData
  ): CancelablePromise<OptionsV1OrganizationManagementGuestFamilyRegistrationByOrganizationIdCompleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/guest-family-registration/{organization_id}/complete",
      path: {
        organization_id: data.organizationId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementInviteAccept(): CancelablePromise<OptionsV1OrganizationManagementInviteAcceptResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/invite/accept",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.inviteId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementInviteByInviteId(
    data: OptionsV1OrganizationManagementInviteByInviteIdData
  ): CancelablePromise<OptionsV1OrganizationManagementInviteByInviteIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/invite/{invite_id}",
      path: {
        invite_id: data.inviteId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementMemberWorkspaceBulk(): CancelablePromise<OptionsV1OrganizationManagementMemberWorkspaceBulkResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/member-workspace-bulk",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementMemberByUserId(
    data: OptionsV1OrganizationManagementMemberByUserIdData
  ): CancelablePromise<OptionsV1OrganizationManagementMemberByUserIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/member/{user_id}",
      path: {
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganization(): CancelablePromise<OptionsV1OrganizationManagementOrganizationResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationMemberId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationMemberByOrganizationMemberId(
    data: OptionsV1OrganizationManagementOrganizationMemberByOrganizationMemberIdData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationMemberByOrganizationMemberIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization-member/{organization_member_id}",
      path: {
        organization_member_id: data.organizationMemberId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationWorkspaceOrganizationPiiDataEntryBulk(): CancelablePromise<OptionsV1OrganizationManagementOrganizationWorkspaceOrganizationPiiDataEntryBulkResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization-workspace/organization-pii-data-entry-bulk",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationWorkspaceProfiles(): CancelablePromise<OptionsV1OrganizationManagementOrganizationWorkspaceProfilesResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization-workspace/profiles",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntry(
    data: OptionsV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization-workspace/{workspace_id}/organization-pii-data-entry",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryUpload(
    data: OptionsV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryUploadData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryUploadResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization-workspace/{workspace_id}/organization-pii-data-entry/upload",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.organizationPiiDataEntryId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryId(
    data: OptionsV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationWorkspaceByWorkspaceIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization-workspace/{workspace_id}/organization-pii-data-entry/{organization_pii_data_entry_id}",
      path: {
        workspace_id: data.workspaceId,
        organization_pii_data_entry_id: data.organizationPiiDataEntryId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationProfiles(): CancelablePromise<OptionsV1OrganizationManagementOrganizationProfilesResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization/profiles",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationByOrganizationId(
    data: OptionsV1OrganizationManagementOrganizationByOrganizationIdData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationByOrganizationIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization/{organization_id}",
      path: {
        organization_id: data.organizationId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationByOrganizationIdHardDelete(
    data: OptionsV1OrganizationManagementOrganizationByOrganizationIdHardDeleteData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationByOrganizationIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization/{organization_id}/hard-delete",
      path: {
        organization_id: data.organizationId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationByOrganizationIdInvite(
    data: OptionsV1OrganizationManagementOrganizationByOrganizationIdInviteData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationByOrganizationIdInviteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization/{organization_id}/invite",
      path: {
        organization_id: data.organizationId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.inviteId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteId(
    data: OptionsV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization/{organization_id}/invite/{invite_id}",
      path: {
        organization_id: data.organizationId,
        invite_id: data.inviteId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.inviteId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdHardDelete(
    data: OptionsV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdHardDeleteData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization/{organization_id}/invite/{invite_id}/hard-delete",
      path: {
        organization_id: data.organizationId,
        invite_id: data.inviteId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.inviteId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdResend(
    data: OptionsV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdResendData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationByOrganizationIdInviteByInviteIdResendResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization/{organization_id}/invite/{invite_id}/resend",
      path: {
        organization_id: data.organizationId,
        invite_id: data.inviteId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationByOrganizationIdMember(
    data: OptionsV1OrganizationManagementOrganizationByOrganizationIdMemberData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationByOrganizationIdMemberResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization/{organization_id}/member",
      path: {
        organization_id: data.organizationId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationByOrganizationIdMemberChild(
    data: OptionsV1OrganizationManagementOrganizationByOrganizationIdMemberChildData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationByOrganizationIdMemberChildResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization/{organization_id}/member-child",
      path: {
        organization_id: data.organizationId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationByOrganizationIdMemberByUserId(
    data: OptionsV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization/{organization_id}/member/{user_id}",
      path: {
        organization_id: data.organizationId,
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdRole(
    data: OptionsV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdRoleData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationByOrganizationIdMemberByUserIdRoleResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization/{organization_id}/member/{user_id}/role",
      path: {
        organization_id: data.organizationId,
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntry(
    data: OptionsV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization/{organization_id}/organization-pii-data-entry",
      path: {
        organization_id: data.organizationId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryUpload(
    data: OptionsV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryUploadData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryUploadResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization/{organization_id}/organization-pii-data-entry/upload",
      path: {
        organization_id: data.organizationId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.organizationPiiDataEntryId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryId(
    data: OptionsV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationByOrganizationIdOrganizationPiiDataEntryByOrganizationPiiDataEntryIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization/{organization_id}/organization-pii-data-entry/{organization_pii_data_entry_id}",
      path: {
        organization_id: data.organizationId,
        organization_pii_data_entry_id: data.organizationPiiDataEntryId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationByOrganizationIdOwner(
    data: OptionsV1OrganizationManagementOrganizationByOrganizationIdOwnerData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationByOrganizationIdOwnerResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization/{organization_id}/owner",
      path: {
        organization_id: data.organizationId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementOrganizationByOrganizationIdTags(
    data: OptionsV1OrganizationManagementOrganizationByOrganizationIdTagsData
  ): CancelablePromise<OptionsV1OrganizationManagementOrganizationByOrganizationIdTagsResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/organization/{organization_id}/tags",
      path: {
        organization_id: data.organizationId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrganizationManagementUserByUserIdInvite(
    data: OptionsV1OrganizationManagementUserByUserIdInviteData
  ): CancelablePromise<OptionsV1OrganizationManagementUserByUserIdInviteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/organization-management/user/{user_id}/invite",
      path: {
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1SearchInternalOrganization(): CancelablePromise<OptionsV1SearchInternalOrganizationResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/search/internal/organization",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1SearchOrganization(): CancelablePromise<OptionsV1SearchOrganizationResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/search/organization",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1ApiUserApiUserByUserIdByUserId(
    data: OptionsV1ApiUserApiUserByUserIdByUserIdData
  ): CancelablePromise<OptionsV1ApiUserApiUserByUserIdByUserIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/api-user/api-user-by-user-id/{user_id}",
      path: {
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1ApiUserApiUserByUserIdByUserIdHardDelete(
    data: OptionsV1ApiUserApiUserByUserIdByUserIdHardDeleteData
  ): CancelablePromise<OptionsV1ApiUserApiUserByUserIdByUserIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/api-user/api-user-by-user-id/{user_id}/hard-delete",
      path: {
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1ApiUserOrganizationByOrganizationId(
    data: OptionsV1ApiUserOrganizationByOrganizationIdData
  ): CancelablePromise<OptionsV1ApiUserOrganizationByOrganizationIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/api-user/organization/{organization_id}",
      path: {
        organization_id: data.organizationId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.apiUserId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1ApiUserOrganizationByOrganizationIdApiUserByApiUserId(
    data: OptionsV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdData
  ): CancelablePromise<OptionsV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/api-user/organization/{organization_id}/api-user/{api_user_id}",
      path: {
        organization_id: data.organizationId,
        api_user_id: data.apiUserId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.organizationId
   * @param data.apiUserId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdHardDelete(
    data: OptionsV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdHardDeleteData
  ): CancelablePromise<OptionsV1ApiUserOrganizationByOrganizationIdApiUserByApiUserIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/api-user/organization/{organization_id}/api-user/{api_user_id}/hard-delete",
      path: {
        organization_id: data.organizationId,
        api_user_id: data.apiUserId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamCard(): CancelablePromise<OptionsV1CardJamCardResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/card",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamCardPack(): CancelablePromise<OptionsV1CardJamCardPackResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/card-pack",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.cardPackId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamCardPackByCardPackId(
    data: OptionsV1CardJamCardPackByCardPackIdData
  ): CancelablePromise<OptionsV1CardJamCardPackByCardPackIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/card-pack/{card_pack_id}",
      path: {
        card_pack_id: data.cardPackId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.cardPackId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamCardPackByCardPackIdHardDelete(
    data: OptionsV1CardJamCardPackByCardPackIdHardDeleteData
  ): CancelablePromise<OptionsV1CardJamCardPackByCardPackIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/card-pack/{card_pack_id}/hard-delete",
      path: {
        card_pack_id: data.cardPackId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamCardSet(): CancelablePromise<OptionsV1CardJamCardSetResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/card-set",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamCardSetPack(): CancelablePromise<OptionsV1CardJamCardSetPackResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/card-set-pack",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.cardSetId
   * @param data.cardSetPackType
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamCardSetPackCardSetByCardSetIdCardSetPackTypeByCardSetPackType(
    data: OptionsV1CardJamCardSetPackCardSetByCardSetIdCardSetPackTypeByCardSetPackTypeData
  ): CancelablePromise<OptionsV1CardJamCardSetPackCardSetByCardSetIdCardSetPackTypeByCardSetPackTypeResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/card-set-pack/card-set/{card_set_id}/card-set-pack-type/{card_set_pack_type}",
      path: {
        card_set_id: data.cardSetId,
        card_set_pack_type: data.cardSetPackType
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.cardSetPackId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamCardSetPackByCardSetPackId(
    data: OptionsV1CardJamCardSetPackByCardSetPackIdData
  ): CancelablePromise<OptionsV1CardJamCardSetPackByCardSetPackIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/card-set-pack/{card_set_pack_id}",
      path: {
        card_set_pack_id: data.cardSetPackId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.cardSetPackId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamCardSetPackByCardSetPackIdHardDelete(
    data: OptionsV1CardJamCardSetPackByCardSetPackIdHardDeleteData
  ): CancelablePromise<OptionsV1CardJamCardSetPackByCardSetPackIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/card-set-pack/{card_set_pack_id}/hard-delete",
      path: {
        card_set_pack_id: data.cardSetPackId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.cardSetId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamCardSetByCardSetId(
    data: OptionsV1CardJamCardSetByCardSetIdData
  ): CancelablePromise<OptionsV1CardJamCardSetByCardSetIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/card-set/{card_set_id}",
      path: {
        card_set_id: data.cardSetId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.cardSetId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamCardSetByCardSetIdHardDelete(
    data: OptionsV1CardJamCardSetByCardSetIdHardDeleteData
  ): CancelablePromise<OptionsV1CardJamCardSetByCardSetIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/card-set/{card_set_id}/hard-delete",
      path: {
        card_set_id: data.cardSetId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.cardSetId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamCardSetByCardSetIdValidate(
    data: OptionsV1CardJamCardSetByCardSetIdValidateData
  ): CancelablePromise<OptionsV1CardJamCardSetByCardSetIdValidateResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/card-set/{card_set_id}/validate",
      path: {
        card_set_id: data.cardSetId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamCardVariantAttribute(): CancelablePromise<OptionsV1CardJamCardVariantAttributeResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/card-variant-attribute",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamCardVariantAttributeRaw(): CancelablePromise<OptionsV1CardJamCardVariantAttributeRawResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/card-variant-attribute-raw",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.cardVariantAttribute
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamCardVariantAttributeByCardVariantAttribute(
    data: OptionsV1CardJamCardVariantAttributeByCardVariantAttributeData
  ): CancelablePromise<OptionsV1CardJamCardVariantAttributeByCardVariantAttributeResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/card-variant-attribute/{card_variant_attribute}",
      path: {
        card_variant_attribute: data.cardVariantAttribute
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.cardVariantAttribute
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamCardVariantAttributeByCardVariantAttributeHardDelete(
    data: OptionsV1CardJamCardVariantAttributeByCardVariantAttributeHardDeleteData
  ): CancelablePromise<OptionsV1CardJamCardVariantAttributeByCardVariantAttributeHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/card-variant-attribute/{card_variant_attribute}/hard-delete",
      path: {
        card_variant_attribute: data.cardVariantAttribute
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamLocalAdminCardDownloads(): CancelablePromise<OptionsV1CardJamLocalAdminCardDownloadsResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/local-admin/card-downloads",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamLocalAdminCardUpload(): CancelablePromise<OptionsV1CardJamLocalAdminCardUploadResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/local-admin/card-upload",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamMarketingCampaign(): CancelablePromise<OptionsV1CardJamMarketingCampaignResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/marketing-campaign",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.marketingCampaignId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamMarketingCampaignByMarketingCampaignId(
    data: OptionsV1CardJamMarketingCampaignByMarketingCampaignIdData
  ): CancelablePromise<OptionsV1CardJamMarketingCampaignByMarketingCampaignIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/marketing-campaign/{marketing_campaign_id}",
      path: {
        marketing_campaign_id: data.marketingCampaignId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.marketingCampaignId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamMarketingCampaignByMarketingCampaignIdActivate(
    data: OptionsV1CardJamMarketingCampaignByMarketingCampaignIdActivateData
  ): CancelablePromise<OptionsV1CardJamMarketingCampaignByMarketingCampaignIdActivateResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/marketing-campaign/{marketing_campaign_id}/activate",
      path: {
        marketing_campaign_id: data.marketingCampaignId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.marketingCampaignId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamMarketingCampaignByMarketingCampaignIdCardPack(
    data: OptionsV1CardJamMarketingCampaignByMarketingCampaignIdCardPackData
  ): CancelablePromise<OptionsV1CardJamMarketingCampaignByMarketingCampaignIdCardPackResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/marketing-campaign/{marketing_campaign_id}/card-pack",
      path: {
        marketing_campaign_id: data.marketingCampaignId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.marketingCampaignId
   * @param data.marketingCampaignCardPackId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamMarketingCampaignByMarketingCampaignIdCardPackByMarketingCampaignCardPackId(
    data: OptionsV1CardJamMarketingCampaignByMarketingCampaignIdCardPackByMarketingCampaignCardPackIdData
  ): CancelablePromise<OptionsV1CardJamMarketingCampaignByMarketingCampaignIdCardPackByMarketingCampaignCardPackIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/marketing-campaign/{marketing_campaign_id}/card-pack/{marketing_campaign_card_pack_id}",
      path: {
        marketing_campaign_id: data.marketingCampaignId,
        marketing_campaign_card_pack_id: data.marketingCampaignCardPackId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.marketingCampaignId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamMarketingCampaignByMarketingCampaignIdDeactivate(
    data: OptionsV1CardJamMarketingCampaignByMarketingCampaignIdDeactivateData
  ): CancelablePromise<OptionsV1CardJamMarketingCampaignByMarketingCampaignIdDeactivateResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/marketing-campaign/{marketing_campaign_id}/deactivate",
      path: {
        marketing_campaign_id: data.marketingCampaignId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.marketingCampaignId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamMarketingCampaignByMarketingCampaignIdHardDelete(
    data: OptionsV1CardJamMarketingCampaignByMarketingCampaignIdHardDeleteData
  ): CancelablePromise<OptionsV1CardJamMarketingCampaignByMarketingCampaignIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/marketing-campaign/{marketing_campaign_id}/hard-delete",
      path: {
        marketing_campaign_id: data.marketingCampaignId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCard(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCardAttribute(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card-attribute",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCardAttributeDecrease(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeDecreaseData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeDecreaseResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card-attribute/decrease",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCardAttributeIncrease(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeIncreaseData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeIncreaseResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card-attribute/increase",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardAttributeId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeId(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeIdData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card-attribute/{card_attribute_id}",
      path: {
        workspace_id: data.workspaceId,
        card_attribute_id: data.cardAttributeId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardAttributeId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeIdHardDelete(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeIdHardDeleteData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardAttributeByCardAttributeIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card-attribute/{card_attribute_id}/hard-delete",
      path: {
        workspace_id: data.workspaceId,
        card_attribute_id: data.cardAttributeId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCardDesign(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card-design",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCardDesignDecrease(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignDecreaseData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignDecreaseResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card-design/decrease",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCardDesignIncrease(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignIncreaseData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignIncreaseResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card-design/increase",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardDesignId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignId(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignIdData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card-design/{card_design_id}",
      path: {
        workspace_id: data.workspaceId,
        card_design_id: data.cardDesignId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardDesignId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignIdHardDelete(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignIdHardDeleteData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardDesignByCardDesignIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card-design/{card_design_id}/hard-delete",
      path: {
        workspace_id: data.workspaceId,
        card_design_id: data.cardDesignId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCardFull(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardFullData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardFullResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card-full",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCardInternal(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardInternalData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardInternalResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card-internal",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCardSet(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardSetData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardSetResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card-set",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardSetId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCardSetByCardSetId(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardSetByCardSetIdData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardSetByCardSetIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card-set/{card_set_id}",
      path: {
        workspace_id: data.workspaceId,
        card_set_id: data.cardSetId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCardByCardId(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card/{card_id}",
      path: {
        workspace_id: data.workspaceId,
        card_id: data.cardId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdFinalize(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdFinalizeData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdFinalizeResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card/{card_id}/finalize",
      path: {
        workspace_id: data.workspaceId,
        card_id: data.cardId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdUpdate(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdUpdateData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdUpdateResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card/{card_id}/update",
      path: {
        workspace_id: data.workspaceId,
        card_id: data.cardId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cardId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdVariant(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdVariantData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdCardByCardIdVariantResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/card/{card_id}/variant",
      path: {
        workspace_id: data.workspaceId,
        card_id: data.cardId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdMarketingCampaignClaim(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdMarketingCampaignClaimData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdMarketingCampaignClaimResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/marketing-campaign-claim",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPack(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/unopened-card-pack",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackDecrease(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackDecreaseData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackDecreaseResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/unopened-card-pack/decrease",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackIncrease(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackIncreaseData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackIncreaseResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/unopened-card-pack/increase",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.unopenedCardPackId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackId(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/unopened-card-pack/{unopened_card_pack_id}",
      path: {
        workspace_id: data.workspaceId,
        unopened_card_pack_id: data.unopenedCardPackId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.unopenedCardPackId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdHardDelete(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdHardDeleteData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/unopened-card-pack/{unopened_card_pack_id}/hard-delete",
      path: {
        workspace_id: data.workspaceId,
        unopened_card_pack_id: data.unopenedCardPackId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.unopenedCardPackId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdOpen(
    data: OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdOpenData
  ): CancelablePromise<OptionsV1CardJamWorkspaceByWorkspaceIdUnopenedCardPackByUnopenedCardPackIdOpenResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-jam/workspace/{workspace_id}/unopened-card-pack/{unopened_card_pack_id}/open",
      path: {
        workspace_id: data.workspaceId,
        unopened_card_pack_id: data.unopenedCardPackId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementAbandonedCartReminder(): CancelablePromise<OptionsV1OrderManagementAbandonedCartReminderResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/abandoned-cart-reminder",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementAccountOpsMarketingStatusUpdate(): CancelablePromise<OptionsV1OrderManagementAccountOpsMarketingStatusUpdateResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/account-ops/marketing-status-update",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementDiscountCoupon(): CancelablePromise<OptionsV1OrderManagementDiscountCouponResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/discount-coupon",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.discountCouponId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementDiscountCouponByDiscountCouponId(
    data: OptionsV1OrderManagementDiscountCouponByDiscountCouponIdData
  ): CancelablePromise<OptionsV1OrderManagementDiscountCouponByDiscountCouponIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/discount-coupon/{discount_coupon_id}",
      path: {
        discount_coupon_id: data.discountCouponId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.discountCouponId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementDiscountCouponByDiscountCouponIdHardDelete(
    data: OptionsV1OrderManagementDiscountCouponByDiscountCouponIdHardDeleteData
  ): CancelablePromise<OptionsV1OrderManagementDiscountCouponByDiscountCouponIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/discount-coupon/{discount_coupon_id}/hard-delete",
      path: {
        discount_coupon_id: data.discountCouponId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementFreeCardCoupon(): CancelablePromise<OptionsV1OrderManagementFreeCardCouponResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/free-card-coupon",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.freeCardCouponId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementFreeCardCouponByFreeCardCouponId(
    data: OptionsV1OrderManagementFreeCardCouponByFreeCardCouponIdData
  ): CancelablePromise<OptionsV1OrderManagementFreeCardCouponByFreeCardCouponIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/free-card-coupon/{free_card_coupon_id}",
      path: {
        free_card_coupon_id: data.freeCardCouponId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.freeCardCouponId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementFreeCardCouponByFreeCardCouponIdHardDelete(
    data: OptionsV1OrderManagementFreeCardCouponByFreeCardCouponIdHardDeleteData
  ): CancelablePromise<OptionsV1OrderManagementFreeCardCouponByFreeCardCouponIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/free-card-coupon/{free_card_coupon_id}/hard-delete",
      path: {
        free_card_coupon_id: data.freeCardCouponId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementOrder(): CancelablePromise<OptionsV1OrderManagementOrderResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/order",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementOrderPrintingStartedBulk(): CancelablePromise<OptionsV1OrderManagementOrderPrintingStartedBulkResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/order/printing-started-bulk",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementOrderShippedBulk(): CancelablePromise<OptionsV1OrderManagementOrderShippedBulkResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/order/shipped-bulk",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementOrderByOrderId(
    data: OptionsV1OrderManagementOrderByOrderIdData
  ): CancelablePromise<OptionsV1OrderManagementOrderByOrderIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/order/{order_id}",
      path: {
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementOrderByOrderIdPrintingStarted(
    data: OptionsV1OrderManagementOrderByOrderIdPrintingStartedData
  ): CancelablePromise<OptionsV1OrderManagementOrderByOrderIdPrintingStartedResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/order/{order_id}/printing-started",
      path: {
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementOrderByOrderIdShipped(
    data: OptionsV1OrderManagementOrderByOrderIdShippedData
  ): CancelablePromise<OptionsV1OrderManagementOrderByOrderIdShippedResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/order/{order_id}/shipped",
      path: {
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementProductPrice(): CancelablePromise<OptionsV1OrderManagementProductPriceResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/product-price",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.productType
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementProductPriceProductTypeByProductType(
    data: OptionsV1OrderManagementProductPriceProductTypeByProductTypeData
  ): CancelablePromise<OptionsV1OrderManagementProductPriceProductTypeByProductTypeResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/product-price-product-type/{product_type}",
      path: {
        product_type: data.productType
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.productPriceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementProductPriceByProductPriceId(
    data: OptionsV1OrderManagementProductPriceByProductPriceIdData
  ): CancelablePromise<OptionsV1OrderManagementProductPriceByProductPriceIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/product-price/{product_price_id}",
      path: {
        product_price_id: data.productPriceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.productPriceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementProductPriceByProductPriceIdHardDelete(
    data: OptionsV1OrderManagementProductPriceByProductPriceIdHardDeleteData
  ): CancelablePromise<OptionsV1OrderManagementProductPriceByProductPriceIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/product-price/{product_price_id}/hard-delete",
      path: {
        product_price_id: data.productPriceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementServiceAccountOpsAccountMerge(): CancelablePromise<OptionsV1OrderManagementServiceAccountOpsAccountMergeResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/service/account-ops/account-merge",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementServiceAccountOpsDataRetentionClear(): CancelablePromise<OptionsV1OrderManagementServiceAccountOpsDataRetentionClearResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/service/account-ops/data-retention-clear",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementServiceOrder(): CancelablePromise<OptionsV1OrderManagementServiceOrderResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/service/order",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementServiceWorkspaceOrderStatistics(): CancelablePromise<OptionsV1OrderManagementServiceWorkspaceOrderStatisticsResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/service/workspace-order-statistics",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementServiceWorkspaceByWorkspaceIdCheckoutByOrderIdTimeout(
    data: OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdCheckoutByOrderIdTimeoutData
  ): CancelablePromise<OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdCheckoutByOrderIdTimeoutResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/service/workspace/{workspace_id}/checkout/{order_id}/timeout",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmation(
    data: OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmationData
  ): CancelablePromise<OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmationResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/service/workspace/{workspace_id}/order/{order_id}/email/confirmation",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmation(
    data: OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmationData
  ): CancelablePromise<OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmationResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/service/workspace/{workspace_id}/order/{order_id}/email/update-confirmation",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcess(
    data: OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcessData
  ): CancelablePromise<OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcessResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/service/workspace/{workspace_id}/order/{order_id}/email/update-in-process",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShipped(
    data: OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShippedData
  ): CancelablePromise<OptionsV1OrderManagementServiceWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShippedResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/service/workspace/{workspace_id}/order/{order_id}/email/update-shipped",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementStripeRetry(): CancelablePromise<OptionsV1OrderManagementStripeRetryResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/stripe/retry",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementStripeWebhook(): CancelablePromise<OptionsV1OrderManagementStripeWebhookResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/stripe/webhook",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdCart(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdCartData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdCartResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/cart",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItem(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/cart/cart-item",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemCard(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemCardData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemCardResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/cart/cart-item/card",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamCard(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamCardData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamCardResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/cart/cart-item/team-card",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamPack(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamPackData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemTeamPackResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/cart/cart-item/team-pack",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cartItemId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemId(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/cart/cart-item/{cart_item_id}",
      path: {
        workspace_id: data.workspaceId,
        cart_item_id: data.cartItemId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.cartItemId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdHardDelete(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdHardDeleteData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdCartCartItemByCartItemIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/cart/cart-item/{cart_item_id}/hard-delete",
      path: {
        workspace_id: data.workspaceId,
        cart_item_id: data.cartItemId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutStart(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutStartData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutStartResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/checkout/start",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderId(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/checkout/{order_id}",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCancel(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCancelData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCancelResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/checkout/{order_id}/cancel",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCheckoutComplete(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCheckoutCompleteData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdCheckoutByOrderIdCheckoutCompleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/checkout/{order_id}/checkout-complete",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCount(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/free-card-count",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountDecrease(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountDecreaseData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountDecreaseResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/free-card-count/decrease",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountHardDelete(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountHardDeleteData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/free-card-count/hard-delete",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountIncrease(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountIncreaseData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCountIncreaseResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/free-card-count/increase",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCouponClaim(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCouponClaimData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdFreeCardCouponClaimResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/free-card-coupon-claim",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdOrder(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/order",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderId(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/order/{order_id}",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmation(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmationData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailConfirmationResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/order/{order_id}/email/confirmation",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmation(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmationData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateConfirmationResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/order/{order_id}/email/update-confirmation",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcess(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcessData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateInProcessResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/order/{order_id}/email/update-in-process",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShipped(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShippedData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdEmailUpdateShippedResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/order/{order_id}/email/update-shipped",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdHardDelete(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdHardDeleteData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/order/{order_id}/hard-delete",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdRewardClaim(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdRewardClaimData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdRewardClaimResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/order/{order_id}/reward-claim",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @param data.orderId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdUpdateCards(
    data: OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdUpdateCardsData
  ): CancelablePromise<OptionsV1OrderManagementWorkspaceByWorkspaceIdOrderByOrderIdUpdateCardsResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/order-management/workspace/{workspace_id}/order/{order_id}/update-cards",
      path: {
        workspace_id: data.workspaceId,
        order_id: data.orderId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardPrintingLocalPrintCardRequest(): CancelablePromise<OptionsV1CardPrintingLocalPrintCardRequestResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-printing/local-print-card-request",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardPrintingLocalPrintCardRequestComplete(): CancelablePromise<OptionsV1CardPrintingLocalPrintCardRequestCompleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-printing/local-print-card-request-complete",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardPrintingOrderPrintCardRequest(): CancelablePromise<OptionsV1CardPrintingOrderPrintCardRequestResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-printing/order-print-card-request",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardPrintingOrderPrintCardRequestUpdate(): CancelablePromise<OptionsV1CardPrintingOrderPrintCardRequestUpdateResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-printing/order-print-card-request-update",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardPrintingPrintCardRequest(): CancelablePromise<OptionsV1CardPrintingPrintCardRequestResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-printing/print-card-request",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.printCardRequestId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardPrintingPrintCardRequestByPrintCardRequestId(
    data: OptionsV1CardPrintingPrintCardRequestByPrintCardRequestIdData
  ): CancelablePromise<OptionsV1CardPrintingPrintCardRequestByPrintCardRequestIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-printing/print-card-request/{print_card_request_id}",
      path: {
        print_card_request_id: data.printCardRequestId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1CardPrintingServiceAccountOpsAccountMerge(): CancelablePromise<OptionsV1CardPrintingServiceAccountOpsAccountMergeResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/card-printing/service/account-ops/account-merge",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1AccountOpsDataRetentionRunStart(): CancelablePromise<OptionsV1AccountOpsDataRetentionRunStartResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/account-ops/data-retention-run/start",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.dataRetentionRunId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1AccountOpsDataRetentionRunByDataRetentionRunIdClear(
    data: OptionsV1AccountOpsDataRetentionRunByDataRetentionRunIdClearData
  ): CancelablePromise<OptionsV1AccountOpsDataRetentionRunByDataRetentionRunIdClearResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/account-ops/data-retention-run/{data_retention_run_id}/clear",
      path: {
        data_retention_run_id: data.dataRetentionRunId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.dataRetentionRunId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1AccountOpsDataRetentionRunByDataRetentionRunIdComplete(
    data: OptionsV1AccountOpsDataRetentionRunByDataRetentionRunIdCompleteData
  ): CancelablePromise<OptionsV1AccountOpsDataRetentionRunByDataRetentionRunIdCompleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/account-ops/data-retention-run/{data_retention_run_id}/complete",
      path: {
        data_retention_run_id: data.dataRetentionRunId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1AccountOpsGuestLogin(): CancelablePromise<OptionsV1AccountOpsGuestLoginResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/account-ops/guest/login",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1AccountOpsGuestMfaLoginComplete(): CancelablePromise<OptionsV1AccountOpsGuestMfaLoginCompleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/account-ops/guest/mfa-login/complete",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1AccountOpsGuestMfaLoginSendCode(): CancelablePromise<OptionsV1AccountOpsGuestMfaLoginSendCodeResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/account-ops/guest/mfa-login/send-code",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1AccountOpsGuestMfaLoginStart(): CancelablePromise<OptionsV1AccountOpsGuestMfaLoginStartResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/account-ops/guest/mfa-login/start",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.codeId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1AccountOpsGuestMfaLoginByCodeIdResend(
    data: OptionsV1AccountOpsGuestMfaLoginByCodeIdResendData
  ): CancelablePromise<OptionsV1AccountOpsGuestMfaLoginByCodeIdResendResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/account-ops/guest/mfa-login/{code_id}/resend",
      path: {
        code_id: data.codeId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1AccountOpsGuestWorkspaceByWorkspaceIdLogin(
    data: OptionsV1AccountOpsGuestWorkspaceByWorkspaceIdLoginData
  ): CancelablePromise<OptionsV1AccountOpsGuestWorkspaceByWorkspaceIdLoginResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/account-ops/guest/workspace/{workspace_id}/login",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.workspaceId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1AccountOpsGuestWorkspaceByWorkspaceIdMfaLoginComplete(
    data: OptionsV1AccountOpsGuestWorkspaceByWorkspaceIdMfaLoginCompleteData
  ): CancelablePromise<OptionsV1AccountOpsGuestWorkspaceByWorkspaceIdMfaLoginCompleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/account-ops/guest/workspace/{workspace_id}/mfa-login/complete",
      path: {
        workspace_id: data.workspaceId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1AccountOpsMarketingSyncRunStart(): CancelablePromise<OptionsV1AccountOpsMarketingSyncRunStartResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/account-ops/marketing-sync-run/start",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.marketingSyncRunId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1AccountOpsMarketingSyncRunByMarketingSyncRunIdComplete(
    data: OptionsV1AccountOpsMarketingSyncRunByMarketingSyncRunIdCompleteData
  ): CancelablePromise<OptionsV1AccountOpsMarketingSyncRunByMarketingSyncRunIdCompleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/account-ops/marketing-sync-run/{marketing_sync_run_id}/complete",
      path: {
        marketing_sync_run_id: data.marketingSyncRunId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.marketingSyncRunId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1AccountOpsMarketingSyncRunByMarketingSyncRunIdProcess(
    data: OptionsV1AccountOpsMarketingSyncRunByMarketingSyncRunIdProcessData
  ): CancelablePromise<OptionsV1AccountOpsMarketingSyncRunByMarketingSyncRunIdProcessResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/account-ops/marketing-sync-run/{marketing_sync_run_id}/process",
      path: {
        marketing_sync_run_id: data.marketingSyncRunId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1AccountOpsOrderMarketingSyncRunStart(): CancelablePromise<OptionsV1AccountOpsOrderMarketingSyncRunStartResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/account-ops/order-marketing-sync-run/start",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.orderMarketingSyncRunId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdComplete(
    data: OptionsV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdCompleteData
  ): CancelablePromise<OptionsV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdCompleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/account-ops/order-marketing-sync-run/{order_marketing_sync_run_id}/complete",
      path: {
        order_marketing_sync_run_id: data.orderMarketingSyncRunId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.orderMarketingSyncRunId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdProcess(
    data: OptionsV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdProcessData
  ): CancelablePromise<OptionsV1AccountOpsOrderMarketingSyncRunByOrderMarketingSyncRunIdProcessResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/account-ops/order-marketing-sync-run/{order_marketing_sync_run_id}/process",
      path: {
        order_marketing_sync_run_id: data.orderMarketingSyncRunId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1SearchInternalTeam(): CancelablePromise<OptionsV1SearchInternalTeamResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/search/internal/team",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1SearchTeam(): CancelablePromise<OptionsV1SearchTeamResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/search/team",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementInviteAccept(): CancelablePromise<OptionsV1TeamManagementInviteAcceptResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/invite/accept",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.inviteId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementInviteByInviteId(
    data: OptionsV1TeamManagementInviteByInviteIdData
  ): CancelablePromise<OptionsV1TeamManagementInviteByInviteIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/invite/{invite_id}",
      path: {
        invite_id: data.inviteId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementMemberByUserId(
    data: OptionsV1TeamManagementMemberByUserIdData
  ): CancelablePromise<OptionsV1TeamManagementMemberByUserIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/member/{user_id}",
      path: {
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementServiceTeamCards(): CancelablePromise<OptionsV1TeamManagementServiceTeamCardsResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/service/team-cards",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamAccessRequestId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequested(
    data: OptionsV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequestedData
  ): CancelablePromise<OptionsV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequestedResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/service/team/{team_id}/team-access-request/{team_access_request_id}/email/access-requested",
      path: {
        team_id: data.teamId,
        team_access_request_id: data.teamAccessRequestId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamAccessRequestId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailApproved(
    data: OptionsV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailApprovedData
  ): CancelablePromise<OptionsV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailApprovedResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/service/team/{team_id}/team-access-request/{team_access_request_id}/email/approved",
      path: {
        team_id: data.teamId,
        team_access_request_id: data.teamAccessRequestId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamAccessRequestId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailDenied(
    data: OptionsV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailDeniedData
  ): CancelablePromise<OptionsV1TeamManagementServiceTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailDeniedResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/service/team/{team_id}/team-access-request/{team_access_request_id}/email/denied",
      path: {
        team_id: data.teamId,
        team_access_request_id: data.teamAccessRequestId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeam(): CancelablePromise<OptionsV1TeamManagementTeamResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamLinkTeamAccessRequest(): CancelablePromise<OptionsV1TeamManagementTeamLinkTeamAccessRequestResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team-link/team-access-request",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamMemberId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamMemberByTeamMemberId(
    data: OptionsV1TeamManagementTeamMemberByTeamMemberIdData
  ): CancelablePromise<OptionsV1TeamManagementTeamMemberByTeamMemberIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team-member/{team_member_id}",
      path: {
        team_member_id: data.teamMemberId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamProfiles(): CancelablePromise<OptionsV1TeamManagementTeamProfilesResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/profiles",
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamId(
    data: OptionsV1TeamManagementTeamByTeamIdData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}",
      path: {
        team_id: data.teamId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdHardDelete(
    data: OptionsV1TeamManagementTeamByTeamIdHardDeleteData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/hard-delete",
      path: {
        team_id: data.teamId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdInvite(
    data: OptionsV1TeamManagementTeamByTeamIdInviteData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdInviteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/invite",
      path: {
        team_id: data.teamId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.inviteId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdInviteByInviteId(
    data: OptionsV1TeamManagementTeamByTeamIdInviteByInviteIdData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdInviteByInviteIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/invite/{invite_id}",
      path: {
        team_id: data.teamId,
        invite_id: data.inviteId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.inviteId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdInviteByInviteIdHardDelete(
    data: OptionsV1TeamManagementTeamByTeamIdInviteByInviteIdHardDeleteData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdInviteByInviteIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/invite/{invite_id}/hard-delete",
      path: {
        team_id: data.teamId,
        invite_id: data.inviteId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.inviteId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdInviteByInviteIdResend(
    data: OptionsV1TeamManagementTeamByTeamIdInviteByInviteIdResendData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdInviteByInviteIdResendResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/invite/{invite_id}/resend",
      path: {
        team_id: data.teamId,
        invite_id: data.inviteId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdMember(
    data: OptionsV1TeamManagementTeamByTeamIdMemberData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdMemberResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/member",
      path: {
        team_id: data.teamId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdMemberByUserId(
    data: OptionsV1TeamManagementTeamByTeamIdMemberByUserIdData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdMemberByUserIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/member/{user_id}",
      path: {
        team_id: data.teamId,
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdMemberByUserIdRole(
    data: OptionsV1TeamManagementTeamByTeamIdMemberByUserIdRoleData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdMemberByUserIdRoleResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/member/{user_id}/role",
      path: {
        team_id: data.teamId,
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdOwner(
    data: OptionsV1TeamManagementTeamByTeamIdOwnerData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdOwnerResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/owner",
      path: {
        team_id: data.teamId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdTeamAccessRequest(
    data: OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/team-access-request",
      path: {
        team_id: data.teamId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamAccessRequestId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestId(
    data: OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/team-access-request/{team_access_request_id}",
      path: {
        team_id: data.teamId,
        team_access_request_id: data.teamAccessRequestId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamAccessRequestId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdApprove(
    data: OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdApproveData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdApproveResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/team-access-request/{team_access_request_id}/approve",
      path: {
        team_id: data.teamId,
        team_access_request_id: data.teamAccessRequestId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamAccessRequestId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdDeny(
    data: OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdDenyData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdDenyResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/team-access-request/{team_access_request_id}/deny",
      path: {
        team_id: data.teamId,
        team_access_request_id: data.teamAccessRequestId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamAccessRequestId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequested(
    data: OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequestedData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdEmailAccessRequestedResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/team-access-request/{team_access_request_id}/email/access-requested",
      path: {
        team_id: data.teamId,
        team_access_request_id: data.teamAccessRequestId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamAccessRequestId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdHardDelete(
    data: OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdHardDeleteData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdTeamAccessRequestByTeamAccessRequestIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/team-access-request/{team_access_request_id}/hard-delete",
      path: {
        team_id: data.teamId,
        team_access_request_id: data.teamAccessRequestId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdTeamCard(
    data: OptionsV1TeamManagementTeamByTeamIdTeamCardData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdTeamCardResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/team-card",
      path: {
        team_id: data.teamId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamCardId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdTeamCardByTeamCardId(
    data: OptionsV1TeamManagementTeamByTeamIdTeamCardByTeamCardIdData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdTeamCardByTeamCardIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/team-card/{team_card_id}",
      path: {
        team_id: data.teamId,
        team_card_id: data.teamCardId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamCardId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdTeamCardByTeamCardIdHardDelete(
    data: OptionsV1TeamManagementTeamByTeamIdTeamCardByTeamCardIdHardDeleteData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdTeamCardByTeamCardIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/team-card/{team_card_id}/hard-delete",
      path: {
        team_id: data.teamId,
        team_card_id: data.teamCardId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdTeamLink(
    data: OptionsV1TeamManagementTeamByTeamIdTeamLinkData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdTeamLinkResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/team-link",
      path: {
        team_id: data.teamId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdTeamLinkUserByUserId(
    data: OptionsV1TeamManagementTeamByTeamIdTeamLinkUserByUserIdData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdTeamLinkUserByUserIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/team-link/user/{user_id}",
      path: {
        team_id: data.teamId,
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamLinkId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkId(
    data: OptionsV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/team-link/{team_link_id}",
      path: {
        team_id: data.teamId,
        team_link_id: data.teamLinkId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.teamId
   * @param data.teamLinkId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdHardDelete(
    data: OptionsV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdHardDeleteData
  ): CancelablePromise<OptionsV1TeamManagementTeamByTeamIdTeamLinkByTeamLinkIdHardDeleteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/team/{team_id}/team-link/{team_link_id}/hard-delete",
      path: {
        team_id: data.teamId,
        team_link_id: data.teamLinkId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns string Default response for CORS method
   * @throws ApiError
   */
  public static optionsV1TeamManagementUserByUserIdInvite(
    data: OptionsV1TeamManagementUserByUserIdInviteData
  ): CancelablePromise<OptionsV1TeamManagementUserByUserIdInviteResponse> {
    return __request(OpenAPI, {
      method: "OPTIONS",
      url: "/v1/team-management/user/{user_id}/invite",
      path: {
        user_id: data.userId
      },
      responseHeader: "Access-Control-Allow-Headers"
    });
  }
}
